//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class SituViewWebApiClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    getAccessoryBundle(request) {
        let url_ = this.baseUrl + "/api/queries/GetAccessoryBundle";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAccessoryBundle(_response);
        });
    }
    processGetAccessoryBundle(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAccessoryBundleResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAccessoryBundleByBuildingInstructions(request) {
        let url_ = this.baseUrl + "/api/queries/GetAccessoryBundleByBuildingInstructions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAccessoryBundleByBuildingInstructions(_response);
        });
    }
    processGetAccessoryBundleByBuildingInstructions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAccessoryBundleByBuildingInstructionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listAccessoryBundles(request) {
        let url_ = this.baseUrl + "/api/queries/ListAccessoryBundles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListAccessoryBundles(_response);
        });
    }
    processListAccessoryBundles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListAccessoryBundlesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createAccessoryBundle(request) {
        let url_ = this.baseUrl + "/api/commands/CreateAccessoryBundle";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateAccessoryBundle(_response);
        });
    }
    processCreateAccessoryBundle(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateAccessoryBundleResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateAccessoryBundle(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateAccessoryBundle";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateAccessoryBundle(_response);
        });
    }
    processUpdateAccessoryBundle(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateAccessoryBundleResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteAccessoryBundle(request) {
        let url_ = this.baseUrl + "/api/commands/DeleteAccessoryBundle";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteAccessoryBundle(_response);
        });
    }
    processDeleteAccessoryBundle(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteAccessoryBundleResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBrand(request) {
        let url_ = this.baseUrl + "/api/queries/GetBrand";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetBrand(_response);
        });
    }
    processGetBrand(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetBrandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listBrands(request) {
        let url_ = this.baseUrl + "/api/queries/ListBrands";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListBrands(_response);
        });
    }
    processListBrands(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListBrandsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createBrand(request) {
        let url_ = this.baseUrl + "/api/commands/CreateBrand";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateBrand(_response);
        });
    }
    processCreateBrand(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateBrandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateBrand(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateBrand";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateBrand(_response);
        });
    }
    processUpdateBrand(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateBrandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteBrand(request) {
        let url_ = this.baseUrl + "/api/commands/DeleteBrand";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteBrand(_response);
        });
    }
    processDeleteBrand(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteBrandResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    finaliseImportedProducts(request) {
        let url_ = this.baseUrl + "/api/commands/FinaliseImportedProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFinaliseImportedProducts(_response);
        });
    }
    processFinaliseImportedProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FinaliseImportedProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    purgeImportedProducts(request) {
        let url_ = this.baseUrl + "/api/commands/PurgeImportedProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPurgeImportedProducts(_response);
        });
    }
    processPurgeImportedProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurgeImportedProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    assignHomeTag(request) {
        let url_ = this.baseUrl + "/api/commands/Home/AssignHomeTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAssignHomeTag(_response);
        });
    }
    processAssignHomeTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssignHomeTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    removeHomeTag(request) {
        let url_ = this.baseUrl + "/api/commands/Home/RemoveHomeTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRemoveHomeTag(_response);
        });
    }
    processRemoveHomeTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemoveHomeTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    uploadManufacturerLogo(request) {
        let url_ = this.baseUrl + "/api/commands/Manufacturers/UploadManufacturerLogo";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUploadManufacturerLogo(_response);
        });
    }
    processUploadManufacturerLogo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadManufacturerLogoResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getManufacturer(request) {
        let url_ = this.baseUrl + "/api/queries/Manufacturers/GetManufacturer";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetManufacturer(_response);
        });
    }
    processGetManufacturer(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetManufacturerResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listManufacturers(request) {
        let url_ = this.baseUrl + "/api/queries/Manufacturers/ListManufacturers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListManufacturers(_response);
        });
    }
    processListManufacturers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListManufacturersResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addProduct(request) {
        let url_ = this.baseUrl + "/api/commands/Products/AddProduct";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddProduct(_response);
        });
    }
    processAddProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProduct(request) {
        let url_ = this.baseUrl + "/api/commands/Products/UpdateProduct";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProduct(_response);
        });
    }
    processUpdateProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProduct(request) {
        let url_ = this.baseUrl + "/api/queries/Products/GetProduct";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProduct(_response);
        });
    }
    processGetProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductByManufacturerAndSkuCode(request) {
        let url_ = this.baseUrl + "/api/queries/Products/GetProductByManufacturerAndSkuCode";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductByManufacturerAndSkuCode(_response);
        });
    }
    processGetProductByManufacturerAndSkuCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listProducts(request) {
        let url_ = this.baseUrl + "/api/queries/Products/ListProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListProducts(_response);
        });
    }
    processListProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createRange(request) {
        let url_ = this.baseUrl + "/api/commands/CreateRange";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateRange(_response);
        });
    }
    processCreateRange(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateRangeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateRange(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateRange";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateRange(_response);
        });
    }
    processUpdateRange(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateRangeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteRange(request) {
        let url_ = this.baseUrl + "/api/commands/DeleteRange";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteRange(_response);
        });
    }
    processDeleteRange(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteRangeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRange(request) {
        let url_ = this.baseUrl + "/api/queries/GetRange";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRange(_response);
        });
    }
    processGetRange(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRangeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRanges(request) {
        let url_ = this.baseUrl + "/api/queries/ListRanges";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRanges(_response);
        });
    }
    processListRanges(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListRangesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProductRange(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateProductRange";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProductRange(_response);
        });
    }
    processUpdateProductRange(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductRangeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProductRangeAuthorisedCompany(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateProductRangeAuthorisedCompany";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProductRangeAuthorisedCompany(_response);
        });
    }
    processUpdateProductRangeAuthorisedCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductRangeAuthorisedCompanyResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addRelease(request) {
        let url_ = this.baseUrl + "/api/commands/Release/AddRelease";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddRelease(_response);
        });
    }
    processAddRelease(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddReleaseResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateRelease(request) {
        let url_ = this.baseUrl + "/api/commands/Release/UpdateRelease";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateRelease(_response);
        });
    }
    processUpdateRelease(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateReleaseResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listReleases(request) {
        let url_ = this.baseUrl + "/api/queries/Release/ListReleases";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListReleases(_response);
        });
    }
    processListReleases(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListReleasesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRelease(request) {
        let url_ = this.baseUrl + "/api/queries/Release/GetRelease";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRelease(_response);
        });
    }
    processGetRelease(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetReleaseResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    importReleaseItemsFromCsv(file, companyId, releaseId) {
        let url_ = this.baseUrl + "/api/commands/Release/ImportReleaseItemsFromCsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("companyId", companyId.toString());
        if (releaseId === null || releaseId === undefined)
            throw new Error("The parameter 'releaseId' cannot be null.");
        else
            content_.append("releaseId", releaseId.toString());
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processImportReleaseItemsFromCsv(_response);
        });
    }
    processImportReleaseItemsFromCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImportReleaseItemsFromCsvResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addReleaseIssue(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseIssue/AddReleaseIssue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddReleaseIssue(_response);
        });
    }
    processAddReleaseIssue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddReleaseIssueResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateReleaseIssue(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseIssue/UpdateReleaseIssue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateReleaseIssue(_response);
        });
    }
    processUpdateReleaseIssue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateReleaseIssueResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listReleaseIssues(request) {
        let url_ = this.baseUrl + "/api/queries/ReleaseIssue/ListReleaseIssues";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListReleaseIssues(_response);
        });
    }
    processListReleaseIssues(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListReleaseIssuesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getReleaseIssue(request) {
        let url_ = this.baseUrl + "/api/queries/ReleaseIssue/GetReleaseIssue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetReleaseIssue(_response);
        });
    }
    processGetReleaseIssue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetReleaseIssueResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    assignReleaseIssueTag(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseIssue/AssignReleaseIssueTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAssignReleaseIssueTag(_response);
        });
    }
    processAssignReleaseIssueTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssignReleaseIssueTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    removeReleaseIssueTag(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseIssue/RemoveReleaseIssueTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRemoveReleaseIssueTag(_response);
        });
    }
    processRemoveReleaseIssueTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemoveReleaseIssueTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addReleaseItem(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseItem/AddReleaseItem";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddReleaseItem(_response);
        });
    }
    processAddReleaseItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddReleaseItemResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateReleaseItem(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseItem/UpdateReleaseItem";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateReleaseItem(_response);
        });
    }
    processUpdateReleaseItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateReleaseItemResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listReleaseItems(request) {
        let url_ = this.baseUrl + "/api/queries/ReleaseItem/ListReleaseItems";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListReleaseItems(_response);
        });
    }
    processListReleaseItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListReleaseItemsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    bulkUpdateReleaseItems(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseItem/BulkUpdateReleaseItems";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processBulkUpdateReleaseItems(_response);
        });
    }
    processBulkUpdateReleaseItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BulkUpdateReleaseItemsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setReleaseItemViewed(request) {
        let url_ = this.baseUrl + "/api/commands/ReleaseItem/SetReleaseItemViewed";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetReleaseItemViewed(_response);
        });
    }
    processSetReleaseItemViewed(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetReleaseItemViewedResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituFacade(request) {
        let url_ = this.baseUrl + "/api/commands/CreateSituFacade";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituFacade(_response);
        });
    }
    processCreateSituFacade(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituFacadeWithNames(request) {
        let url_ = this.baseUrl + "/api/commands/CreateSituFacadeWithNames";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituFacadeWithNames(_response);
        });
    }
    processCreateSituFacadeWithNames(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituFacadeChild(request) {
        let url_ = this.baseUrl + "/api/commands/CreateSituFacadeChild";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituFacadeChild(_response);
        });
    }
    processCreateSituFacadeChild(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituFacade(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituFacade";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituFacade(_response);
        });
    }
    processGetSituFacade(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituFacadeWithIds(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituFacadeWithIds";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituFacadeWithIds(_response);
        });
    }
    processGetSituFacadeWithIds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituFacadeWithNames(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituFacadeWithNames";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituFacadeWithNames(_response);
        });
    }
    processGetSituFacadeWithNames(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    downloadSituFacades(request) {
        let url_ = this.baseUrl + "/api/commands/DownloadSituFacades";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSituFacades(_response);
        });
    }
    processDownloadSituFacades(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    importStyleTemplatesFromCsv(file, companyId) {
        let url_ = this.baseUrl + "/api/commands/Style/ImportStyleTemplatesFromCsv";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("companyId", companyId.toString());
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processImportStyleTemplatesFromCsv(_response);
        });
    }
    processImportStyleTemplatesFromCsv(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImportStyleTemplatesFromCsvResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAcceptance(request) {
        let url_ = this.baseUrl + "/api/queries/GetAcceptance";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAcceptance(_response);
        });
    }
    processGetAcceptance(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAcceptanceResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifactProgress(request) {
        let url_ = this.baseUrl + "/api/queries/GetArtifactProgress";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifactProgress(_response);
        });
    }
    processGetArtifactProgress(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactProgressResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDefaultRenderedOutput(request) {
        let url_ = this.baseUrl + "/api/queries/GetDefaultRenderedOutput";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetDefaultRenderedOutput(_response);
        });
    }
    processGetDefaultRenderedOutput(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDefaultRenderedOutputResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeArtifact(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeArtifact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeArtifact(_response);
        });
    }
    processGetHomeArtifact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeConfig(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeConfig(_response);
        });
    }
    processGetHomeConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeConfigId(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeConfigId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeConfigId(_response);
        });
    }
    processGetHomeConfigId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeConfigIdResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeConfigSlimId(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeConfigSlimId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeConfigSlimId(_response);
        });
    }
    processGetHomeConfigSlimId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeConfigSlimIdResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHome(request) {
        let url_ = this.baseUrl + "/api/queries/GetHome";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHome(_response);
        });
    }
    processGetHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeDetail(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeDetail";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeDetail(_response);
        });
    }
    processGetHomeDetail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeDetailResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeFloorplan(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeFloorplan";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeFloorplan(_response);
        });
    }
    processGetHomeFloorplan(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeId(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeId(_response);
        });
    }
    processGetHomeId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeIdResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getIfcFile(request) {
        let url_ = this.baseUrl + "/api/queries/GetIfcFile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetIfcFile(_response);
        });
    }
    processGetIfcFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetIfcFileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getIfcFileUploadStatus(request) {
        let url_ = this.baseUrl + "/api/queries/GetIfcFileUploadStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetIfcFileUploadStatus(_response);
        });
    }
    processGetIfcFileUploadStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetIfcFileUploadStatusResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getMostPopularRenderedHomeByBuilder(request) {
        let url_ = this.baseUrl + "/api/queries/GetMostPopularRenderedHomeByBuilder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMostPopularRenderedHomeByBuilder(_response);
        });
    }
    processGetMostPopularRenderedHomeByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetMostPopularRenderedHomeByBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPlanJsonFile(request) {
        let url_ = this.baseUrl + "/api/commands/GetPlanJsonFile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetPlanJsonFile(_response);
        });
    }
    processGetPlanJsonFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPlanJsonFileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductCalloutBoard(request) {
        let url_ = this.baseUrl + "/api/queries/GetProductCalloutPanel";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductCalloutBoard(_response);
        });
    }
    processGetProductCalloutBoard(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductCalloutPanelResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductInfo(request) {
        let url_ = this.baseUrl + "/api/queries/GetProductInfo";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductInfo(_response);
        });
    }
    processGetProductInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductInfoResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductionArtifacts(request) {
        let url_ = this.baseUrl + "/api/queries/GetProductionArtifactsForBuilder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductionArtifacts(_response);
        });
    }
    processGetProductionArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductionArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituView(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituView";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituView(_response);
        });
    }
    processGetSituView(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituViewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituViewWithIds(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituViewWithIds";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituViewWithIds(_response);
        });
    }
    processGetSituViewWithIds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituViewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituViewWithNames(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituViewWithNames";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituViewWithNames(_response);
        });
    }
    processGetSituViewWithNames(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituViewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStyleConfig(request) {
        let url_ = this.baseUrl + "/api/queries/GetStyleConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStyleConfig(_response);
        });
    }
    processGetStyleConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStyleConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStyleTemplate(request) {
        let url_ = this.baseUrl + "/api/queries/GetStyleTemplate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStyleTemplate(_response);
        });
    }
    processGetStyleTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStyleTemplateResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStyleTemplateByName(request) {
        let url_ = this.baseUrl + "/api/queries/GetStyleTemplateByName";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStyleTemplateByName(_response);
        });
    }
    processGetStyleTemplateByName(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStyleTemplateResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStyleTemplateThemes(request) {
        let url_ = this.baseUrl + "/api/queries/GetStyleTemplateThemes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStyleTemplateThemes(_response);
        });
    }
    processGetStyleTemplateThemes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStyleTemplateThemesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStyleTree(request) {
        let url_ = this.baseUrl + "/api/queries/GetStyleTree";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStyleTree(_response);
        });
    }
    processGetStyleTree(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStyleTreeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getTermsAndConditions(request) {
        let url_ = this.baseUrl + "/api/queries/GetTermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetTermsAndConditions(_response);
        });
    }
    processGetTermsAndConditions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetTermsAndConditionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listCachedHomesByBuilder(request) {
        let url_ = this.baseUrl + "/api/queries/ListCachedHomesByBuilder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListCachedHomesByBuilder(_response);
        });
    }
    processListCachedHomesByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListCachedHomesByBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listHomeConfigsByHome(request) {
        let url_ = this.baseUrl + "/api/queries/ListHomeConfigsByHome";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListHomeConfigsByHome(_response);
        });
    }
    processListHomeConfigsByHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListHomeConfigsByHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listHomeDetails(request) {
        let url_ = this.baseUrl + "/api/queries/ListHomeDetails";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListHomeDetails(_response);
        });
    }
    processListHomeDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListHomeDetailsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listHomeIfcFiles(request) {
        let url_ = this.baseUrl + "/api/queries/ListHomeIfcFiles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListHomeIfcFiles(_response);
        });
    }
    processListHomeIfcFiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListHomeIfcFilesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listHomesByCompany(request) {
        let url_ = this.baseUrl + "/api/queries/ListHomesByCompany";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListHomesByCompany(_response);
        });
    }
    processListHomesByCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListHomesByCompanyResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listHomes(request) {
        let url_ = this.baseUrl + "/api/queries/ListHomes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListHomes(_response);
        });
    }
    processListHomes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListHomesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listIfcFileErrors(request) {
        let url_ = this.baseUrl + "/api/queries/ListIfcErrors";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListIfcFileErrors(_response);
        });
    }
    processListIfcFileErrors(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListIfcErrorsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listIfcFilesByHomeId(byHomeIdRequest) {
        let url_ = this.baseUrl + "/api/queries/ListIfcFilesByHomeId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(byHomeIdRequest);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListIfcFilesByHomeId(_response);
        });
    }
    processListIfcFilesByHomeId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListIfcFilesByHomeIdResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listManufacturerProducts(request) {
        let url_ = this.baseUrl + "/api/queries/ListManufacturerProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListManufacturerProducts(_response);
        });
    }
    processListManufacturerProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListManufacturerProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listPagedArtifacts(request) {
        let url_ = this.baseUrl + "/api/queries/ListPagedArtifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListPagedArtifacts(_response);
        });
    }
    processListPagedArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListPagedArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listPagedHomeIfcFiles(request) {
        let url_ = this.baseUrl + "/api/queries/ListPagedHomeIfcFiles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListPagedHomeIfcFiles(_response);
        });
    }
    processListPagedHomeIfcFiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListPagedHomeIfcFilesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listPagedIfcFileErrors(request) {
        let url_ = this.baseUrl + "/api/queries/ListPagedIfcErrors";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListPagedIfcFileErrors(_response);
        });
    }
    processListPagedIfcFileErrors(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListPagedIfcErrorsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listPagedImportedProducts(request) {
        let url_ = this.baseUrl + "/api/queries/ListPagedImportedProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListPagedImportedProducts(_response);
        });
    }
    processListPagedImportedProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListPagedImportedProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRenderedOutputs(request) {
        let url_ = this.baseUrl + "/api/queries/ListRenderedOutputs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRenderedOutputs(_response);
        });
    }
    processListRenderedOutputs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListRenderedOutputsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listStyleTemplates(request) {
        let url_ = this.baseUrl + "/api/queries/ListStyleTemplates";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListStyleTemplates(_response);
        });
    }
    processListStyleTemplates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListStyleTemplatesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listStyleTemplatesByTheme(request) {
        let url_ = this.baseUrl + "/api/queries/ListStyleTemplatesByTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListStyleTemplatesByTheme(_response);
        });
    }
    processListStyleTemplatesByTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListStyleTemplatesByThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listTags(request) {
        let url_ = this.baseUrl + "/api/queries/ListTags";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListTags(_response);
        });
    }
    processListTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListTagsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFile(companyId, fileVaultReferenceId) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/GetFile?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (fileVaultReferenceId === null)
            throw new Error("The parameter 'fileVaultReferenceId' cannot be null.");
        else if (fileVaultReferenceId !== undefined)
            url_ += "fileVaultReferenceId=" + encodeURIComponent("" + fileVaultReferenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFile(_response);
        });
    }
    processGetFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getValidFileExtensions(fileVaultCategory) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/GetValidFileExtensions?";
        if (fileVaultCategory === null)
            throw new Error("The parameter 'fileVaultCategory' cannot be null.");
        else if (fileVaultCategory !== undefined)
            url_ += "fileVaultCategory=" + encodeURIComponent("" + fileVaultCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetValidFileExtensions(_response);
        });
    }
    processGetValidFileExtensions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getZippedFiles(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/GetZippedFiles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetZippedFiles(_response);
        });
    }
    processGetZippedFiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    requestFileVaultUpload(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/RequestFileVaultUpload";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRequestFileVaultUpload(_response);
        });
    }
    processRequestFileVaultUpload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileVaultUploadResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    commitFileVaultUpload(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/CommitFileVaultUpload";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCommitFileVaultUpload(_response);
        });
    }
    processCommitFileVaultUpload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileVaultUploadCommitResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFileVaultReferences(relationsRequest) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/GetFileVaultReferences";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(relationsRequest);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFileVaultReferences(_response);
        });
    }
    processGetFileVaultReferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetFileVaultReferencesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFileVaultReferenceRelations(relationsRequest) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/GetFileVaultReferenceRelations";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(relationsRequest);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetFileVaultReferenceRelations(_response);
        });
    }
    processGetFileVaultReferenceRelations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetFileVaultReferenceRelationsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addFileVaultReferences(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/AddFileVaultReferences";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddFileVaultReferences(_response);
        });
    }
    processAddFileVaultReferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddFileVaultReferencesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    removeFileVaultReferences(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/FileVault/RemoveFileVaultReferences";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRemoveFileVaultReferences(_response);
        });
    }
    processRemoveFileVaultReferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemoveFileVaultReferencesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    importThemes(companyId, files) {
        let url_ = this.baseUrl + "/api/commands/experimental/ImportThemes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("companyId", companyId.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processImportThemes(_response);
        });
    }
    processImportThemes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImportThemesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAssetInstance(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/ProductAssetBuilder/GetAssetInstance";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAssetInstance(_response);
        });
    }
    processGetAssetInstance(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAssetInstanceResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAssetTemplate(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/ProductAssetBuilder/GetAssetTemplate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAssetTemplate(_response);
        });
    }
    processGetAssetTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAssetTemplateResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAssetReferenceRecommendations(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/ProductAssetBuilder/GetAssetReferenceRecommendations";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAssetReferenceRecommendations(_response);
        });
    }
    processGetAssetReferenceRecommendations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAssetReferenceRecommendationsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    publishAssets(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/ProductAssetBuilder/PublishAssets";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPublishAssets(_response);
        });
    }
    processPublishAssets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PublishAssetsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getMeshDetails(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/ProductAssetBuilder/GetMeshDetails";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMeshDetails(_response);
        });
    }
    processGetMeshDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetMeshDetailsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAssetValidation(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/ProductAssetBuilder/GetAssetValidation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetAssetValidation(_response);
        });
    }
    processGetAssetValidation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetAssetValidationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addProductClassification(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductClassifications/AddProductClassification";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddProductClassification(_response);
        });
    }
    processAddProductClassification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddProductClassificationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProductClassification(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductClassifications/UpdateProductClassification";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProductClassification(_response);
        });
    }
    processUpdateProductClassification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductClassificationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listProductClassifications(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductClassifications/ListProductClassifications";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListProductClassifications(_response);
        });
    }
    processListProductClassifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListProductClassificationsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    newAddProduct(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/Products/NewAddProduct";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processNewAddProduct(_response);
        });
    }
    processNewAddProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NewAddProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    newUpdateProduct(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/Products/NewUpdateProduct";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processNewUpdateProduct(_response);
        });
    }
    processNewUpdateProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NewUpdateProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    newGetProduct(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/NewGetProduct";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processNewGetProduct(_response);
        });
    }
    processNewGetProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NewGetProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    newListProducts(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/NewListProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processNewListProducts(_response);
        });
    }
    processNewListProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NewListProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    productWorkflowGraph() {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/ProductWorkflowGraph";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processProductWorkflowGraph(_response);
        });
    }
    processProductWorkflowGraph(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    triggerProductWorkflow(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/TriggerProductWorkflow";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTriggerProductWorkflow(_response);
        });
    }
    processTriggerProductWorkflow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TriggerProductWorkflowResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductWorkflowHistory(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/GetProductWorkflowHistory";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductWorkflowHistory(_response);
        });
    }
    processGetProductWorkflowHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductWorkflowHistoryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductThemes(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/GetProductThemes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductThemes(_response);
        });
    }
    processGetProductThemes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductThemesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductWorkflowStates(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/GetProductWorkflowStates";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductWorkflowStates(_response);
        });
    }
    processGetProductWorkflowStates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductWorkflowConfigurationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    productWorkflowStateReport(productWorkflowStateReportRequest) {
        let url_ = this.baseUrl + "/api/queries/experimental/Products/ProductWorkflowStateReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(productWorkflowStateReportRequest);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processProductWorkflowStateReport(_response);
        });
    }
    processProductWorkflowStateReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductWorkflowStateReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addProductSpecification(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductSpecifications/AddProductSpecification";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddProductSpecification(_response);
        });
    }
    processAddProductSpecification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddProductSpecificationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProductSpecification(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductSpecifications/UpdateProductSpecification";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProductSpecification(_response);
        });
    }
    processUpdateProductSpecification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductSpecificationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listProductSpecifications(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductSpecifications/ListProductSpecifications";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListProductSpecifications(_response);
        });
    }
    processListProductSpecifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListProductSpecificationsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addProductType(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductTypes/AddProductType";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddProductType(_response);
        });
    }
    processAddProductType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddProductTypeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProductType(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductTypes/UpdateProductType";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProductType(_response);
        });
    }
    processUpdateProductType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductTypeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProductTypeRelatedTags(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductTypes/UpdateProductTypeRelatedTags";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProductTypeRelatedTags(_response);
        });
    }
    processUpdateProductTypeRelatedTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductTypeRelatedTagsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductType(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductTypes/GetProductType";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductType(_response);
        });
    }
    processGetProductType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductTypeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listProductTypes(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ProductTypes/ListProductTypes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListProductTypes(_response);
        });
    }
    processListProductTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListProductTypesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateRequestedProduct(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedProduct/UpdateRequestedProduct";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateRequestedProduct(_response);
        });
    }
    processUpdateRequestedProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateRequestedProductResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateRequestedProducts(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedProduct/UpdateRequestedProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateRequestedProducts(_response);
        });
    }
    processUpdateRequestedProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateRequestedProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    importRequestedProduct(companyId, file) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedProduct/ImportRequestedProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processImportRequestedProduct(_response);
        });
    }
    processImportRequestedProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImportRequestedProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRequestedProducts(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedProduct/ListRequestedProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRequestedProducts(_response);
        });
    }
    processListRequestedProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListRequestedProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    triggerRequestedProductWorkflow(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedProduct/TriggerRequestedProductWorkflow/api/queries/experimental/RequestedProduct/TriggerRequestedProductWorkflow";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTriggerRequestedProductWorkflow(_response);
        });
    }
    processTriggerRequestedProductWorkflow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TriggerRequestedProductWorkflowResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    requestedSupplierWorkflowGraph() {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedSupplier/RequestedSupplierWorkflowGraph";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRequestedSupplierWorkflowGraph(_response);
        });
    }
    processRequestedSupplierWorkflowGraph(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createRequestedSupplier(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedSupplier/CreateRequestedSupplier";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateRequestedSupplier(_response);
        });
    }
    processCreateRequestedSupplier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateRequestedSupplierResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRequestedSupplierStates(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedSupplier/ListRequestedSupplierStates";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRequestedSupplierStates(_response);
        });
    }
    processListRequestedSupplierStates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListRequestedSupplierStatesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRequestedSupplier(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedSupplier/GetRequestedSupplier";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRequestedSupplier(_response);
        });
    }
    processGetRequestedSupplier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRequestedSupplierCurrentWorkflowStateResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    triggerRequestedSupplierWorkflow(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/RequestedSupplier/TriggerRequestedSupplierWorkflow";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTriggerRequestedSupplierWorkflow(_response);
        });
    }
    processTriggerRequestedSupplierWorkflow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TriggerRequestedSupplierWorkflowResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    upsertThemeLineItems(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/ThemeLineItems/UpsertThemeLineItems";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpsertThemeLineItems(_response);
        });
    }
    processUpsertThemeLineItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpsertThemeLineItemsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listThemeLineItems(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ThemeLineItems/ListThemeLineItems";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListThemeLineItems(_response);
        });
    }
    processListThemeLineItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListThemeLineItemsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getThemeLineItemType(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ThemeLineItemTypes/GetThemeLineItemType";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetThemeLineItemType(_response);
        });
    }
    processGetThemeLineItemType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetThemeLineItemTypeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listThemeLineItemTypes(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ThemeLineItemTypes/ListThemeLineItemTypes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListThemeLineItemTypes(_response);
        });
    }
    processListThemeLineItemTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListThemeLineItemTypesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addThemeReplacementTag(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ThemeReplacementTags/AddThemeReplacementTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddThemeReplacementTag(_response);
        });
    }
    processAddThemeReplacementTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddThemeReplacementTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateThemeReplacementTag(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ThemeReplacementTags/UpdateThemeReplacementTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateThemeReplacementTag(_response);
        });
    }
    processUpdateThemeReplacementTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateThemeReplacementTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchThemeReplacementTags(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ThemeReplacementTags/SearchThemeReplacementTags";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSearchThemeReplacementTags(_response);
        });
    }
    processSearchThemeReplacementTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SearchThemeReplacementTagsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listThemeReplacementTags(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/ThemeReplacementTags/ListThemeReplacementTags";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListThemeReplacementTags(_response);
        });
    }
    processListThemeReplacementTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListThemeReplacementTagsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addTheme(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/Themes/AddTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddTheme(_response);
        });
    }
    processAddTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateTheme(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/Themes/UpdateTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateTheme(_response);
        });
    }
    processUpdateTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    copyTheme(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/Themes/CopyTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCopyTheme(_response);
        });
    }
    processCopyTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CopyThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getTheme(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Themes/GetTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetTheme(_response);
        });
    }
    processGetTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    publishTheme(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/Themes/PublishTheme";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPublishTheme(_response);
        });
    }
    processPublishTheme(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PublishThemeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getThemeConfig(request) {
        let url_ = this.baseUrl + "/api/commands/experimental/Themes/GetThemeConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetThemeConfig(_response);
        });
    }
    processGetThemeConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetThemeConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listThemes(request) {
        let url_ = this.baseUrl + "/api/queries/experimental/Themes/ListThemes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListThemes(_response);
        });
    }
    processListThemes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListThemesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addAcceptance(request) {
        let url_ = this.baseUrl + "/api/commands/AddAcceptance";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddAcceptance(_response);
        });
    }
    processAddAcceptance(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddAcceptanceResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addHome(builder, homeName, ifcFiles, files) {
        let url_ = this.baseUrl + "/api/commands/AddHome";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (builder !== null && builder !== undefined)
            content_.append("Builder", builder.toString());
        if (homeName !== null && homeName !== undefined)
            content_.append("HomeName", homeName.toString());
        if (ifcFiles !== null && ifcFiles !== undefined)
            ifcFiles.forEach(item_ => content_.append("IfcFiles", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddHome(_response);
        });
    }
    processAddHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addStyleCategory(request) {
        let url_ = this.baseUrl + "/api/commands/AddStyleCategory";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddStyleCategory(_response);
        });
    }
    processAddStyleCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddStyleCategoryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addStyleTemplate(request) {
        let url_ = this.baseUrl + "/api/commands/AddStyleTemplate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddStyleTemplate(_response);
        });
    }
    processAddStyleTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddStyleTemplateResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    clearIfcFileUploadError(request) {
        let url_ = this.baseUrl + "/api/commands/ClearIfcFileUploadError";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processClearIfcFileUploadError(_response);
        });
    }
    processClearIfcFileUploadError(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClearIfcFileUploadErrorResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituViewChild(request) {
        let url_ = this.baseUrl + "/api/commands/CreateSituViewChild";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituViewChild(_response);
        });
    }
    processCreateSituViewChild(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituViewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituView(request) {
        let url_ = this.baseUrl + "/api/commands/CreateSituView";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituView(_response);
        });
    }
    processCreateSituView(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituViewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituViewWithNames(request) {
        let url_ = this.baseUrl + "/api/commands/CreateSituViewWithNames";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituViewWithNames(_response);
        });
    }
    processCreateSituViewWithNames(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituViewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createTag(request) {
        let url_ = this.baseUrl + "/api/commands/CreateTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateTag(_response);
        });
    }
    processCreateTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteTag(request) {
        let url_ = this.baseUrl + "/api/commands/DeleteTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteTag(_response);
        });
    }
    processDeleteTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSanitizedFile(request) {
        let url_ = this.baseUrl + "/api/commands/GetSanitizedFile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSanitizedFile(_response);
        });
    }
    processGetSanitizedFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSanitizedFileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    importProducts(companyId, files) {
        let url_ = this.baseUrl + "/api/commands/ImportProducts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("companyId", companyId.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processImportProducts(_response);
        });
    }
    processImportProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImportProductsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    logPanoramaView(request) {
        let url_ = this.baseUrl + "/api/commands/LogPanoramaView";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processLogPanoramaView(_response);
        });
    }
    processLogPanoramaView(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LogPanoramaViewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveStyleCategory(request) {
        let url_ = this.baseUrl + "/api/commands/SaveStyleCategory";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveStyleCategory(_response);
        });
    }
    processSaveStyleCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveStyleCategoryResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveStyleConfig(request) {
        let url_ = this.baseUrl + "/api/commands/SaveStyleConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveStyleConfig(_response);
        });
    }
    processSaveStyleConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveStyleConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveStyleTemplate(request) {
        let url_ = this.baseUrl + "/api/commands/SaveStyleTemplate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveStyleTemplate(_response);
        });
    }
    processSaveStyleTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveStyleTemplateResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setArtifactActive(request) {
        let url_ = this.baseUrl + "/api/commands/SetArtifactActive";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetArtifactActive(_response);
        });
    }
    processSetArtifactActive(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetArtifactActiveResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setCompanyTeamsIntegration(request) {
        let url_ = this.baseUrl + "/api/commands/SetCompanyTeamsIntegration";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetCompanyTeamsIntegration(_response);
        });
    }
    processSetCompanyTeamsIntegration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetCompanyTeamsIntegrationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setDefaultRenderedOutput(request) {
        let url_ = this.baseUrl + "/api/commands/SetDefaultRenderedOutput";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetDefaultRenderedOutput(_response);
        });
    }
    processSetDefaultRenderedOutput(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetDefaultRenderedOutputResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setRenderedOutputProduction(request) {
        let url_ = this.baseUrl + "/api/commands/SetRenderedOutputProduction";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetRenderedOutputProduction(_response);
        });
    }
    processSetRenderedOutputProduction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetRenderedOutputProductionResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setRenderedOutputStatus(request) {
        let url_ = this.baseUrl + "/api/commands/SetRenderedOutputStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetRenderedOutputStatus(_response);
        });
    }
    processSetRenderedOutputStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetRenderedOutputStatusResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateCategoryStyles(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateCategoryStyles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateCategoryStyles(_response);
        });
    }
    processUpdateCategoryStyles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateCategoryStylesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateHome(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateHome";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateHome(_response);
        });
    }
    processUpdateHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateHomeIfcFile(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateHomeIfcFile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateHomeIfcFile(_response);
        });
    }
    processUpdateHomeIfcFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateHomeIfcFileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProductMatch(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateProductMatch";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateProductMatch(_response);
        });
    }
    processUpdateProductMatch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductMatchResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateTag(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateTag(_response);
        });
    }
    processUpdateTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateTagResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    uploadFilesForHome(builder, homeName, ifcFiles, files) {
        let url_ = this.baseUrl + "/api/commands/UploadFilesForHome";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (builder !== null && builder !== undefined)
            content_.append("Builder", builder.toString());
        if (homeName !== null && homeName !== undefined)
            content_.append("HomeName", homeName.toString());
        if (ifcFiles !== null && ifcFiles !== undefined)
            ifcFiles.forEach(item_ => content_.append("IfcFiles", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUploadFilesForHome(_response);
        });
    }
    processUploadFilesForHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadFilesForHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    uploadStyleThumbnail(request) {
        let url_ = this.baseUrl + "/api/commands/UploadStyleThumbnail";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUploadStyleThumbnail(_response);
        });
    }
    processUploadStyleThumbnail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UploadStyleThumbnailResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SituResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class GetAccessoryBundleResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.accessoryBundle = _data["accessoryBundle"] ? AccessoryBundle.fromJS(_data["accessoryBundle"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccessoryBundleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessoryBundle"] = this.accessoryBundle ? this.accessoryBundle.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class AccessoryBundle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.buildingInstructions = _data["buildingInstructions"];
            this.companyId = _data["companyId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(AccessoryBundleItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryBundle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["buildingInstructions"] = this.buildingInstructions;
        data["companyId"] = this.companyId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
export class AccessoryBundleItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.accessoryBundleId = _data["accessoryBundleId"];
            this.homeIfcFileId = _data["homeIfcFileId"];
            this.code = _data["code"];
            this.sortOrder = _data["sortOrder"];
            this.homeIfcFileName = _data["homeIfcFileName"];
            this.homeName = _data["homeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryBundleItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessoryBundleId"] = this.accessoryBundleId;
        data["homeIfcFileId"] = this.homeIfcFileId;
        data["code"] = this.code;
        data["sortOrder"] = this.sortOrder;
        data["homeIfcFileName"] = this.homeIfcFileName;
        data["homeName"] = this.homeName;
        return data;
    }
}
export class GetAccessoryBundleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccessoryBundleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class GetAccessoryBundleByBuildingInstructionsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.accessoryBundle = _data["accessoryBundle"] ? AccessoryBundle.fromJS(_data["accessoryBundle"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccessoryBundleByBuildingInstructionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessoryBundle"] = this.accessoryBundle ? this.accessoryBundle.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetAccessoryBundleByBuildingInstructionsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.buildingInstructions = _data["buildingInstructions"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccessoryBundleByBuildingInstructionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["buildingInstructions"] = this.buildingInstructions;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class ListAccessoryBundlesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accessoryBundles"])) {
                this.accessoryBundles = [];
                for (let item of _data["accessoryBundles"])
                    this.accessoryBundles.push(AccessoryBundle.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListAccessoryBundlesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessoryBundles)) {
            data["accessoryBundles"] = [];
            for (let item of this.accessoryBundles)
                data["accessoryBundles"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListAccessoryBundlesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.includeInactive = _data["includeInactive"];
            this.searchTerm = _data["searchTerm"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListAccessoryBundlesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["includeInactive"] = this.includeInactive;
        data["searchTerm"] = this.searchTerm;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
export class CreateAccessoryBundleResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.accessoryBundle = _data["accessoryBundle"] ? AccessoryBundle.fromJS(_data["accessoryBundle"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessoryBundleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessoryBundle"] = this.accessoryBundle ? this.accessoryBundle.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class CreateAccessoryBundleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.buildingInstructions = _data["buildingInstructions"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(CreateAccessoryBundleItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessoryBundleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["buildingInstructions"] = this.buildingInstructions;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
export class CreateAccessoryBundleItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeIfcFileId = _data["homeIfcFileId"];
            this.code = _data["code"];
            this.sortOrder = _data["sortOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessoryBundleItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeIfcFileId"] = this.homeIfcFileId;
        data["code"] = this.code;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}
export class UpdateAccessoryBundleResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.accessoryBundle = _data["accessoryBundle"] ? AccessoryBundle.fromJS(_data["accessoryBundle"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessoryBundleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessoryBundle"] = this.accessoryBundle ? this.accessoryBundle.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateAccessoryBundleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.buildingInstructions = _data["buildingInstructions"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(CreateAccessoryBundleItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessoryBundleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["buildingInstructions"] = this.buildingInstructions;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
export class DeleteAccessoryBundleResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccessoryBundleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteAccessoryBundleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccessoryBundleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class GetBrandResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class Brand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.brandLogoUrl = _data["brandLogoUrl"];
            this.showBrandLogoOnly = _data["showBrandLogoOnly"];
            this.modifiedBy = _data["modifiedBy"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined;
            this.qualityLevel = _data["qualityLevel"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Brand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["brandLogoUrl"] = this.brandLogoUrl;
        data["showBrandLogoOnly"] = this.showBrandLogoOnly;
        data["modifiedBy"] = this.modifiedBy;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined;
        data["qualityLevel"] = this.qualityLevel;
        return data;
    }
}
export var QualityLevel;
(function (QualityLevel) {
    QualityLevel[QualityLevel["Unset"] = 0] = "Unset";
    QualityLevel[QualityLevel["Good"] = 3] = "Good";
    QualityLevel[QualityLevel["Better"] = 5] = "Better";
    QualityLevel[QualityLevel["Best"] = 7] = "Best";
})(QualityLevel || (QualityLevel = {}));
export class GetBrandRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["id"] = this.id;
        return data;
    }
}
export class ListBrandsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["brands"])) {
                this.brands = [];
                for (let item of _data["brands"])
                    this.brands.push(Brand.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListBrandsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListBrandsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListBrandsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        return data;
    }
}
export class CreateBrandResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBrandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class CreateBrandRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBrandRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        return data;
    }
}
export class UpdateBrandResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBrandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateBrandRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBrandRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        return data;
    }
}
export class DeleteBrandResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBrandResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteBrandRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.brandId = _data["brandId"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBrandRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["brandId"] = this.brandId;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class FinaliseImportedProductsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productCount = _data["productCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FinaliseImportedProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productCount"] = this.productCount;
        super.toJSON(data);
        return data;
    }
}
export class FinaliseImportedProductsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["excludedProductsIds"])) {
                this.excludedProductsIds = [];
                for (let item of _data["excludedProductsIds"])
                    this.excludedProductsIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FinaliseImportedProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.excludedProductsIds)) {
            data["excludedProductsIds"] = [];
            for (let item of this.excludedProductsIds)
                data["excludedProductsIds"].push(item);
        }
        return data;
    }
}
export class PurgeImportedProductsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeImportedProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PurgeImportedProductsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeImportedProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class AssignHomeTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignHomeTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class AssignHomeTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.tagId = _data["tagId"];
            this.homeId = _data["homeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignHomeTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["tagId"] = this.tagId;
        data["homeId"] = this.homeId;
        return data;
    }
}
export class RemoveHomeTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveHomeTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RemoveHomeTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.tagId = _data["tagId"];
            this.homeId = _data["homeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveHomeTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["tagId"] = this.tagId;
        data["homeId"] = this.homeId;
        return data;
    }
}
export class UploadManufacturerLogoResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.manufacturerLogoUrl = _data["manufacturerLogoUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadManufacturerLogoResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerLogoUrl"] = this.manufacturerLogoUrl;
        super.toJSON(data);
        return data;
    }
}
export class UploadManufacturerLogoRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.manufacturerId = _data["manufacturerId"];
            this.manufacturerLogo = _data["manufacturerLogo"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadManufacturerLogoRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerId"] = this.manufacturerId;
        data["manufacturerLogo"] = this.manufacturerLogo;
        return data;
    }
}
export class GetManufacturerResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.manufacturer = _data["manufacturer"] ? Company.fromJS(_data["manufacturer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class Company {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
            this.disabled = _data["disabled"];
            this.companyType = _data["companyType"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined;
            this.productCount = _data["productCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        data["disabled"] = this.disabled;
        data["companyType"] = this.companyType;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined;
        data["productCount"] = this.productCount;
        return data;
    }
}
export var CompanyType;
(function (CompanyType) {
    CompanyType[CompanyType["Builder"] = 0] = "Builder";
    CompanyType[CompanyType["Manufacturer"] = 1] = "Manufacturer";
    CompanyType[CompanyType["Architecture"] = 2] = "Architecture";
})(CompanyType || (CompanyType = {}));
export class GetManufacturerRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.manufacturerId = _data["manufacturerId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerId"] = this.manufacturerId;
        return data;
    }
}
export class PagedResponseOfCompany extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Company.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfCompany();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListManufacturersResponse extends PagedResponseOfCompany {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [];
                for (let item of _data["manufacturers"])
                    this.manufacturers.push(Company.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListManufacturersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class PagedRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
export class ListManufacturersRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.enabled = _data["enabled"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.companyType = _data["companyType"];
            this.companyIdsToExclude = _data["companyIdsToExclude"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListManufacturersRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["enabled"] = this.enabled;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["companyType"] = this.companyType;
        data["companyIdsToExclude"] = this.companyIdsToExclude;
        super.toJSON(data);
        return data;
    }
}
export class AddProductResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class Product {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.displaySku = _data["displaySku"];
            this.type = _data["type"];
            this.brand = _data["brand"];
            this.brandLogoUrl = _data["brandLogoUrl"];
            this.showBrandLogoOnly = _data["showBrandLogoOnly"];
            this.hideSku = _data["hideSku"];
            this.disabled = _data["disabled"];
            this.modifiedBy = _data["modifiedBy"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["displaySku"] = this.displaySku;
        data["type"] = this.type;
        data["brand"] = this.brand;
        data["brandLogoUrl"] = this.brandLogoUrl;
        data["showBrandLogoOnly"] = this.showBrandLogoOnly;
        data["hideSku"] = this.hideSku;
        data["disabled"] = this.disabled;
        data["modifiedBy"] = this.modifiedBy;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    }
}
export class AddProductRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["product"] = this.product ? this.product.toJSON() : undefined;
        return data;
    }
}
export class UpdateProductResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["product"] = this.product ? this.product.toJSON() : undefined;
        return data;
    }
}
export class GetProductResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetProductRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        return data;
    }
}
export class GetProductByManufacturerAndSkuCodeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.sku = _data["sku"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductByManufacturerAndSkuCodeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["sku"] = this.sku;
        return data;
    }
}
export class PagedResponseOfProduct extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Product.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListProductsResponse extends PagedResponseOfProduct {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [];
                for (let item of _data["products"])
                    this.products.push(Product.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListProductsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["tagFilter"])) {
                this.tagFilter = [];
                for (let item of _data["tagFilter"])
                    this.tagFilter.push(item);
            }
            if (Array.isArray(_data["rangeFilter"])) {
                this.rangeFilter = [];
                for (let item of _data["rangeFilter"])
                    this.rangeFilter.push(item);
            }
            this.companyId = _data["companyId"];
            this.enabled = _data["enabled"];
            this.includeTagsIds = _data["includeTagsIds"];
            this.includeRangeIds = _data["includeRangeIds"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.tagFilter)) {
            data["tagFilter"] = [];
            for (let item of this.tagFilter)
                data["tagFilter"].push(item);
        }
        if (Array.isArray(this.rangeFilter)) {
            data["rangeFilter"] = [];
            for (let item of this.rangeFilter)
                data["rangeFilter"].push(item);
        }
        data["companyId"] = this.companyId;
        data["enabled"] = this.enabled;
        data["includeTagsIds"] = this.includeTagsIds;
        data["includeRangeIds"] = this.includeRangeIds;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class CreateRangeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.range = _data["range"] ? Range.fromJS(_data["range"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRangeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["range"] = this.range ? this.range.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class Range {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.borderColour = _data["borderColour"];
            this.backgroundColour = _data["backgroundColour"];
            this.logicalExpression = _data["logicalExpression"];
            this.canShare = _data["canShare"];
            this.companyId = _data["companyId"];
            this.resourceType = _data["resourceType"];
            this.isDeleted = _data["isDeleted"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.dateDeleted = _data["dateDeleted"] ? new Date(_data["dateDeleted"].toString()) : undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["rangeRoles"])) {
                this.rangeRoles = [];
                for (let item of _data["rangeRoles"])
                    this.rangeRoles.push(RangeRole.fromJS(item));
            }
            if (Array.isArray(_data["rangeAuthorisedCompanies"])) {
                this.rangeAuthorisedCompanies = [];
                for (let item of _data["rangeAuthorisedCompanies"])
                    this.rangeAuthorisedCompanies.push(RangeAuthorisedCompany.fromJS(item));
            }
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [];
                for (let item of _data["productIds"])
                    this.productIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Range();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["borderColour"] = this.borderColour;
        data["backgroundColour"] = this.backgroundColour;
        data["logicalExpression"] = this.logicalExpression;
        data["canShare"] = this.canShare;
        data["companyId"] = this.companyId;
        data["resourceType"] = this.resourceType;
        data["isDeleted"] = this.isDeleted;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["dateDeleted"] = this.dateDeleted ? this.dateDeleted.toISOString() : undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.rangeRoles)) {
            data["rangeRoles"] = [];
            for (let item of this.rangeRoles)
                data["rangeRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.rangeAuthorisedCompanies)) {
            data["rangeAuthorisedCompanies"] = [];
            for (let item of this.rangeAuthorisedCompanies)
                data["rangeAuthorisedCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        return data;
    }
}
export var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["Any"] = 0] = "Any";
    ResourceType[ResourceType["Product"] = 1] = "Product";
    ResourceType[ResourceType["User"] = 2] = "User";
    ResourceType[ResourceType["Home"] = 3] = "Home";
    ResourceType[ResourceType["ReleaseIssue"] = 4] = "ReleaseIssue";
})(ResourceType || (ResourceType = {}));
export class RangeRole {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.name = _data["name"];
            this.rangeId = _data["rangeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RangeRole();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["name"] = this.name;
        data["rangeId"] = this.rangeId;
        return data;
    }
}
export class RangeAuthorisedCompany {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rangeId = _data["rangeId"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RangeAuthorisedCompany();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rangeId"] = this.rangeId;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class CreateRangeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.resourceType = _data["resourceType"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRangeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resourceType"] = this.resourceType;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class UpdateRangeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRangeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateRangeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rangeId = _data["rangeId"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.borderColour = _data["borderColour"];
            this.backgroundColour = _data["backgroundColour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRangeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rangeId"] = this.rangeId;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["borderColour"] = this.borderColour;
        data["backgroundColour"] = this.backgroundColour;
        return data;
    }
}
export class DeleteRangeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRangeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteRangeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rangeId = _data["rangeId"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRangeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rangeId"] = this.rangeId;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class GetRangeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.range = _data["range"] ? Range.fromJS(_data["range"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRangeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["range"] = this.range ? this.range.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetRangeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRangeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["id"] = this.id;
        return data;
    }
}
export class PagedResponseOfRange extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Range.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfRange();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListRangesResponse extends PagedResponseOfRange {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRangesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ListRangesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.resourceType = _data["resourceType"];
            this.companyId = _data["companyId"];
            this.includeDeleted = _data["includeDeleted"];
            this.onlySharedRanges = _data["onlySharedRanges"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRangesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["resourceType"] = this.resourceType;
        data["companyId"] = this.companyId;
        data["includeDeleted"] = this.includeDeleted;
        data["onlySharedRanges"] = this.onlySharedRanges;
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductRangeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductRangeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductRangeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rangeId = _data["rangeId"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [];
                for (let item of _data["productIds"])
                    this.productIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductRangeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rangeId"] = this.rangeId;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        return data;
    }
}
export class UpdateProductRangeAuthorisedCompanyResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductRangeAuthorisedCompanyResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductRangeAuthorisedCompanyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rangeId = _data["rangeId"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [];
                for (let item of _data["companyIds"])
                    this.companyIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductRangeAuthorisedCompanyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rangeId"] = this.rangeId;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        return data;
    }
}
export class AddReleaseResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.releaseId = _data["releaseId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddReleaseResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["releaseId"] = this.releaseId;
        super.toJSON(data);
        return data;
    }
}
export class AddReleaseRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddReleaseRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        return data;
    }
}
export class UpdateReleaseResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateReleaseRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseId = _data["releaseId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined;
            this.renderReleaseStatus = _data["renderReleaseStatus"];
            this.situPlan = _data["situPlan"];
            this.situVr = _data["situVr"];
            this.situRender = _data["situRender"];
            this.situRaytracedPlus = _data["situRaytracedPlus"];
            this.skipRaytraced = _data["skipRaytraced"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseId"] = this.releaseId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        data["renderReleaseStatus"] = this.renderReleaseStatus;
        data["situPlan"] = this.situPlan;
        data["situVr"] = this.situVr;
        data["situRender"] = this.situRender;
        data["situRaytracedPlus"] = this.situRaytracedPlus;
        data["skipRaytraced"] = this.skipRaytraced;
        return data;
    }
}
export var RenderReleaseStatus;
(function (RenderReleaseStatus) {
    RenderReleaseStatus[RenderReleaseStatus["InFlight"] = 0] = "InFlight";
    RenderReleaseStatus[RenderReleaseStatus["PreRelease"] = 1] = "PreRelease";
    RenderReleaseStatus[RenderReleaseStatus["Released"] = 2] = "Released";
})(RenderReleaseStatus || (RenderReleaseStatus = {}));
export class PagedResponseOfRelease extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Release.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfRelease();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListReleasesResponse extends PagedResponseOfRelease {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListReleasesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class Release {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.dateDeleted = _data["dateDeleted"] ? new Date(_data["dateDeleted"].toString()) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.renderReleaseStatus = _data["renderReleaseStatus"];
            this.released = _data["released"];
            this.situPlan = _data["situPlan"];
            this.situVr = _data["situVr"];
            this.situRender = _data["situRender"];
            this.situRaytracedPlus = _data["situRaytracedPlus"];
            this.skipRaytraced = _data["skipRaytraced"];
            this.totalRendered = _data["totalRendered"];
            this.totalLive = _data["totalLive"];
            this.total = _data["total"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            if (Array.isArray(_data["releaseItems"])) {
                this.releaseItems = [];
                for (let item of _data["releaseItems"])
                    this.releaseItems.push(ReleaseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Release();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["dateDeleted"] = this.dateDeleted ? this.dateDeleted.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["renderReleaseStatus"] = this.renderReleaseStatus;
        data["released"] = this.released;
        data["situPlan"] = this.situPlan;
        data["situVr"] = this.situVr;
        data["situRender"] = this.situRender;
        data["situRaytracedPlus"] = this.situRaytracedPlus;
        data["skipRaytraced"] = this.skipRaytraced;
        data["totalRendered"] = this.totalRendered;
        data["totalLive"] = this.totalLive;
        data["total"] = this.total;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        if (Array.isArray(this.releaseItems)) {
            data["releaseItems"] = [];
            for (let item of this.releaseItems)
                data["releaseItems"].push(item.toJSON());
        }
        return data;
    }
}
export class ReleaseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.releaseId = _data["releaseId"];
            this.homeConfigId = _data["homeConfigId"];
            this.styleTemplate = _data["styleTemplate"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.dateLastViewed = _data["dateLastViewed"] ? new Date(_data["dateLastViewed"].toString()) : undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.approvedBy = _data["approvedBy"];
            this.approvedByName = _data["approvedByName"];
            this.lastViewedBy = _data["lastViewedBy"];
            this.lastViewedName = _data["lastViewedName"];
            this.productName = _data["productName"];
            this.releaseStatus = _data["releaseStatus"];
            this.latestVersion = _data["latestVersion"];
            this.productionVersion = _data["productionVersion"];
            this.higherResVersion = _data["higherResVersion"];
            this.highestResVersion = _data["highestResVersion"];
            this.situVr = _data["situVr"];
            this.situPlan = _data["situPlan"];
            this.situRender = _data["situRender"];
            this.newVersionAvailable = _data["newVersionAvailable"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            this.options = _data["options"];
            this.supportTask = _data["supportTask"];
            this.externalSupportTask = _data["externalSupportTask"];
            this.comments = _data["comments"];
            this.release = _data["release"] ? Release.fromJS(_data["release"]) : undefined;
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            if (Array.isArray(_data["releaseIssueReleaseItems"])) {
                this.releaseIssueReleaseItems = [];
                for (let item of _data["releaseIssueReleaseItems"])
                    this.releaseIssueReleaseItems.push(ReleaseIssueReleaseItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["releaseId"] = this.releaseId;
        data["homeConfigId"] = this.homeConfigId;
        data["styleTemplate"] = this.styleTemplate;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["dateLastViewed"] = this.dateLastViewed ? this.dateLastViewed.toISOString() : undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["approvedBy"] = this.approvedBy;
        data["approvedByName"] = this.approvedByName;
        data["lastViewedBy"] = this.lastViewedBy;
        data["lastViewedName"] = this.lastViewedName;
        data["productName"] = this.productName;
        data["releaseStatus"] = this.releaseStatus;
        data["latestVersion"] = this.latestVersion;
        data["productionVersion"] = this.productionVersion;
        data["higherResVersion"] = this.higherResVersion;
        data["highestResVersion"] = this.highestResVersion;
        data["situVr"] = this.situVr;
        data["situPlan"] = this.situPlan;
        data["situRender"] = this.situRender;
        data["newVersionAvailable"] = this.newVersionAvailable;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        data["options"] = this.options;
        data["supportTask"] = this.supportTask;
        data["externalSupportTask"] = this.externalSupportTask;
        data["comments"] = this.comments;
        data["release"] = this.release ? this.release.toJSON() : undefined;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        if (Array.isArray(this.releaseIssueReleaseItems)) {
            data["releaseIssueReleaseItems"] = [];
            for (let item of this.releaseIssueReleaseItems)
                data["releaseIssueReleaseItems"].push(item.toJSON());
        }
        return data;
    }
}
export var ProductName;
(function (ProductName) {
    ProductName[ProductName["Panorama"] = 0] = "Panorama";
    ProductName[ProductName["VR"] = 1] = "VR";
    ProductName[ProductName["RayTraced"] = 2] = "RayTraced";
    ProductName[ProductName["Plan"] = 3] = "Plan";
    ProductName[ProductName["Render"] = 4] = "Render";
    ProductName[ProductName["Facade"] = 5] = "Facade";
    ProductName[ProductName["Insights"] = 6] = "Insights";
    ProductName[ProductName["Vanity"] = 7] = "Vanity";
    ProductName[ProductName["AssetModule"] = 8] = "AssetModule";
    ProductName[ProductName["RayTracedPlus"] = 9] = "RayTracedPlus";
    ProductName[ProductName["ProductPreview"] = 10] = "ProductPreview";
    ProductName[ProductName["IfcPreview"] = 11] = "IfcPreview";
    ProductName[ProductName["Connect"] = 12] = "Connect";
    ProductName[ProductName["Unreal"] = 13] = "Unreal";
})(ProductName || (ProductName = {}));
export var ReleaseStatus;
(function (ReleaseStatus) {
    ReleaseStatus[ReleaseStatus["Proposed"] = 1] = "Proposed";
    ReleaseStatus[ReleaseStatus["ReadyForRender"] = 2] = "ReadyForRender";
    ReleaseStatus[ReleaseStatus["RenderFailed"] = 3] = "RenderFailed";
    ReleaseStatus[ReleaseStatus["ReadyForReview"] = 4] = "ReadyForReview";
    ReleaseStatus[ReleaseStatus["RequiresAttentionSitu"] = 5] = "RequiresAttentionSitu";
    ReleaseStatus[ReleaseStatus["RequiresAttentionVendor"] = 6] = "RequiresAttentionVendor";
    ReleaseStatus[ReleaseStatus["StandardReviewed"] = 7] = "StandardReviewed";
    ReleaseStatus[ReleaseStatus["ReadyForLive"] = 8] = "ReadyForLive";
    ReleaseStatus[ReleaseStatus["Live"] = 9] = "Live";
    ReleaseStatus[ReleaseStatus["RenderingStandard"] = 10] = "RenderingStandard";
    ReleaseStatus[ReleaseStatus["RenderingHiRes"] = 11] = "RenderingHiRes";
    ReleaseStatus[ReleaseStatus["ApprovedForLive"] = 12] = "ApprovedForLive";
    ReleaseStatus[ReleaseStatus["OnHold"] = 13] = "OnHold";
})(ReleaseStatus || (ReleaseStatus = {}));
export class HomeConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.builder = _data["builder"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(item);
            }
            if (Array.isArray(_data["themes"])) {
                this.themes = [];
                for (let item of _data["themes"])
                    this.themes.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["builder"] = this.builder;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item);
        }
        return data;
    }
}
export class ReleaseIssueReleaseItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.releaseIssueId = _data["releaseIssueId"];
            this.releaseItemId = _data["releaseItemId"];
            this.renderedOutputId = _data["renderedOutputId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseIssueReleaseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["releaseIssueId"] = this.releaseIssueId;
        data["releaseItemId"] = this.releaseItemId;
        data["renderedOutputId"] = this.renderedOutputId;
        return data;
    }
}
export class ListReleasesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.containsWord = _data["containsWord"];
            this.isNotReleased = _data["isNotReleased"];
            this.includeStats = _data["includeStats"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListReleasesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["containsWord"] = this.containsWord;
        data["isNotReleased"] = this.isNotReleased;
        data["includeStats"] = this.includeStats;
        super.toJSON(data);
        return data;
    }
}
export class GetReleaseResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.release = _data["release"] ? Release.fromJS(_data["release"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReleaseResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["release"] = this.release ? this.release.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetReleaseRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseId = _data["releaseId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReleaseRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseId"] = this.releaseId;
        return data;
    }
}
export class ImportReleaseItemsFromCsvResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["importedReleaseItems"])) {
                this.importedReleaseItems = [];
                for (let item of _data["importedReleaseItems"])
                    this.importedReleaseItems.push(ReleaseItem.fromJS(item));
            }
            if (Array.isArray(_data["createdAccessoryBundles"])) {
                this.createdAccessoryBundles = [];
                for (let item of _data["createdAccessoryBundles"])
                    this.createdAccessoryBundles.push(AccessoryBundle.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [];
                for (let item of _data["warnings"])
                    this.warnings.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.totalProcessed = _data["totalProcessed"];
            this.totalImported = _data["totalImported"];
            this.totalSkipped = _data["totalSkipped"];
            this.accessoryBundlesCreated = _data["accessoryBundlesCreated"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportReleaseItemsFromCsvResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importedReleaseItems)) {
            data["importedReleaseItems"] = [];
            for (let item of this.importedReleaseItems)
                data["importedReleaseItems"].push(item.toJSON());
        }
        if (Array.isArray(this.createdAccessoryBundles)) {
            data["createdAccessoryBundles"] = [];
            for (let item of this.createdAccessoryBundles)
                data["createdAccessoryBundles"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["totalProcessed"] = this.totalProcessed;
        data["totalImported"] = this.totalImported;
        data["totalSkipped"] = this.totalSkipped;
        data["accessoryBundlesCreated"] = this.accessoryBundlesCreated;
        super.toJSON(data);
        return data;
    }
}
export class AddReleaseIssueResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.releaseIssueId = _data["releaseIssueId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddReleaseIssueResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["releaseIssueId"] = this.releaseIssueId;
        super.toJSON(data);
        return data;
    }
}
export class AddReleaseIssueRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseItemId = _data["releaseItemId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.reportedSituLink = _data["reportedSituLink"];
            this.productName = _data["productName"];
            this.releaseIssuePriority = _data["releaseIssuePriority"];
            this.assignedToName = _data["assignedToName"];
            this.assignedTo = _data["assignedTo"];
            this.releaseIssueCategory = _data["releaseIssueCategory"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddReleaseIssueRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseItemId"] = this.releaseItemId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["reportedSituLink"] = this.reportedSituLink;
        data["productName"] = this.productName;
        data["releaseIssuePriority"] = this.releaseIssuePriority;
        data["assignedToName"] = this.assignedToName;
        data["assignedTo"] = this.assignedTo;
        data["releaseIssueCategory"] = this.releaseIssueCategory;
        return data;
    }
}
export var ReleaseIssuePriority;
(function (ReleaseIssuePriority) {
    ReleaseIssuePriority[ReleaseIssuePriority["Low"] = 1] = "Low";
    ReleaseIssuePriority[ReleaseIssuePriority["Medium"] = 2] = "Medium";
    ReleaseIssuePriority[ReleaseIssuePriority["High"] = 3] = "High";
})(ReleaseIssuePriority || (ReleaseIssuePriority = {}));
export var ReleaseIssueCategory;
(function (ReleaseIssueCategory) {
    ReleaseIssueCategory[ReleaseIssueCategory["Drawing"] = 1] = "Drawing";
    ReleaseIssueCategory[ReleaseIssueCategory["Theming"] = 2] = "Theming";
    ReleaseIssueCategory[ReleaseIssueCategory["Software"] = 3] = "Software";
})(ReleaseIssueCategory || (ReleaseIssueCategory = {}));
export class UpdateReleaseIssueResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseIssueResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateReleaseIssueRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.releaseIssueId = _data["releaseIssueId"];
            this.companyId = _data["companyId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.reportedSituLink = _data["reportedSituLink"];
            this.releaseIssuePriority = _data["releaseIssuePriority"];
            this.releaseIssueStatus = _data["releaseIssueStatus"];
            this.releaseIssueCategory = _data["releaseIssueCategory"];
            this.assignedToName = _data["assignedToName"];
            this.assignedTo = _data["assignedTo"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseIssueRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["releaseIssueId"] = this.releaseIssueId;
        data["companyId"] = this.companyId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["reportedSituLink"] = this.reportedSituLink;
        data["releaseIssuePriority"] = this.releaseIssuePriority;
        data["releaseIssueStatus"] = this.releaseIssueStatus;
        data["releaseIssueCategory"] = this.releaseIssueCategory;
        data["assignedToName"] = this.assignedToName;
        data["assignedTo"] = this.assignedTo;
        return data;
    }
}
export var ReleaseIssueStatus;
(function (ReleaseIssueStatus) {
    ReleaseIssueStatus[ReleaseIssueStatus["Unassigned"] = 1] = "Unassigned";
    ReleaseIssueStatus[ReleaseIssueStatus["Assigned"] = 2] = "Assigned";
    ReleaseIssueStatus[ReleaseIssueStatus["InProgress"] = 3] = "InProgress";
    ReleaseIssueStatus[ReleaseIssueStatus["Complete"] = 4] = "Complete";
    ReleaseIssueStatus[ReleaseIssueStatus["CompleteNonIssue"] = 5] = "CompleteNonIssue";
})(ReleaseIssueStatus || (ReleaseIssueStatus = {}));
export class PagedResponseOfReleaseIssue extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ReleaseIssue.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfReleaseIssue();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListReleaseIssuesResponse extends PagedResponseOfReleaseIssue {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListReleaseIssuesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ReleaseIssue {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.releaseIssueStatus = _data["releaseIssueStatus"];
            this.releaseIssuePriority = _data["releaseIssuePriority"];
            this.clickUpTaskId = _data["clickUpTaskId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.assignedTo = _data["assignedTo"];
            this.assignedToName = _data["assignedToName"];
            this.reportedSituLink = _data["reportedSituLink"];
            this.totalReleases = _data["totalReleases"];
            this.totalReleaseItems = _data["totalReleaseItems"];
            this.productName = _data["productName"];
            this.releaseIssueCategory = _data["releaseIssueCategory"];
            if (Array.isArray(_data["releaseItems"])) {
                this.releaseItems = [];
                for (let item of _data["releaseItems"])
                    this.releaseItems.push(ReleaseItem.fromJS(item));
            }
            if (Array.isArray(_data["releaseIssueReleaseItems"])) {
                this.releaseIssueReleaseItems = [];
                for (let item of _data["releaseIssueReleaseItems"])
                    this.releaseIssueReleaseItems.push(ReleaseIssueReleaseItem.fromJS(item));
            }
            if (Array.isArray(_data["releaseIssueTags"])) {
                this.releaseIssueTags = [];
                for (let item of _data["releaseIssueTags"])
                    this.releaseIssueTags.push(ReleaseIssueTag.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseIssue();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["releaseIssueStatus"] = this.releaseIssueStatus;
        data["releaseIssuePriority"] = this.releaseIssuePriority;
        data["clickUpTaskId"] = this.clickUpTaskId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["assignedTo"] = this.assignedTo;
        data["assignedToName"] = this.assignedToName;
        data["reportedSituLink"] = this.reportedSituLink;
        data["totalReleases"] = this.totalReleases;
        data["totalReleaseItems"] = this.totalReleaseItems;
        data["productName"] = this.productName;
        data["releaseIssueCategory"] = this.releaseIssueCategory;
        if (Array.isArray(this.releaseItems)) {
            data["releaseItems"] = [];
            for (let item of this.releaseItems)
                data["releaseItems"].push(item.toJSON());
        }
        if (Array.isArray(this.releaseIssueReleaseItems)) {
            data["releaseIssueReleaseItems"] = [];
            for (let item of this.releaseIssueReleaseItems)
                data["releaseIssueReleaseItems"].push(item.toJSON());
        }
        if (Array.isArray(this.releaseIssueTags)) {
            data["releaseIssueTags"] = [];
            for (let item of this.releaseIssueTags)
                data["releaseIssueTags"].push(item.toJSON());
        }
        return data;
    }
}
export class ReleaseIssueTag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.releaseIssueId = _data["releaseIssueId"];
            this.tagId = _data["tagId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseIssueTag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["releaseIssueId"] = this.releaseIssueId;
        data["tagId"] = this.tagId;
        return data;
    }
}
export class ListReleaseIssuesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.containsWord = _data["containsWord"];
            this.includeStats = _data["includeStats"];
            this.includeRefs = _data["includeRefs"];
            this.releaseId = _data["releaseId"];
            this.priority = _data["priority"];
            this.status = _data["status"];
            this.renderedOutputId = _data["renderedOutputId"];
            this.releaseItemId = _data["releaseItemId"];
            this.productName = _data["productName"];
            this.category = _data["category"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListReleaseIssuesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["containsWord"] = this.containsWord;
        data["includeStats"] = this.includeStats;
        data["includeRefs"] = this.includeRefs;
        data["releaseId"] = this.releaseId;
        data["priority"] = this.priority;
        data["status"] = this.status;
        data["renderedOutputId"] = this.renderedOutputId;
        data["releaseItemId"] = this.releaseItemId;
        data["productName"] = this.productName;
        data["category"] = this.category;
        super.toJSON(data);
        return data;
    }
}
export class GetReleaseIssueResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.releaseIssue = _data["releaseIssue"] ? ReleaseIssue.fromJS(_data["releaseIssue"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReleaseIssueResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["releaseIssue"] = this.releaseIssue ? this.releaseIssue.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetReleaseIssueRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseIssueId = _data["releaseIssueId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReleaseIssueRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseIssueId"] = this.releaseIssueId;
        return data;
    }
}
export class AssignReleaseIssueTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignReleaseIssueTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class AssignReleaseIssueTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.tagId = _data["tagId"];
            this.releaseIssueId = _data["releaseIssueId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignReleaseIssueTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["tagId"] = this.tagId;
        data["releaseIssueId"] = this.releaseIssueId;
        return data;
    }
}
export class RemoveReleaseIssueTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveReleaseIssueTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RemoveReleaseIssueTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.tagId = _data["tagId"];
            this.releaseIssueId = _data["releaseIssueId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveReleaseIssueTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["tagId"] = this.tagId;
        data["releaseIssueId"] = this.releaseIssueId;
        return data;
    }
}
export class AddReleaseItemResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.releaseItemId = _data["releaseItemId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddReleaseItemResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["releaseItemId"] = this.releaseItemId;
        super.toJSON(data);
        return data;
    }
}
export class AddReleaseItemRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseId = _data["releaseId"];
            this.homeId = _data["homeId"];
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigTemplate = _data["styleConfigTemplate"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddReleaseItemRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseId"] = this.releaseId;
        data["homeId"] = this.homeId;
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigTemplate"] = this.styleConfigTemplate;
        data["productName"] = this.productName;
        return data;
    }
}
export class UpdateReleaseItemResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseItemResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateReleaseItemRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseItemId = _data["releaseItemId"];
            this.releaseStatus = _data["releaseStatus"];
            this.comments = _data["comments"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseItemRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseItemId"] = this.releaseItemId;
        data["releaseStatus"] = this.releaseStatus;
        data["comments"] = this.comments;
        return data;
    }
}
export class PagedResponseOfReleaseItem extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ReleaseItem.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfReleaseItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListReleaseItemsResponse extends PagedResponseOfReleaseItem {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListReleaseItemsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ListReleaseItemsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseId = _data["releaseId"];
            this.renderedOutputId = _data["renderedOutputId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListReleaseItemsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseId"] = this.releaseId;
        data["renderedOutputId"] = this.renderedOutputId;
        super.toJSON(data);
        return data;
    }
}
export class BulkUpdateReleaseItemsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateReleaseItemsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class BulkUpdateReleaseItemsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["releaseItemIds"])) {
                this.releaseItemIds = [];
                for (let item of _data["releaseItemIds"])
                    this.releaseItemIds.push(item);
            }
            this.releaseItemFieldToUpdate = _data["releaseItemFieldToUpdate"];
            this.releaseStatus = _data["releaseStatus"];
            this.comments = _data["comments"];
            this.supportTicket = _data["supportTicket"];
            this.releaseIssueId = _data["releaseIssueId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateReleaseItemsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.releaseItemIds)) {
            data["releaseItemIds"] = [];
            for (let item of this.releaseItemIds)
                data["releaseItemIds"].push(item);
        }
        data["releaseItemFieldToUpdate"] = this.releaseItemFieldToUpdate;
        data["releaseStatus"] = this.releaseStatus;
        data["comments"] = this.comments;
        data["supportTicket"] = this.supportTicket;
        data["releaseIssueId"] = this.releaseIssueId;
        return data;
    }
}
export var ReleaseItemFieldToUpdate;
(function (ReleaseItemFieldToUpdate) {
    ReleaseItemFieldToUpdate[ReleaseItemFieldToUpdate["ReleaseStatus"] = 0] = "ReleaseStatus";
    ReleaseItemFieldToUpdate[ReleaseItemFieldToUpdate["Comments"] = 1] = "Comments";
    ReleaseItemFieldToUpdate[ReleaseItemFieldToUpdate["SupportTicket"] = 2] = "SupportTicket";
    ReleaseItemFieldToUpdate[ReleaseItemFieldToUpdate["Delete"] = 3] = "Delete";
    ReleaseItemFieldToUpdate[ReleaseItemFieldToUpdate["AssignToReleaseIssue"] = 4] = "AssignToReleaseIssue";
})(ReleaseItemFieldToUpdate || (ReleaseItemFieldToUpdate = {}));
export class SetReleaseItemViewedResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetReleaseItemViewedResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetReleaseItemViewedRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.releaseId = _data["releaseId"];
            this.releaseItemId = _data["releaseItemId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetReleaseItemViewedRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["releaseId"] = this.releaseId;
        data["releaseItemId"] = this.releaseItemId;
        return data;
    }
}
export class GetRenderedOutputResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.styledHomeId = _data["styledHomeId"];
            this.homeId = _data["homeId"];
            this.homeConfigId = _data["homeConfigId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfigSlim.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfigId = _data["styleConfigId"];
            this.artifactId = _data["artifactId"];
            this.parentRenderedOutputId = _data["parentRenderedOutputId"];
            this.productName = _data["productName"];
            this.isProduction = _data["isProduction"];
            this.status = _data["status"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.createdByName = _data["createdByName"];
            this.queuePosition = _data["queuePosition"];
            this.parentRenderedOutput = _data["parentRenderedOutput"] ? RenderedOutputSlim.fromJS(_data["parentRenderedOutput"]) : undefined;
            this.styleConfigTemplate = _data["styleConfigTemplate"] ? StyleConfigTemplateSlim.fromJS(_data["styleConfigTemplate"]) : undefined;
            if (Array.isArray(_data["sourceArtifacts"])) {
                this.sourceArtifacts = [];
                for (let item of _data["sourceArtifacts"])
                    this.sourceArtifacts.push(RenderedOutputSourceArtifactSlim.fromJS(item));
            }
            if (Array.isArray(_data["renderedOutputChildren"])) {
                this.renderedOutputChildren = [];
                for (let item of _data["renderedOutputChildren"])
                    this.renderedOutputChildren.push(RenderedOutput.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRenderedOutputResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["styledHomeId"] = this.styledHomeId;
        data["homeId"] = this.homeId;
        data["homeConfigId"] = this.homeConfigId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfigId"] = this.styleConfigId;
        data["artifactId"] = this.artifactId;
        data["parentRenderedOutputId"] = this.parentRenderedOutputId;
        data["productName"] = this.productName;
        data["isProduction"] = this.isProduction;
        data["status"] = this.status;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["createdByName"] = this.createdByName;
        data["queuePosition"] = this.queuePosition;
        data["parentRenderedOutput"] = this.parentRenderedOutput ? this.parentRenderedOutput.toJSON() : undefined;
        data["styleConfigTemplate"] = this.styleConfigTemplate ? this.styleConfigTemplate.toJSON() : undefined;
        if (Array.isArray(this.sourceArtifacts)) {
            data["sourceArtifacts"] = [];
            for (let item of this.sourceArtifacts)
                data["sourceArtifacts"].push(item.toJSON());
        }
        if (Array.isArray(this.renderedOutputChildren)) {
            data["renderedOutputChildren"] = [];
            for (let item of this.renderedOutputChildren)
                data["renderedOutputChildren"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetSituFacadeResponse extends GetRenderedOutputResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.facadeConfigName = _data["facadeConfigName"];
            if (_data["versionHistory"]) {
                this.versionHistory = {};
                for (let key in _data["versionHistory"]) {
                    if (_data["versionHistory"].hasOwnProperty(key))
                        this.versionHistory[key] = _data["versionHistory"][key] ? new Date(_data["versionHistory"][key].toString()) : undefined;
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["facadeConfigName"] = this.facadeConfigName;
        if (this.versionHistory) {
            data["versionHistory"] = {};
            for (let key in this.versionHistory) {
                if (this.versionHistory.hasOwnProperty(key))
                    data["versionHistory"][key] = this.versionHistory[key] ? this.versionHistory[key].toISOString() : undefined;
            }
        }
        super.toJSON(data);
        return data;
    }
}
export class HomeConfigSlim {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"];
            this.companyId = _data["companyId"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeConfigSlim();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company;
        data["companyId"] = this.companyId;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}
export var RenderedOutputStatus;
(function (RenderedOutputStatus) {
    RenderedOutputStatus[RenderedOutputStatus["Queued"] = 0] = "Queued";
    RenderedOutputStatus[RenderedOutputStatus["InProgress"] = 1] = "InProgress";
    RenderedOutputStatus[RenderedOutputStatus["Complete"] = 2] = "Complete";
    RenderedOutputStatus[RenderedOutputStatus["Failed"] = 3] = "Failed";
    RenderedOutputStatus[RenderedOutputStatus["Cancelled"] = 4] = "Cancelled";
})(RenderedOutputStatus || (RenderedOutputStatus = {}));
export class RenderedOutputSlim {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.artifactId = _data["artifactId"];
            this.parentRenderedOutputId = _data["parentRenderedOutputId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RenderedOutputSlim();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["artifactId"] = this.artifactId;
        data["parentRenderedOutputId"] = this.parentRenderedOutputId;
        return data;
    }
}
export class StyleConfigTemplateSlim {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleConfigTemplateSlim();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class RenderedOutputSourceArtifactSlim {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RenderedOutputSourceArtifactSlim();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class RenderedOutput {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.styledHomeId = _data["styledHomeId"];
            this.homeId = _data["homeId"];
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigId = _data["styleConfigId"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.artifactId = _data["artifactId"];
            this.parentRenderedOutputId = _data["parentRenderedOutputId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.productName = _data["productName"];
            this.isProduction = _data["isProduction"];
            this.status = _data["status"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.styledHome = _data["styledHome"] ? StyledHome.fromJS(_data["styledHome"]) : undefined;
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfigTemplate = _data["styleConfigTemplate"] ? StyleConfigTemplate.fromJS(_data["styleConfigTemplate"]) : undefined;
            if (Array.isArray(_data["productionHistory"])) {
                this.productionHistory = [];
                for (let item of _data["productionHistory"])
                    this.productionHistory.push(RenderedOutputProductionHistory.fromJS(item));
            }
            if (Array.isArray(_data["sourceArtifacts"])) {
                this.sourceArtifacts = [];
                for (let item of _data["sourceArtifacts"])
                    this.sourceArtifacts.push(RenderedOutputSourceArtifact.fromJS(item));
            }
            if (Array.isArray(_data["renderedOutputChildren"])) {
                this.renderedOutputChildren = [];
                for (let item of _data["renderedOutputChildren"])
                    this.renderedOutputChildren.push(RenderedOutput.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RenderedOutput();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["styledHomeId"] = this.styledHomeId;
        data["homeId"] = this.homeId;
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigId"] = this.styleConfigId;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["artifactId"] = this.artifactId;
        data["parentRenderedOutputId"] = this.parentRenderedOutputId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["productName"] = this.productName;
        data["isProduction"] = this.isProduction;
        data["status"] = this.status;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["styledHome"] = this.styledHome ? this.styledHome.toJSON() : undefined;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfigTemplate"] = this.styleConfigTemplate ? this.styleConfigTemplate.toJSON() : undefined;
        if (Array.isArray(this.productionHistory)) {
            data["productionHistory"] = [];
            for (let item of this.productionHistory)
                data["productionHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceArtifacts)) {
            data["sourceArtifacts"] = [];
            for (let item of this.sourceArtifacts)
                data["sourceArtifacts"].push(item.toJSON());
        }
        if (Array.isArray(this.renderedOutputChildren)) {
            data["renderedOutputChildren"] = [];
            for (let item of this.renderedOutputChildren)
                data["renderedOutputChildren"].push(item.toJSON());
        }
        return data;
    }
}
export class StyledHome {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigId = _data["styleConfigId"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.home = _data["home"] ? Home.fromJS(_data["home"]) : undefined;
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfig = _data["styleConfig"] ? StyleConfig.fromJS(_data["styleConfig"]) : undefined;
            this.styleConfigTemplate = _data["styleConfigTemplate"] ? StyleConfigTemplate.fromJS(_data["styleConfigTemplate"]) : undefined;
            if (Array.isArray(_data["renderedOutputs"])) {
                this.renderedOutputs = [];
                for (let item of _data["renderedOutputs"])
                    this.renderedOutputs.push(RenderedOutput.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyledHome();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigId"] = this.styleConfigId;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["home"] = this.home ? this.home.toJSON() : undefined;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfig"] = this.styleConfig ? this.styleConfig.toJSON() : undefined;
        data["styleConfigTemplate"] = this.styleConfigTemplate ? this.styleConfigTemplate.toJSON() : undefined;
        if (Array.isArray(this.renderedOutputs)) {
            data["renderedOutputs"] = [];
            for (let item of this.renderedOutputs)
                data["renderedOutputs"].push(item.toJSON());
        }
        return data;
    }
}
export class Home {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.isHidden = _data["isHidden"];
            this.dateLastRendered = _data["dateLastRendered"] ? new Date(_data["dateLastRendered"].toString()) : undefined;
            this.dateLastRaytracedPlusRendered = _data["dateLastRaytracedPlusRendered"] ? new Date(_data["dateLastRaytracedPlusRendered"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Home();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["isHidden"] = this.isHidden;
        data["dateLastRendered"] = this.dateLastRendered ? this.dateLastRendered.toISOString() : undefined;
        data["dateLastRaytracedPlusRendered"] = this.dateLastRaytracedPlusRendered ? this.dateLastRaytracedPlusRendered.toISOString() : undefined;
        return data;
    }
}
export class StyleConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.styleConfigTemplate = _data["styleConfigTemplate"] ? StyleConfigTemplate.fromJS(_data["styleConfigTemplate"]) : undefined;
            if (Array.isArray(_data["styleConfigStyles"])) {
                this.styleConfigStyles = [];
                for (let item of _data["styleConfigStyles"])
                    this.styleConfigStyles.push(StyleConfigStyle.fromJS(item));
            }
            if (Array.isArray(_data["styledHomes"])) {
                this.styledHomes = [];
                for (let item of _data["styledHomes"])
                    this.styledHomes.push(StyledHome.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["styleConfigTemplate"] = this.styleConfigTemplate ? this.styleConfigTemplate.toJSON() : undefined;
        if (Array.isArray(this.styleConfigStyles)) {
            data["styleConfigStyles"] = [];
            for (let item of this.styleConfigStyles)
                data["styleConfigStyles"].push(item.toJSON());
        }
        if (Array.isArray(this.styledHomes)) {
            data["styledHomes"] = [];
            for (let item of this.styledHomes)
                data["styledHomes"].push(item.toJSON());
        }
        return data;
    }
}
export class StyleConfigTemplate {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.tagId = _data["tagId"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.productName = _data["productName"];
            this.isHidden = _data["isHidden"];
            this.home = _data["home"] ? Home.fromJS(_data["home"]) : undefined;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleConfigTemplate();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["tagId"] = this.tagId;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["productName"] = this.productName;
        data["isHidden"] = this.isHidden;
        data["home"] = this.home ? this.home.toJSON() : undefined;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined;
        return data;
    }
}
export class Tag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.borderColour = _data["borderColour"];
            this.backgroundColour = _data["backgroundColour"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["authorisedRoles"])) {
                this.authorisedRoles = [];
                for (let item of _data["authorisedRoles"])
                    this.authorisedRoles.push(TagRole.fromJS(item));
            }
            this.resourceType = _data["resourceType"];
            this.isDeleted = _data["isDeleted"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.dateDeleted = _data["dateDeleted"] ? new Date(_data["dateDeleted"].toString()) : undefined;
            this.updatedBy = _data["updatedBy"];
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["borderColour"] = this.borderColour;
        data["backgroundColour"] = this.backgroundColour;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.authorisedRoles)) {
            data["authorisedRoles"] = [];
            for (let item of this.authorisedRoles)
                data["authorisedRoles"].push(item.toJSON());
        }
        data["resourceType"] = this.resourceType;
        data["isDeleted"] = this.isDeleted;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["dateDeleted"] = this.dateDeleted ? this.dateDeleted.toISOString() : undefined;
        data["updatedBy"] = this.updatedBy;
        data["category"] = this.category ? this.category.toJSON() : undefined;
        return data;
    }
}
export class TagRole {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TagRole();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class Category {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class StyleConfigStyle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.styleConfigId = _data["styleConfigId"];
            this.styleId = _data["styleId"];
            this.order = _data["order"];
            this.styleConfig = _data["styleConfig"] ? StyleConfig.fromJS(_data["styleConfig"]) : undefined;
            this.style = _data["style"] ? Style.fromJS(_data["style"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleConfigStyle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["styleConfigId"] = this.styleConfigId;
        data["styleId"] = this.styleId;
        data["order"] = this.order;
        data["styleConfig"] = this.styleConfig ? this.styleConfig.toJSON() : undefined;
        data["style"] = this.style ? this.style.toJSON() : undefined;
        return data;
    }
}
export class Style {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.themeName = _data["themeName"];
            this.themeType = _data["themeType"];
            this.styleCategoryId = _data["styleCategoryId"];
            this.companyId = _data["companyId"];
            this.themeId = _data["themeId"];
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.isHidden = _data["isHidden"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.styleCategory = _data["styleCategory"] ? StyleCategory.fromJS(_data["styleCategory"]) : undefined;
            this.theme = _data["theme"] ? Theme.fromJS(_data["theme"]) : undefined;
            if (Array.isArray(_data["styleConfigStyles"])) {
                this.styleConfigStyles = [];
                for (let item of _data["styleConfigStyles"])
                    this.styleConfigStyles.push(StyleConfigStyle.fromJS(item));
            }
            if (Array.isArray(_data["styleConfigTemplateStyles"])) {
                this.styleConfigTemplateStyles = [];
                for (let item of _data["styleConfigTemplateStyles"])
                    this.styleConfigTemplateStyles.push(StyleConfigTemplateStyle.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Style();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["themeName"] = this.themeName;
        data["themeType"] = this.themeType;
        data["styleCategoryId"] = this.styleCategoryId;
        data["companyId"] = this.companyId;
        data["themeId"] = this.themeId;
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["isHidden"] = this.isHidden;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["styleCategory"] = this.styleCategory ? this.styleCategory.toJSON() : undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        if (Array.isArray(this.styleConfigStyles)) {
            data["styleConfigStyles"] = [];
            for (let item of this.styleConfigStyles)
                data["styleConfigStyles"].push(item.toJSON());
        }
        if (Array.isArray(this.styleConfigTemplateStyles)) {
            data["styleConfigTemplateStyles"] = [];
            for (let item of this.styleConfigTemplateStyles)
                data["styleConfigTemplateStyles"].push(item.toJSON());
        }
        return data;
    }
}
export var ThemeType;
(function (ThemeType) {
    ThemeType[ThemeType["DecoratorThemes"] = 0] = "DecoratorThemes";
    ThemeType[ThemeType["FurnishingThemes"] = 1] = "FurnishingThemes";
    ThemeType[ThemeType["FurnishingPlacementSchemes"] = 2] = "FurnishingPlacementSchemes";
    ThemeType[ThemeType["ProductReplacementThemes"] = 3] = "ProductReplacementThemes";
    ThemeType[ThemeType["SceneryThemes"] = 4] = "SceneryThemes";
    ThemeType[ThemeType["ParameterThemes"] = 5] = "ParameterThemes";
    ThemeType[ThemeType["Themes"] = 6] = "Themes";
})(ThemeType || (ThemeType = {}));
export class StyleCategory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.parentStyleCategoryId = _data["parentStyleCategoryId"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isSingleSelect = _data["isSingleSelect"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.parentStyleCategory = _data["parentStyleCategory"] ? StyleCategory.fromJS(_data["parentStyleCategory"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleCategory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["parentStyleCategoryId"] = this.parentStyleCategoryId;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isSingleSelect"] = this.isSingleSelect;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["parentStyleCategory"] = this.parentStyleCategory ? this.parentStyleCategory.toJSON() : undefined;
        return data;
    }
}
export class Theme {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.disabled = _data["disabled"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined;
            this.dateLastPublished = _data["dateLastPublished"] ? new Date(_data["dateLastPublished"].toString()) : undefined;
            this.lineItemCount = _data["lineItemCount"];
            this.productCount = _data["productCount"];
            this.incompleteLineItemCount = _data["incompleteLineItemCount"];
            this.lineItemsMissingTag = _data["lineItemsMissingTag"];
            this.lineItemsMissingProduct = _data["lineItemsMissingProduct"];
            this.productsNotLive = _data["productsNotLive"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Theme();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["disabled"] = this.disabled;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined;
        data["dateLastPublished"] = this.dateLastPublished ? this.dateLastPublished.toISOString() : undefined;
        data["lineItemCount"] = this.lineItemCount;
        data["productCount"] = this.productCount;
        data["incompleteLineItemCount"] = this.incompleteLineItemCount;
        data["lineItemsMissingTag"] = this.lineItemsMissingTag;
        data["lineItemsMissingProduct"] = this.lineItemsMissingProduct;
        data["productsNotLive"] = this.productsNotLive;
        return data;
    }
}
export class StyleConfigTemplateStyle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.styleId = _data["styleId"];
            this.order = _data["order"];
            this.styleConfigTemplate = _data["styleConfigTemplate"] ? StyleConfigTemplate.fromJS(_data["styleConfigTemplate"]) : undefined;
            this.style = _data["style"] ? Style.fromJS(_data["style"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleConfigTemplateStyle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["styleId"] = this.styleId;
        data["order"] = this.order;
        data["styleConfigTemplate"] = this.styleConfigTemplate ? this.styleConfigTemplate.toJSON() : undefined;
        data["style"] = this.style ? this.style.toJSON() : undefined;
        return data;
    }
}
export class RenderedOutputProductionHistory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.renderedOutputId = _data["renderedOutputId"];
            this.dateTimeStamp = _data["dateTimeStamp"] ? new Date(_data["dateTimeStamp"].toString()) : undefined;
            this.userId = _data["userId"];
            this.renderedOutput = _data["renderedOutput"] ? RenderedOutput.fromJS(_data["renderedOutput"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RenderedOutputProductionHistory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["renderedOutputId"] = this.renderedOutputId;
        data["dateTimeStamp"] = this.dateTimeStamp ? this.dateTimeStamp.toISOString() : undefined;
        data["userId"] = this.userId;
        data["renderedOutput"] = this.renderedOutput ? this.renderedOutput.toJSON() : undefined;
        return data;
    }
}
export class RenderedOutputSourceArtifact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.renderedOutputId = _data["renderedOutputId"];
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.styleId = _data["styleId"];
            this.homeIfcFileId = _data["homeIfcFileId"];
            this.renderedOutput = _data["renderedOutput"] ? RenderedOutput.fromJS(_data["renderedOutput"]) : undefined;
            this.style = _data["style"] ? Style.fromJS(_data["style"]) : undefined;
            this.homeIfcFile = _data["homeIfcFile"] ? HomeIfcFile.fromJS(_data["homeIfcFile"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RenderedOutputSourceArtifact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["renderedOutputId"] = this.renderedOutputId;
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["styleId"] = this.styleId;
        data["homeIfcFileId"] = this.homeIfcFileId;
        data["renderedOutput"] = this.renderedOutput ? this.renderedOutput.toJSON() : undefined;
        data["style"] = this.style ? this.style.toJSON() : undefined;
        data["homeIfcFile"] = this.homeIfcFile ? this.homeIfcFile.toJSON() : undefined;
        return data;
    }
}
export class HomeIfcFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.ifcPreviewArtifactId = _data["ifcPreviewArtifactId"];
            this.ifcPreviewStoreysInArtifact = _data["ifcPreviewStoreysInArtifact"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.isHidden = _data["isHidden"];
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.isAccessory = _data["isAccessory"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.home = _data["home"] ? Home.fromJS(_data["home"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeIfcFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["ifcPreviewArtifactId"] = this.ifcPreviewArtifactId;
        data["ifcPreviewStoreysInArtifact"] = this.ifcPreviewStoreysInArtifact;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["isHidden"] = this.isHidden;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["isAccessory"] = this.isAccessory;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["home"] = this.home ? this.home.toJSON() : undefined;
        return data;
    }
}
export var HomeIfcFileType;
(function (HomeIfcFileType) {
    HomeIfcFileType[HomeIfcFileType["Master"] = 0] = "Master";
    HomeIfcFileType[HomeIfcFileType["Option"] = 1] = "Option";
})(HomeIfcFileType || (HomeIfcFileType = {}));
export class CreateSituFacadeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.configurationName = _data["configurationName"];
            this.queueName = _data["queueName"];
            this.environmentOverride = _data["environmentOverride"] ? ArtifactEnvironment.fromJS(_data["environmentOverride"]) : undefined;
            this.accessoryBundleId = _data["accessoryBundleId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituFacadeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["configurationName"] = this.configurationName;
        data["queueName"] = this.queueName;
        data["environmentOverride"] = this.environmentOverride ? this.environmentOverride.toJSON() : undefined;
        data["accessoryBundleId"] = this.accessoryBundleId;
        return data;
    }
}
export class ArtifactEnvironment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.company = _data["company"];
            this.environment = _data["environment"];
            this.product = _data["product"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactEnvironment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["environment"] = this.environment;
        data["product"] = this.product;
        return data;
    }
}
export var EnvironmentName;
(function (EnvironmentName) {
    EnvironmentName[EnvironmentName["Latest"] = 0] = "Latest";
    EnvironmentName[EnvironmentName["Staging"] = 1] = "Staging";
    EnvironmentName[EnvironmentName["Production"] = 2] = "Production";
    EnvironmentName[EnvironmentName["Fallback"] = 3] = "Fallback";
})(EnvironmentName || (EnvironmentName = {}));
export class CreateSituFacadeWithNamesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.artifactId = _data["artifactId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfigSlim.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfigName = _data["styleConfigName"];
            this.configurationName = _data["configurationName"];
            this.queueName = _data["queueName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituFacadeWithNamesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["artifactId"] = this.artifactId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfigName"] = this.styleConfigName;
        data["configurationName"] = this.configurationName;
        data["queueName"] = this.queueName;
        return data;
    }
}
export class CreateSituFacadeChildRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.renderedOutputId = _data["renderedOutputId"];
            this.configurationName = _data["configurationName"];
            this.queueName = _data["queueName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituFacadeChildRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["renderedOutputId"] = this.renderedOutputId;
        data["configurationName"] = this.configurationName;
        data["queueName"] = this.queueName;
        return data;
    }
}
export class GetSituFacadeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.renderedOutputId = _data["renderedOutputId"];
            this.includeHistory = _data["includeHistory"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["renderedOutputId"] = this.renderedOutputId;
        data["includeHistory"] = this.includeHistory;
        return data;
    }
}
export class GetSituFacadeWithIdsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigName = _data["styleConfigName"];
            this.configName = _data["configName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeWithIdsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigName"] = this.styleConfigName;
        data["configName"] = this.configName;
        return data;
    }
}
export class GetSituFacadeWithNamesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfig = _data["homeConfig"] ? HomeConfigSlim.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfigName = _data["styleConfigName"];
            this.configName = _data["configName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeWithNamesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfigName"] = this.styleConfigName;
        data["configName"] = this.configName;
        return data;
    }
}
export class DownloadSituFacadesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["facadeIds"])) {
                this.facadeIds = [];
                for (let item of _data["facadeIds"])
                    this.facadeIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSituFacadesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.facadeIds)) {
            data["facadeIds"] = [];
            for (let item of this.facadeIds)
                data["facadeIds"].push(item);
        }
        return data;
    }
}
export class ImportStyleTemplatesFromCsvResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.templatesCreated = _data["templatesCreated"];
            this.templatesUpdated = _data["templatesUpdated"];
            this.totalProcessed = _data["totalProcessed"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [];
                for (let item of _data["warnings"])
                    this.warnings.push(item);
            }
            if (Array.isArray(_data["results"])) {
                this.results = [];
                for (let item of _data["results"])
                    this.results.push(StyleTemplateImportResult.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportStyleTemplatesFromCsvResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["templatesCreated"] = this.templatesCreated;
        data["templatesUpdated"] = this.templatesUpdated;
        data["totalProcessed"] = this.totalProcessed;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class StyleTemplateImportResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.templateName = _data["templateName"];
            this.templateId = _data["templateId"];
            this.isNew = _data["isNew"];
            this.stylesCount = _data["stylesCount"];
            this.tagName = _data["tagName"];
            if (Array.isArray(_data["missingStyles"])) {
                this.missingStyles = [];
                for (let item of _data["missingStyles"])
                    this.missingStyles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleTemplateImportResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["templateId"] = this.templateId;
        data["isNew"] = this.isNew;
        data["stylesCount"] = this.stylesCount;
        data["tagName"] = this.tagName;
        if (Array.isArray(this.missingStyles)) {
            data["missingStyles"] = [];
            for (let item of this.missingStyles)
                data["missingStyles"].push(item);
        }
        return data;
    }
}
export class GetAcceptanceResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.hasAcceptedLatest = _data["hasAcceptedLatest"];
            this.hasAcceptedBefore = _data["hasAcceptedBefore"];
            this.dateAccepted = _data["dateAccepted"] ? new Date(_data["dateAccepted"].toString()) : undefined;
            this.termsAndConditionsId = _data["termsAndConditionsId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.ianaLanguageSubtag = _data["ianaLanguageSubtag"];
            this.gracePeriodInDays = _data["gracePeriodInDays"];
            this.documentLink = _data["documentLink"];
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.patch = _data["patch"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptanceResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["hasAcceptedLatest"] = this.hasAcceptedLatest;
        data["hasAcceptedBefore"] = this.hasAcceptedBefore;
        data["dateAccepted"] = this.dateAccepted ? this.dateAccepted.toISOString() : undefined;
        data["termsAndConditionsId"] = this.termsAndConditionsId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["ianaLanguageSubtag"] = this.ianaLanguageSubtag;
        data["gracePeriodInDays"] = this.gracePeriodInDays;
        data["documentLink"] = this.documentLink;
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["patch"] = this.patch;
        super.toJSON(data);
        return data;
    }
}
export class GetAcceptanceRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.resourceId = _data["resourceId"];
            this.documentType = _data["documentType"];
            this.ianaLanguageSubtag = _data["ianaLanguageSubtag"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptanceRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["resourceId"] = this.resourceId;
        data["documentType"] = this.documentType;
        data["ianaLanguageSubtag"] = this.ianaLanguageSubtag;
        return data;
    }
}
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["License"] = 0] = "License";
    DocumentType[DocumentType["Partnership"] = 1] = "Partnership";
})(DocumentType || (DocumentType = {}));
export class GetArtifactProgressResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.homeConfigId = _data["homeConfigId"];
            this.recipeFingerprint = _data["recipeFingerprint"];
            this.estimatedCompletionTime = _data["estimatedCompletionTime"] ? new Date(_data["estimatedCompletionTime"].toString()) : undefined;
            this.expectedNumberOfFiles = _data["expectedNumberOfFiles"];
            this.positionInQueue = _data["positionInQueue"];
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(HomeConfigFile.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactProgressResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["homeConfigId"] = this.homeConfigId;
        data["recipeFingerprint"] = this.recipeFingerprint;
        data["estimatedCompletionTime"] = this.estimatedCompletionTime ? this.estimatedCompletionTime.toISOString() : undefined;
        data["expectedNumberOfFiles"] = this.expectedNumberOfFiles;
        data["positionInQueue"] = this.positionInQueue;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class HomeConfigFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.homeConfigId = _data["homeConfigId"];
            this.fileName = _data["fileName"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.url = _data["url"];
            this.renderRequestId = _data["renderRequestId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeConfigFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeConfigId"] = this.homeConfigId;
        data["fileName"] = this.fileName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["url"] = this.url;
        data["renderRequestId"] = this.renderRequestId;
        return data;
    }
}
export class GetArtifactProgressRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactProgressRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        return data;
    }
}
export class GetDefaultRenderedOutputResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.renderedOutputId = _data["renderedOutputId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultRenderedOutputResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["renderedOutputId"] = this.renderedOutputId;
        super.toJSON(data);
        return data;
    }
}
export class GetDefaultRenderedOutputRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.isUserRequest = _data["isUserRequest"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultRenderedOutputRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["isUserRequest"] = this.isUserRequest;
        data["productName"] = this.productName;
        return data;
    }
}
export class GetHomeArtifactResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [];
                for (let item of _data["artifacts"])
                    this.artifacts.push(Artifact.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeArtifactResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class Artifact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.version = _data["version"];
            this.active = _data["active"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.errors = _data["errors"];
            this.notes = _data["notes"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Artifact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["active"] = this.active;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["errors"] = this.errors;
        data["notes"] = this.notes;
        return data;
    }
}
export class GetHomeArtifactRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeArtifactRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        return data;
    }
}
export class GetHomeConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeId = _data["homeId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeId"] = this.homeId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        return data;
    }
}
export class GetHomeConfigIdResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeConfigIdResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeConfigIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeConfigIdRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        return data;
    }
}
export class GetHomeConfigSlimIdResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeConfigSlimIdResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeConfigSlimIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfigSlim.fromJS(_data["homeConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeConfigSlimIdRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        return data;
    }
}
export class GetHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.homeConfigId = _data["homeConfigId"];
            this.recipeFingerprint = _data["recipeFingerprint"];
            this.estimatedCompletionTime = _data["estimatedCompletionTime"] ? new Date(_data["estimatedCompletionTime"].toString()) : undefined;
            this.expectedNumberOfFiles = _data["expectedNumberOfFiles"];
            this.positionInQueue = _data["positionInQueue"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(HomeConfigFile.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["homeConfigId"] = this.homeConfigId;
        data["recipeFingerprint"] = this.recipeFingerprint;
        data["estimatedCompletionTime"] = this.estimatedCompletionTime ? this.estimatedCompletionTime.toISOString() : undefined;
        data["expectedNumberOfFiles"] = this.expectedNumberOfFiles;
        data["positionInQueue"] = this.positionInQueue;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetHomeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeId = _data["homeId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.forceRefresh = _data["forceRefresh"];
            this.renderType = _data["renderType"];
            this.startingRoom = _data["startingRoom"];
            this.artifactEnvironment = _data["artifactEnvironment"] ? ArtifactEnvironment.fromJS(_data["artifactEnvironment"]) : undefined;
            this.queueName = _data["queueName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeId"] = this.homeId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["forceRefresh"] = this.forceRefresh;
        data["renderType"] = this.renderType;
        data["startingRoom"] = this.startingRoom;
        data["artifactEnvironment"] = this.artifactEnvironment ? this.artifactEnvironment.toJSON() : undefined;
        data["queueName"] = this.queueName;
        return data;
    }
}
export var RenderType;
(function (RenderType) {
    RenderType[RenderType["Rasterized"] = 0] = "Rasterized";
    RenderType[RenderType["PathTraced"] = 1] = "PathTraced";
    RenderType[RenderType["BestAvailable"] = 2] = "BestAvailable";
    RenderType[RenderType["VirtualReality"] = 3] = "VirtualReality";
    RenderType[RenderType["SituRender"] = 4] = "SituRender";
    RenderType[RenderType["SituFacade"] = 5] = "SituFacade";
    RenderType[RenderType["SituPlan"] = 6] = "SituPlan";
    RenderType[RenderType["Insights"] = 7] = "Insights";
    RenderType[RenderType["Vanity"] = 8] = "Vanity";
    RenderType[RenderType["AssetModule"] = 9] = "AssetModule";
    RenderType[RenderType["GenericArtifact"] = 10] = "GenericArtifact";
    RenderType[RenderType["PathTracedPlus"] = 11] = "PathTracedPlus";
})(RenderType || (RenderType = {}));
export class GetHomeDetailResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ifcFiles"])) {
                this.ifcFiles = [];
                for (let item of _data["ifcFiles"])
                    this.ifcFiles.push(IfcFileArtifact.fromJS(item));
            }
            this.tempIfcFiles = _data["tempIfcFiles"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeDetailResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ifcFiles)) {
            data["ifcFiles"] = [];
            for (let item of this.ifcFiles)
                data["ifcFiles"].push(item.toJSON());
        }
        data["tempIfcFiles"] = this.tempIfcFiles;
        super.toJSON(data);
        return data;
    }
}
export class IfcFileArtifact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.isMaster = _data["isMaster"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [];
                for (let item of _data["versions"])
                    this.versions.push(IfcFileVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcFileArtifact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isMaster"] = this.isMaster;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        return data;
    }
}
export class IfcFileVersion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.version = _data["version"];
            this.active = _data["active"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [];
                for (let item of _data["products"])
                    this.products.push(item);
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [];
                for (let item of _data["zones"])
                    this.zones.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [];
                for (let item of _data["warnings"])
                    this.warnings.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            if (Array.isArray(_data["storeys"])) {
                this.storeys = [];
                for (let item of _data["storeys"])
                    this.storeys.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcFileVersion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["active"] = this.active;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.storeys)) {
            data["storeys"] = [];
            for (let item of this.storeys)
                data["storeys"].push(item);
        }
        return data;
    }
}
export class GetHomeDetailRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.home = _data["home"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeDetailRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["home"] = this.home;
        return data;
    }
}
export class GetHomeFloorplanRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.floor = _data["floor"];
            this.settings = _data["settings"] ? FloorplanSettings.fromJS(_data["settings"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeFloorplanRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["floor"] = this.floor;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined;
        return data;
    }
}
export class FloorplanSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.planScalingFactor = _data["planScalingFactor"];
            this.planImageRotation = _data["planImageRotation"];
            this.roomNameFontURL = _data["roomNameFontURL"];
            this.roomNameFontFamily = _data["roomNameFontFamily"];
            this.roomNameFontSize = _data["roomNameFontSize"];
            this.dimensionsFontURL = _data["dimensionsFontURL"];
            this.dimensionsFontFamily = _data["dimensionsFontFamily"];
            this.dimensionsFontSize = _data["dimensionsFontSize"];
            this.floorplanColour = _data["floorplanColour"];
            this.roomOutlineStrokeWidth = _data["roomOutlineStrokeWidth"];
            this.floorTileColour = _data["floorTileColour"];
            this.floorTileWidth = _data["floorTileWidth"];
            this.floorTileHeight = _data["floorTileHeight"];
            this.floorTileStrokeWidth = _data["floorTileStrokeWidth"];
            this.doorColour = _data["doorColour"];
            this.doorStrokeWidth = _data["doorStrokeWidth"];
            this.doorArcColour = _data["doorArcColour"];
            this.doorArcStrokeWidth = _data["doorArcStrokeWidth"];
            this.doorArcStrokeLength = _data["doorArcStrokeLength"];
            this.windowColour = _data["windowColour"];
            this.windowStrokeWidth = _data["windowStrokeWidth"];
            this.roomHighlightColour = _data["roomHighlightColour"];
            this.optionColour = _data["optionColour"];
            this.highlightOptions = _data["highlightOptions"];
            this.roomHighlightOpacity = _data["roomHighlightOpacity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FloorplanSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["planScalingFactor"] = this.planScalingFactor;
        data["planImageRotation"] = this.planImageRotation;
        data["roomNameFontURL"] = this.roomNameFontURL;
        data["roomNameFontFamily"] = this.roomNameFontFamily;
        data["roomNameFontSize"] = this.roomNameFontSize;
        data["dimensionsFontURL"] = this.dimensionsFontURL;
        data["dimensionsFontFamily"] = this.dimensionsFontFamily;
        data["dimensionsFontSize"] = this.dimensionsFontSize;
        data["floorplanColour"] = this.floorplanColour;
        data["roomOutlineStrokeWidth"] = this.roomOutlineStrokeWidth;
        data["floorTileColour"] = this.floorTileColour;
        data["floorTileWidth"] = this.floorTileWidth;
        data["floorTileHeight"] = this.floorTileHeight;
        data["floorTileStrokeWidth"] = this.floorTileStrokeWidth;
        data["doorColour"] = this.doorColour;
        data["doorStrokeWidth"] = this.doorStrokeWidth;
        data["doorArcColour"] = this.doorArcColour;
        data["doorArcStrokeWidth"] = this.doorArcStrokeWidth;
        data["doorArcStrokeLength"] = this.doorArcStrokeLength;
        data["windowColour"] = this.windowColour;
        data["windowStrokeWidth"] = this.windowStrokeWidth;
        data["roomHighlightColour"] = this.roomHighlightColour;
        data["optionColour"] = this.optionColour;
        data["highlightOptions"] = this.highlightOptions;
        data["roomHighlightOpacity"] = this.roomHighlightOpacity;
        return data;
    }
}
export class GetHomeIdResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeId = _data["homeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeIdResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeId"] = this.homeId;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.home = _data["home"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeIdRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["home"] = this.home;
        return data;
    }
}
export class GetIfcFileResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.ifcFile = _data["ifcFile"] ? HomeIfcFile.fromJS(_data["ifcFile"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcFileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ifcFile"] = this.ifcFile ? this.ifcFile.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetIfcFileRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeIfcFileId = _data["homeIfcFileId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcFileRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeIfcFileId"] = this.homeIfcFileId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        return data;
    }
}
export class GetIfcFileUploadStatusResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tempIfcFiles"])) {
                this.tempIfcFiles = [];
                for (let item of _data["tempIfcFiles"])
                    this.tempIfcFiles.push(TempIfcFile.fromJS(item));
            }
            if (Array.isArray(_data["tempIfcFileErrors"])) {
                this.tempIfcFileErrors = [];
                for (let item of _data["tempIfcFileErrors"])
                    this.tempIfcFileErrors.push(TempIfcFileError.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcFileUploadStatusResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tempIfcFiles)) {
            data["tempIfcFiles"] = [];
            for (let item of this.tempIfcFiles)
                data["tempIfcFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.tempIfcFileErrors)) {
            data["tempIfcFileErrors"] = [];
            for (let item of this.tempIfcFileErrors)
                data["tempIfcFileErrors"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class TempIfcFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.filePath = _data["filePath"];
            this.home = _data["home"];
            this.fileName = _data["fileName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TempIfcFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filePath"] = this.filePath;
        data["home"] = this.home;
        data["fileName"] = this.fileName;
        return data;
    }
}
export class TempIfcFileError {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.errorDate = _data["errorDate"] ? new Date(_data["errorDate"].toString()) : undefined;
            this.filePath = _data["filePath"];
            this.home = _data["home"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TempIfcFileError();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["errorDate"] = this.errorDate ? this.errorDate.toISOString() : undefined;
        data["filePath"] = this.filePath;
        data["home"] = this.home;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class GetIfcFileUploadStatusRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.homeName = _data["homeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfcFileUploadStatusRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["homeName"] = this.homeName;
        return data;
    }
}
export class GetMostPopularRenderedHomeByBuilderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.builder = _data["builder"];
            this.homeName = _data["homeName"];
            this.facade = _data["facade"];
            this.themes = _data["themes"];
            this.options = _data["options"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMostPopularRenderedHomeByBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["homeName"] = this.homeName;
        data["facade"] = this.facade;
        data["themes"] = this.themes;
        data["options"] = this.options;
        super.toJSON(data);
        return data;
    }
}
export class GetMostPopularRenderedHomeByBuilderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.home = _data["home"];
            this.theme = _data["theme"];
            this.daysPreviousToSearch = _data["daysPreviousToSearch"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMostPopularRenderedHomeByBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["home"] = this.home;
        data["theme"] = this.theme;
        data["daysPreviousToSearch"] = this.daysPreviousToSearch;
        return data;
    }
}
export class GetPlanJsonFileResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanJsonFileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}
export class GetPlanJsonFileRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.fileName = _data["fileName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanJsonFileRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["fileName"] = this.fileName;
        return data;
    }
}
export class GetProductCalloutPanelResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [];
                for (let item of _data["products"])
                    this.products.push(Product2.fromJS(item));
            }
            if (_data["productMaterial"]) {
                this.productMaterial = {};
                for (let key in _data["productMaterial"]) {
                    if (_data["productMaterial"].hasOwnProperty(key))
                        this.productMaterial[key] = _data["productMaterial"][key] ? _data["productMaterial"][key].map((i) => FileVaultMarketingItem.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["brandMaterial"])) {
                this.brandMaterial = [];
                for (let item of _data["brandMaterial"])
                    this.brandMaterial.push(FileVaultMarketingItem.fromJS(item));
            }
            if (Array.isArray(_data["companyMaterial"])) {
                this.companyMaterial = [];
                for (let item of _data["companyMaterial"])
                    this.companyMaterial.push(FileVaultMarketingItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductCalloutPanelResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.productMaterial) {
            data["productMaterial"] = {};
            for (let key in this.productMaterial) {
                if (this.productMaterial.hasOwnProperty(key))
                    data["productMaterial"][key] = this.productMaterial[key];
            }
        }
        if (Array.isArray(this.brandMaterial)) {
            data["brandMaterial"] = [];
            for (let item of this.brandMaterial)
                data["brandMaterial"].push(item.toJSON());
        }
        if (Array.isArray(this.companyMaterial)) {
            data["companyMaterial"] = [];
            for (let item of this.companyMaterial)
                data["companyMaterial"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class Product2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productTypeId = _data["productTypeId"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.hideSku = _data["hideSku"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.productUrl = _data["productUrl"];
            this.description = _data["description"];
            this.brandId = _data["brandId"];
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : undefined;
            this.qualityLevel = _data["qualityLevel"];
            this.calloutsEnabled = _data["calloutsEnabled"];
            this.previewArtifactId = _data["previewArtifactId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["productSpecificationIds"])) {
                this.productSpecificationIds = [];
                for (let item of _data["productSpecificationIds"])
                    this.productSpecificationIds.push(item);
            }
            if (Array.isArray(_data["rangeIds"])) {
                this.rangeIds = [];
                for (let item of _data["rangeIds"])
                    this.rangeIds.push(item);
            }
            this.currentWorkflowState = _data["currentWorkflowState"] ? ProductWorkflow.fromJS(_data["currentWorkflowState"]) : undefined;
            this.disabled = _data["disabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Product2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productTypeId"] = this.productTypeId;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["hideSku"] = this.hideSku;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["productUrl"] = this.productUrl;
        data["description"] = this.description;
        data["brandId"] = this.brandId;
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        data["qualityLevel"] = this.qualityLevel;
        data["calloutsEnabled"] = this.calloutsEnabled;
        data["previewArtifactId"] = this.previewArtifactId;
        data["notes"] = this.notes;
        if (Array.isArray(this.productSpecificationIds)) {
            data["productSpecificationIds"] = [];
            for (let item of this.productSpecificationIds)
                data["productSpecificationIds"].push(item);
        }
        if (Array.isArray(this.rangeIds)) {
            data["rangeIds"] = [];
            for (let item of this.rangeIds)
                data["rangeIds"].push(item);
        }
        data["currentWorkflowState"] = this.currentWorkflowState ? this.currentWorkflowState.toJSON() : undefined;
        data["disabled"] = this.disabled;
        return data;
    }
}
export class ProductWorkflow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.state = _data["state"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [];
                for (let item of _data["transitions"])
                    this.transitions.push(ProductTransition.fromJS(item));
            }
            if (Array.isArray(_data["restrictedTransitions"])) {
                this.restrictedTransitions = [];
                for (let item of _data["restrictedTransitions"])
                    this.restrictedTransitions.push(ProductTransition.fromJS(item));
            }
            this.stateType = _data["stateType"];
            if (Array.isArray(_data["roleAccessRestrictions"])) {
                this.roleAccessRestrictions = [];
                for (let item of _data["roleAccessRestrictions"])
                    this.roleAccessRestrictions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWorkflow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictedTransitions)) {
            data["restrictedTransitions"] = [];
            for (let item of this.restrictedTransitions)
                data["restrictedTransitions"].push(item.toJSON());
        }
        data["stateType"] = this.stateType;
        if (Array.isArray(this.roleAccessRestrictions)) {
            data["roleAccessRestrictions"] = [];
            for (let item of this.roleAccessRestrictions)
                data["roleAccessRestrictions"].push(item);
        }
        return data;
    }
}
export var ProductWorkflowState;
(function (ProductWorkflowState) {
    ProductWorkflowState[ProductWorkflowState["NewRequest"] = 10] = "NewRequest";
    ProductWorkflowState[ProductWorkflowState["OnHold"] = 20] = "OnHold";
    ProductWorkflowState[ProductWorkflowState["DuplicateRequestedProduct"] = 30] = "DuplicateRequestedProduct";
    ProductWorkflowState[ProductWorkflowState["ProductExists"] = 40] = "ProductExists";
    ProductWorkflowState[ProductWorkflowState["InvalidProduct"] = 50] = "InvalidProduct";
    ProductWorkflowState[ProductWorkflowState["ProductionPaused"] = 100] = "ProductionPaused";
    ProductWorkflowState[ProductWorkflowState["NewProduct"] = 110] = "NewProduct";
    ProductWorkflowState[ProductWorkflowState["ReferenceMaterialRequired"] = 130] = "ReferenceMaterialRequired";
    ProductWorkflowState[ProductWorkflowState["GatheringReferenceMaterial"] = 140] = "GatheringReferenceMaterial";
    ProductWorkflowState[ProductWorkflowState["ReferenceMaterialAvailable"] = 150] = "ReferenceMaterialAvailable";
    ProductWorkflowState[ProductWorkflowState["ReadyForAssetCreation"] = 160] = "ReadyForAssetCreation";
    ProductWorkflowState[ProductWorkflowState["AssetCreationInProgress"] = 170] = "AssetCreationInProgress";
    ProductWorkflowState[ProductWorkflowState["ReadyForImport"] = 180] = "ReadyForImport";
    ProductWorkflowState[ProductWorkflowState["ProductAssetApproval"] = 190] = "ProductAssetApproval";
    ProductWorkflowState[ProductWorkflowState["Live"] = 200] = "Live";
})(ProductWorkflowState || (ProductWorkflowState = {}));
export class ProductTransition {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.trigger = _data["trigger"];
            this.triggerName = _data["triggerName"];
            this.triggerDescription = _data["triggerDescription"];
            this.destinationState = _data["destinationState"];
            this.destinationName = _data["destinationName"];
            this.destinationDescription = _data["destinationDescription"];
            this.destinationStateType = _data["destinationStateType"];
            this.requiresWorkflowComments = _data["requiresWorkflowComments"];
            if (Array.isArray(_data["requiredProperties"])) {
                this.requiredProperties = [];
                for (let item of _data["requiredProperties"])
                    this.requiredProperties.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTransition();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["trigger"] = this.trigger;
        data["triggerName"] = this.triggerName;
        data["triggerDescription"] = this.triggerDescription;
        data["destinationState"] = this.destinationState;
        data["destinationName"] = this.destinationName;
        data["destinationDescription"] = this.destinationDescription;
        data["destinationStateType"] = this.destinationStateType;
        data["requiresWorkflowComments"] = this.requiresWorkflowComments;
        if (Array.isArray(this.requiredProperties)) {
            data["requiredProperties"] = [];
            for (let item of this.requiredProperties)
                data["requiredProperties"].push(item);
        }
        return data;
    }
}
export var ProductWorkflowTrigger;
(function (ProductWorkflowTrigger) {
    ProductWorkflowTrigger[ProductWorkflowTrigger["ApproveRequestedProduct"] = 10] = "ApproveRequestedProduct";
    ProductWorkflowTrigger[ProductWorkflowTrigger["PutOnHold"] = 11] = "PutOnHold";
    ProductWorkflowTrigger[ProductWorkflowTrigger["MarkAsDuplicateRequestedProduct"] = 12] = "MarkAsDuplicateRequestedProduct";
    ProductWorkflowTrigger[ProductWorkflowTrigger["MarkAsExistingProduct"] = 13] = "MarkAsExistingProduct";
    ProductWorkflowTrigger[ProductWorkflowTrigger["MarkAsInvalidProduct"] = 14] = "MarkAsInvalidProduct";
    ProductWorkflowTrigger[ProductWorkflowTrigger["ReleaseFromHold"] = 21] = "ReleaseFromHold";
    ProductWorkflowTrigger[ProductWorkflowTrigger["PauseProductProduction"] = 100] = "PauseProductProduction";
    ProductWorkflowTrigger[ProductWorkflowTrigger["ReleaseFromProductionPause"] = 109] = "ReleaseFromProductionPause";
    ProductWorkflowTrigger[ProductWorkflowTrigger["ApproveProduct"] = 110] = "ApproveProduct";
    ProductWorkflowTrigger[ProductWorkflowTrigger["ProductAssetAlreadyCreated"] = 111] = "ProductAssetAlreadyCreated";
    ProductWorkflowTrigger[ProductWorkflowTrigger["StartGatheringReferenceMaterial"] = 130] = "StartGatheringReferenceMaterial";
    ProductWorkflowTrigger[ProductWorkflowTrigger["CompleteGatheringReferenceMaterial"] = 140] = "CompleteGatheringReferenceMaterial";
    ProductWorkflowTrigger[ProductWorkflowTrigger["AcceptReferenceMaterial"] = 150] = "AcceptReferenceMaterial";
    ProductWorkflowTrigger[ProductWorkflowTrigger["RejectReferenceMaterial"] = 151] = "RejectReferenceMaterial";
    ProductWorkflowTrigger[ProductWorkflowTrigger["StartProductAssetCreation"] = 160] = "StartProductAssetCreation";
    ProductWorkflowTrigger[ProductWorkflowTrigger["RequiresAdditionalReferenceMaterial"] = 161] = "RequiresAdditionalReferenceMaterial";
    ProductWorkflowTrigger[ProductWorkflowTrigger["CompleteProductAssetCreation"] = 170] = "CompleteProductAssetCreation";
    ProductWorkflowTrigger[ProductWorkflowTrigger["PutAssetCreationOnHold"] = 171] = "PutAssetCreationOnHold";
    ProductWorkflowTrigger[ProductWorkflowTrigger["ImportedProductAsset"] = 180] = "ImportedProductAsset";
    ProductWorkflowTrigger[ProductWorkflowTrigger["ApproveProductAsset"] = 190] = "ApproveProductAsset";
    ProductWorkflowTrigger[ProductWorkflowTrigger["RejectProductAsset"] = 191] = "RejectProductAsset";
    ProductWorkflowTrigger[ProductWorkflowTrigger["ReworkProductAsset"] = 200] = "ReworkProductAsset";
})(ProductWorkflowTrigger || (ProductWorkflowTrigger = {}));
export var WorkflowStateType;
(function (WorkflowStateType) {
    WorkflowStateType[WorkflowStateType["InProgress"] = 0] = "InProgress";
    WorkflowStateType[WorkflowStateType["Start"] = 1] = "Start";
    WorkflowStateType[WorkflowStateType["Completed"] = 2] = "Completed";
    WorkflowStateType[WorkflowStateType["Failed"] = 3] = "Failed";
    WorkflowStateType[WorkflowStateType["Retired"] = 4] = "Retired";
    WorkflowStateType[WorkflowStateType["Paused"] = 5] = "Paused";
})(WorkflowStateType || (WorkflowStateType = {}));
export class FileVaultMarketingItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.fileName = _data["fileName"];
            this.fileContentType = _data["fileContentType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultMarketingItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["fileName"] = this.fileName;
        data["fileContentType"] = this.fileContentType;
        return data;
    }
}
export class GetProductCalloutPanelRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.manufacturerCode = _data["manufacturerCode"];
            this.builderCode = _data["builderCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductCalloutPanelRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["manufacturerCode"] = this.manufacturerCode;
        data["builderCode"] = this.builderCode;
        return data;
    }
}
export class GetProductInfoResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productInfo = _data["productInfo"] ? ProductInfo.fromJS(_data["productInfo"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductInfoResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productInfo"] = this.productInfo ? this.productInfo.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ProductInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.manufacturerLogoUrl = _data["manufacturerLogoUrl"];
            this.sku = _data["sku"];
            this.displaySku = _data["displaySku"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.brand = _data["brand"];
            this.brandLogoUrl = _data["brandLogoUrl"];
            this.showBrandLogoOnly = _data["showBrandLogoOnly"];
            this.hideSku = _data["hideSku"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["manufacturerLogoUrl"] = this.manufacturerLogoUrl;
        data["sku"] = this.sku;
        data["displaySku"] = this.displaySku;
        data["description"] = this.description;
        data["type"] = this.type;
        data["brand"] = this.brand;
        data["brandLogoUrl"] = this.brandLogoUrl;
        data["showBrandLogoOnly"] = this.showBrandLogoOnly;
        data["hideSku"] = this.hideSku;
        return data;
    }
}
export class GetProductInfoRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["productDetails"])) {
                this.productDetails = [];
                for (let item of _data["productDetails"])
                    this.productDetails.push(ProductDetail.fromJS(item));
            }
            this.manufacturer = _data["manufacturer"];
            this.sku = _data["sku"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductInfoRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productDetails)) {
            data["productDetails"] = [];
            for (let item of this.productDetails)
                data["productDetails"].push(item.toJSON());
        }
        data["manufacturer"] = this.manufacturer;
        data["sku"] = this.sku;
        return data;
    }
}
export class ProductDetail {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.group = _data["group"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetail();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        data["group"] = this.group;
        return data;
    }
}
export var InfoType;
(function (InfoType) {
    InfoType[InfoType["ProductId"] = 0] = "ProductId";
    InfoType[InfoType["Value"] = 1] = "Value";
})(InfoType || (InfoType = {}));
export class GetProductionArtifactsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [];
                for (let item of _data["artifacts"])
                    this.artifacts.push(ArtifactVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductionArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ArtifactVersion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactVersion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class GetProductionArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.product = _data["product"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductionArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["product"] = this.product;
        return data;
    }
}
export class GetSituViewResponse extends GetRenderedOutputResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.estimatedCompletionTime = _data["estimatedCompletionTime"] ? new Date(_data["estimatedCompletionTime"].toString()) : undefined;
            this.recipeFingerprint = _data["recipeFingerprint"];
            this.expectedNumberOfFiles = _data["expectedNumberOfFiles"];
            if (_data["versionHistory"]) {
                this.versionHistory = {};
                for (let key in _data["versionHistory"]) {
                    if (_data["versionHistory"].hasOwnProperty(key))
                        this.versionHistory[key] = _data["versionHistory"][key] ? new Date(_data["versionHistory"][key].toString()) : undefined;
                }
            }
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(HomeConfigFile.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituViewResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["estimatedCompletionTime"] = this.estimatedCompletionTime ? this.estimatedCompletionTime.toISOString() : undefined;
        data["recipeFingerprint"] = this.recipeFingerprint;
        data["expectedNumberOfFiles"] = this.expectedNumberOfFiles;
        if (this.versionHistory) {
            data["versionHistory"] = {};
            for (let key in this.versionHistory) {
                if (this.versionHistory.hasOwnProperty(key))
                    data["versionHistory"][key] = this.versionHistory[key] ? this.versionHistory[key].toISOString() : undefined;
            }
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetSituViewRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.renderedOutputId = _data["renderedOutputId"];
            this.includeHistory = _data["includeHistory"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituViewRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["renderedOutputId"] = this.renderedOutputId;
        data["includeHistory"] = this.includeHistory;
        return data;
    }
}
export class GetSituViewWithIdsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigName = _data["styleConfigName"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituViewWithIdsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigName"] = this.styleConfigName;
        data["productName"] = this.productName;
        return data;
    }
}
export class GetSituViewWithNamesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfig = _data["homeConfig"] ? HomeConfigSlim.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfigName = _data["styleConfigName"];
            this.renderType = _data["renderType"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituViewWithNamesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfigName"] = this.styleConfigName;
        data["renderType"] = this.renderType;
        data["productName"] = this.productName;
        return data;
    }
}
export class GetStyleConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.styleConfigId = _data["styleConfigId"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.styleConfigTemplateName = _data["styleConfigTemplateName"];
            if (Array.isArray(_data["styles"])) {
                this.styles = [];
                for (let item of _data["styles"])
                    this.styles.push(ConfigStyle.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleConfigId"] = this.styleConfigId;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["styleConfigTemplateName"] = this.styleConfigTemplateName;
        if (Array.isArray(this.styles)) {
            data["styles"] = [];
            for (let item of this.styles)
                data["styles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ConfigStyle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.styleCategoryId = _data["styleCategoryId"];
            this.style = _data["style"];
            this.callerReferenceKey = _data["callerReferenceKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigStyle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["styleCategoryId"] = this.styleCategoryId;
        data["style"] = this.style;
        data["callerReferenceKey"] = this.callerReferenceKey;
        return data;
    }
}
export class GetStyleConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.styleConfigId = _data["styleConfigId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleConfigId"] = this.styleConfigId;
        return data;
    }
}
export class GetStyleTemplateResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.isHidden = _data["isHidden"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["styles"])) {
                this.styles = [];
                for (let item of _data["styles"])
                    this.styles.push(TemplateStyle.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleTemplateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["isHidden"] = this.isHidden;
        data["productName"] = this.productName;
        if (Array.isArray(this.styles)) {
            data["styles"] = [];
            for (let item of this.styles)
                data["styles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class TemplateStyle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.styleCategoryId = _data["styleCategoryId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.isHidden = _data["isHidden"];
            this.companyId = _data["companyId"];
            this.themeId = _data["themeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateStyle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["styleCategoryId"] = this.styleCategoryId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["isHidden"] = this.isHidden;
        data["companyId"] = this.companyId;
        data["themeId"] = this.themeId;
        return data;
    }
}
export class GetStyleTemplateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.styleTemplateId = _data["styleTemplateId"];
            this.includeIncompleteStyles = _data["includeIncompleteStyles"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleTemplateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleTemplateId"] = this.styleTemplateId;
        data["includeIncompleteStyles"] = this.includeIncompleteStyles;
        return data;
    }
}
export class GetStyleTemplateByNameRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.homeId = _data["homeId"];
            this.includeIncompleteStyles = _data["includeIncompleteStyles"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleTemplateByNameRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["homeId"] = this.homeId;
        data["includeIncompleteStyles"] = this.includeIncompleteStyles;
        return data;
    }
}
export class GetStyleTemplateThemesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themes"])) {
                this.themes = [];
                for (let item of _data["themes"])
                    this.themes.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleTemplateThemesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetStyleTemplateThemesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.styleTemplateId = _data["styleTemplateId"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleTemplateThemesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["styleTemplateId"] = this.styleTemplateId;
        data["name"] = this.name;
        return data;
    }
}
export class GetStyleTreeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (let item of _data["categories"])
                    this.categories.push(StyleCategoryNode.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleTreeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class StyleCategoryNode {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.parentStyleCategoryId = _data["parentStyleCategoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isSingleSelect = _data["isSingleSelect"];
            if (Array.isArray(_data["styles"])) {
                this.styles = [];
                for (let item of _data["styles"])
                    this.styles.push(StyleNode.fromJS(item));
            }
            if (Array.isArray(_data["styleCategories"])) {
                this.styleCategories = [];
                for (let item of _data["styleCategories"])
                    this.styleCategories.push(StyleCategoryNode.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleCategoryNode();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["parentStyleCategoryId"] = this.parentStyleCategoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isSingleSelect"] = this.isSingleSelect;
        if (Array.isArray(this.styles)) {
            data["styles"] = [];
            for (let item of this.styles)
                data["styles"].push(item.toJSON());
        }
        if (Array.isArray(this.styleCategories)) {
            data["styleCategories"] = [];
            for (let item of this.styleCategories)
                data["styleCategories"].push(item.toJSON());
        }
        return data;
    }
}
export class StyleNode {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.displayName = _data["displayName"];
            this.themeName = _data["themeName"];
            this.themeType = _data["themeType"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.styleCategoryId = _data["styleCategoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleNode();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["displayName"] = this.displayName;
        data["themeName"] = this.themeName;
        data["themeType"] = this.themeType;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["styleCategoryId"] = this.styleCategoryId;
        return data;
    }
}
export class GetStyleTreeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [];
                for (let item of _data["companyIds"])
                    this.companyIds.push(item);
            }
            this.showAll = _data["showAll"];
            this.includeOrphaned = _data["includeOrphaned"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleTreeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["showAll"] = this.showAll;
        data["includeOrphaned"] = this.includeOrphaned;
        return data;
    }
}
export class TermsAndConditionsBase extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.termsAndConditionsId = _data["termsAndConditionsId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.ianaLanguageSubtag = _data["ianaLanguageSubtag"];
            this.documentLink = _data["documentLink"];
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.patch = _data["patch"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsBase();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["termsAndConditionsId"] = this.termsAndConditionsId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["ianaLanguageSubtag"] = this.ianaLanguageSubtag;
        data["documentLink"] = this.documentLink;
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["patch"] = this.patch;
        super.toJSON(data);
        return data;
    }
}
export class GetTermsAndConditionsResponse extends TermsAndConditionsBase {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTermsAndConditionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class GetTermsAndConditionsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.ianaLanguageSubtag = _data["ianaLanguageSubtag"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTermsAndConditionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["ianaLanguageSubtag"] = this.ianaLanguageSubtag;
        return data;
    }
}
export class ListCachedHomesByBuilderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.cachedHomes = _data["cachedHomes"] ? CachedHomes.fromJS(_data["cachedHomes"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListCachedHomesByBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["cachedHomes"] = this.cachedHomes ? this.cachedHomes.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class CachedHomes {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dateCacheExpires = _data["dateCacheExpires"] ? new Date(_data["dateCacheExpires"].toString()) : undefined;
            this.dateTimeStamp = _data["dateTimeStamp"] ? new Date(_data["dateTimeStamp"].toString()) : undefined;
            if (Array.isArray(_data["homeConfigs"])) {
                this.homeConfigs = [];
                for (let item of _data["homeConfigs"])
                    this.homeConfigs.push(HomeConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CachedHomes();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateCacheExpires"] = this.dateCacheExpires ? this.dateCacheExpires.toISOString() : undefined;
        data["dateTimeStamp"] = this.dateTimeStamp ? this.dateTimeStamp.toISOString() : undefined;
        if (Array.isArray(this.homeConfigs)) {
            data["homeConfigs"] = [];
            for (let item of this.homeConfigs)
                data["homeConfigs"].push(item.toJSON());
        }
        return data;
    }
}
export class ListCachedHomesByBuilderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.environment = _data["environment"];
            this.productName = _data["productName"];
            this.renderType = _data["renderType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListCachedHomesByBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["environment"] = this.environment;
        data["productName"] = this.productName;
        data["renderType"] = this.renderType;
        return data;
    }
}
export class PagedResponseOfHome extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Home.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfHome();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListHomeConfigsByHomeResponse extends PagedResponseOfHome {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["homeConfigs"])) {
                this.homeConfigs = [];
                for (let item of _data["homeConfigs"])
                    this.homeConfigs.push(HomeConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomeConfigsByHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homeConfigs)) {
            data["homeConfigs"] = [];
            for (let item of this.homeConfigs)
                data["homeConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListHomeConfigsByHomeRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.masterFileFilter = _data["masterFileFilter"];
            this.themesFilter = _data["themesFilter"];
            this.optionsFilter = _data["optionsFilter"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomeConfigsByHomeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["masterFileFilter"] = this.masterFileFilter;
        data["themesFilter"] = this.themesFilter;
        data["optionsFilter"] = this.optionsFilter;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfHomeDetail extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(HomeDetail.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfHomeDetail();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListHomeDetailsResponse extends PagedResponseOfHomeDetail {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomeDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class HomeDetail {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.isHidden = _data["isHidden"];
            this.dateLastRendered = _data["dateLastRendered"] ? new Date(_data["dateLastRendered"].toString()) : undefined;
            this.dateLastRaytracedPlusRendered = _data["dateLastRaytracedPlusRendered"] ? new Date(_data["dateLastRaytracedPlusRendered"].toString()) : undefined;
            if (Array.isArray(_data["homeConfigs"])) {
                this.homeConfigs = [];
                for (let item of _data["homeConfigs"])
                    this.homeConfigs.push(HomeConfig.fromJS(item));
            }
            if (Array.isArray(_data["homeTags"])) {
                this.homeTags = [];
                for (let item of _data["homeTags"])
                    this.homeTags.push(HomeTag.fromJS(item));
            }
            if (Array.isArray(_data["ifcFiles"])) {
                this.ifcFiles = [];
                for (let item of _data["ifcFiles"])
                    this.ifcFiles.push(HomeIfcFile.fromJS(item));
            }
            if (Array.isArray(_data["styledHomes"])) {
                this.styledHomes = [];
                for (let item of _data["styledHomes"])
                    this.styledHomes.push(StyledHome.fromJS(item));
            }
            if (Array.isArray(_data["styleConfigTemplates"])) {
                this.styleConfigTemplates = [];
                for (let item of _data["styleConfigTemplates"])
                    this.styleConfigTemplates.push(StyleConfigTemplate.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeDetail();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["isHidden"] = this.isHidden;
        data["dateLastRendered"] = this.dateLastRendered ? this.dateLastRendered.toISOString() : undefined;
        data["dateLastRaytracedPlusRendered"] = this.dateLastRaytracedPlusRendered ? this.dateLastRaytracedPlusRendered.toISOString() : undefined;
        if (Array.isArray(this.homeConfigs)) {
            data["homeConfigs"] = [];
            for (let item of this.homeConfigs)
                data["homeConfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.homeTags)) {
            data["homeTags"] = [];
            for (let item of this.homeTags)
                data["homeTags"].push(item.toJSON());
        }
        if (Array.isArray(this.ifcFiles)) {
            data["ifcFiles"] = [];
            for (let item of this.ifcFiles)
                data["ifcFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.styledHomes)) {
            data["styledHomes"] = [];
            for (let item of this.styledHomes)
                data["styledHomes"].push(item.toJSON());
        }
        if (Array.isArray(this.styleConfigTemplates)) {
            data["styleConfigTemplates"] = [];
            for (let item of this.styleConfigTemplates)
                data["styleConfigTemplates"].push(item.toJSON());
        }
        return data;
    }
}
export class HomeTag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeId = _data["homeId"];
            this.tagId = _data["tagId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeTag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeId"] = this.homeId;
        data["tagId"] = this.tagId;
        return data;
    }
}
export class ListHomeDetailsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["homeTags"])) {
                this.homeTags = [];
                for (let item of _data["homeTags"])
                    this.homeTags.push(item);
            }
            this.excludeHomesWithNoTags = _data["excludeHomesWithNoTags"];
            this.isHidden = _data["isHidden"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomeDetailsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.homeTags)) {
            data["homeTags"] = [];
            for (let item of this.homeTags)
                data["homeTags"].push(item);
        }
        data["excludeHomesWithNoTags"] = this.excludeHomesWithNoTags;
        data["isHidden"] = this.isHidden;
        super.toJSON(data);
        return data;
    }
}
export class ListHomeIfcFilesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeIfcFileList = _data["homeIfcFileList"] ? HomeIfcFileList.fromJS(_data["homeIfcFileList"]) : undefined;
            this.artifactStoreEnabled = _data["artifactStoreEnabled"];
            if (Array.isArray(_data["builders"])) {
                this.builders = [];
                for (let item of _data["builders"])
                    this.builders.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomeIfcFilesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeIfcFileList"] = this.homeIfcFileList ? this.homeIfcFileList.toJSON() : undefined;
        data["artifactStoreEnabled"] = this.artifactStoreEnabled;
        if (Array.isArray(this.builders)) {
            data["builders"] = [];
            for (let item of this.builders)
                data["builders"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class HomeIfcFileList {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["homeIfcFiles"])) {
                this.homeIfcFiles = [];
                for (let item of _data["homeIfcFiles"])
                    this.homeIfcFiles.push(HomeIfcFileDetails.fromJS(item));
            }
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeIfcFileList();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homeIfcFiles)) {
            data["homeIfcFiles"] = [];
            for (let item of this.homeIfcFiles)
                data["homeIfcFiles"].push(item.toJSON());
        }
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        return data;
    }
}
export class HomeIfcFileDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.home = _data["home"];
            this.files = _data["files"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.dateTimeStamp = _data["dateTimeStamp"] ? new Date(_data["dateTimeStamp"].toString()) : undefined;
            this.error = _data["error"];
            this.masterFile = _data["masterFile"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeIfcFileDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["home"] = this.home;
        data["files"] = this.files;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["dateTimeStamp"] = this.dateTimeStamp ? this.dateTimeStamp.toISOString() : undefined;
        data["error"] = this.error;
        data["masterFile"] = this.masterFile;
        return data;
    }
}
export class ListHomeIfcFilesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomeIfcFilesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        return data;
    }
}
export class ListHomesByCompanyResponse extends PagedResponseOfHome {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["homes"])) {
                this.homes = [];
                for (let item of _data["homes"])
                    this.homes.push(Home.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomesByCompanyResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homes)) {
            data["homes"] = [];
            for (let item of this.homes)
                data["homes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListHomesByCompanyRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.searchTerm = _data["searchTerm"];
            this.isHidden = _data["isHidden"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomesByCompanyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["searchTerm"] = this.searchTerm;
        data["isHidden"] = this.isHidden;
        super.toJSON(data);
        return data;
    }
}
export class ListHomesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["homes"])) {
                this.homes = [];
                for (let item of _data["homes"])
                    this.homes.push(item);
            }
            if (Array.isArray(_data["builders"])) {
                this.builders = [];
                for (let item of _data["builders"])
                    this.builders.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homes)) {
            data["homes"] = [];
            for (let item of this.homes)
                data["homes"].push(item);
        }
        if (Array.isArray(this.builders)) {
            data["builders"] = [];
            for (let item of this.builders)
                data["builders"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class ListHomesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.includeBuilders = _data["includeBuilders"];
            this.builder = _data["builder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["includeBuilders"] = this.includeBuilders;
        data["builder"] = this.builder;
        return data;
    }
}
export class ListIfcErrorsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ifcParseErrors"])) {
                this.ifcParseErrors = [];
                for (let item of _data["ifcParseErrors"])
                    this.ifcParseErrors.push(IfcParseError.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListIfcErrorsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ifcParseErrors)) {
            data["ifcParseErrors"] = [];
            for (let item of this.ifcParseErrors)
                data["ifcParseErrors"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class IfcParseError {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.home = _data["home"];
            this.ifcFile = _data["ifcFile"];
            this.error = _data["error"];
            this.severity = _data["severity"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcParseError();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["home"] = this.home;
        data["ifcFile"] = this.ifcFile;
        data["error"] = this.error;
        data["severity"] = this.severity;
        data["version"] = this.version;
        return data;
    }
}
export class ListIfcErrorsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListIfcErrorsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        return data;
    }
}
export class ListIfcFilesByHomeIdResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ifcFiles"])) {
                this.ifcFiles = [];
                for (let item of _data["ifcFiles"])
                    this.ifcFiles.push(HomeIfcFile.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListIfcFilesByHomeIdResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ifcFiles)) {
            data["ifcFiles"] = [];
            for (let item of this.ifcFiles)
                data["ifcFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListIfcFilesByHomeIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.isMaster = _data["isMaster"];
            this.justTen = _data["justTen"];
            this.orderLatest = _data["orderLatest"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListIfcFilesByHomeIdRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["isMaster"] = this.isMaster;
        data["justTen"] = this.justTen;
        data["orderLatest"] = this.orderLatest;
        return data;
    }
}
export class ListManufacturerProductsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["manufacturerProducts"])) {
                this.manufacturerProducts = [];
                for (let item of _data["manufacturerProducts"])
                    this.manufacturerProducts.push(ManufacturerProduct.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListManufacturerProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerProducts)) {
            data["manufacturerProducts"] = [];
            for (let item of this.manufacturerProducts)
                data["manufacturerProducts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ManufacturerProduct {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.manufacturerId = _data["manufacturerId"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerCode = _data["manufacturerCode"];
            this.manufacturerLogoUrl = _data["manufacturerLogoUrl"];
            this.product = _data["product"];
            this.sku = _data["sku"];
            this.displaySku = _data["displaySku"];
            this.type = _data["type"];
            this.brand = _data["brand"];
            this.brandLogoUrl = _data["brandLogoUrl"];
            this.showBrandLogoOnly = _data["showBrandLogoOnly"];
            this.hideSku = _data["hideSku"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["manufacturerId"] = this.manufacturerId;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerCode"] = this.manufacturerCode;
        data["manufacturerLogoUrl"] = this.manufacturerLogoUrl;
        data["product"] = this.product;
        data["sku"] = this.sku;
        data["displaySku"] = this.displaySku;
        data["type"] = this.type;
        data["brand"] = this.brand;
        data["brandLogoUrl"] = this.brandLogoUrl;
        data["showBrandLogoOnly"] = this.showBrandLogoOnly;
        data["hideSku"] = this.hideSku;
        return data;
    }
}
export class ListManufacturerProductsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListManufacturerProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class PagedResponseOfArtifactVersionItem extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ArtifactVersionItem.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfArtifactVersionItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListPagedArtifactsResponse extends PagedResponseOfArtifactVersionItem {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["builders"])) {
                this.builders = [];
                for (let item of _data["builders"])
                    this.builders.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.builders)) {
            data["builders"] = [];
            for (let item of this.builders)
                data["builders"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class ArtifactVersionItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.active = _data["active"];
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [];
                for (let item of _data["metaData"])
                    this.metaData.push(MetaDataItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactVersionItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["active"] = this.active;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        return data;
    }
}
export class MetaDataItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MetaDataItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}
export class ListPagedArtifactsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.includeBuilders = _data["includeBuilders"];
            this.builder = _data["builder"];
            this.containsFilter = _data["containsFilter"];
            if (Array.isArray(_data["containsWords"])) {
                this.containsWords = [];
                for (let item of _data["containsWords"])
                    this.containsWords.push(item);
            }
            this.productName = _data["productName"];
            this.includeDisabled = _data["includeDisabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["includeBuilders"] = this.includeBuilders;
        data["builder"] = this.builder;
        data["containsFilter"] = this.containsFilter;
        if (Array.isArray(this.containsWords)) {
            data["containsWords"] = [];
            for (let item of this.containsWords)
                data["containsWords"].push(item);
        }
        data["productName"] = this.productName;
        data["includeDisabled"] = this.includeDisabled;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfIfcFile extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(IfcFile.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfIfcFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListPagedHomeIfcFilesResponse extends PagedResponseOfIfcFile {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["environmentSettings"])) {
                this.environmentSettings = [];
                for (let item of _data["environmentSettings"])
                    this.environmentSettings.push(EnvironmentSettings.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedHomeIfcFilesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.environmentSettings)) {
            data["environmentSettings"] = [];
            for (let item of this.environmentSettings)
                data["environmentSettings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class EnvironmentSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            this.defaultCuttoffDate = _data["defaultCuttoffDate"] ? new Date(_data["defaultCuttoffDate"].toString()) : undefined;
            if (Array.isArray(_data["referenceKeyCuttoffs"])) {
                this.referenceKeyCuttoffs = [];
                for (let item of _data["referenceKeyCuttoffs"])
                    this.referenceKeyCuttoffs.push(ReferenceKeyCuttoff.fromJS(item));
            }
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [];
                for (let item of _data["overrides"])
                    this.overrides.push(ArtifactVersion.fromJS(item));
            }
            this.retainedFromProductionDate = _data["retainedFromProductionDate"] ? new Date(_data["retainedFromProductionDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        data["defaultCuttoffDate"] = this.defaultCuttoffDate ? this.defaultCuttoffDate.toISOString() : undefined;
        if (Array.isArray(this.referenceKeyCuttoffs)) {
            data["referenceKeyCuttoffs"] = [];
            for (let item of this.referenceKeyCuttoffs)
                data["referenceKeyCuttoffs"].push(item.toJSON());
        }
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        data["retainedFromProductionDate"] = this.retainedFromProductionDate ? this.retainedFromProductionDate.toISOString() : undefined;
        return data;
    }
}
export class ReferenceKeyCuttoff {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.query = _data["query"];
            this.cuttoffDate = _data["cuttoffDate"] ? new Date(_data["cuttoffDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceKeyCuttoff();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["cuttoffDate"] = this.cuttoffDate ? this.cuttoffDate.toISOString() : undefined;
        return data;
    }
}
export class IfcFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.home = _data["home"];
            this.name = _data["name"];
            this.fileType = _data["fileType"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["home"] = this.home;
        data["name"] = this.name;
        data["fileType"] = this.fileType;
        data["version"] = this.version;
        return data;
    }
}
export class ListPagedHomeIfcFilesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.builder = _data["builder"];
            this.home = _data["home"];
            this.includeEnvironments = _data["includeEnvironments"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedHomeIfcFilesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["home"] = this.home;
        data["includeEnvironments"] = this.includeEnvironments;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfIfcParseError extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(IfcParseError.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfIfcParseError();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListPagedIfcErrorsResponse extends PagedResponseOfIfcParseError {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedIfcErrorsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ListPagedIfcErrorsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.builder = _data["builder"];
            this.home = _data["home"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedIfcErrorsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["home"] = this.home;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfImportedProduct extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ImportedProduct.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfImportedProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListPagedImportedProductsResponse extends PagedResponseOfImportedProduct {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedImportedProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ImportedProduct {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.displaySku = _data["displaySku"];
            this.type = _data["type"];
            this.brand = _data["brand"];
            this.brandLogoUrl = _data["brandLogoUrl"];
            this.disabled = _data["disabled"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(ImportedProductError.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["displaySku"] = this.displaySku;
        data["type"] = this.type;
        data["brand"] = this.brand;
        data["brandLogoUrl"] = this.brandLogoUrl;
        data["disabled"] = this.disabled;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}
export class ImportedProductError {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.importedProductId = _data["importedProductId"];
            this.id = _data["id"];
            this.error = _data["error"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedProductError();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["importedProductId"] = this.importedProductId;
        data["id"] = this.id;
        data["error"] = this.error;
        return data;
    }
}
export class ListPagedImportedProductsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPagedImportedProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfRenderedOutputSummary extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(RenderedOutputSummary.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfRenderedOutputSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListRenderedOutputsResponse extends PagedResponseOfRenderedOutputSummary {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["renderedOutputs"])) {
                this.renderedOutputs = [];
                for (let item of _data["renderedOutputs"])
                    this.renderedOutputs.push(RenderedOutputSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRenderedOutputsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.renderedOutputs)) {
            data["renderedOutputs"] = [];
            for (let item of this.renderedOutputs)
                data["renderedOutputs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class RenderedOutputSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.homeConfigId = _data["homeConfigId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfigSlim.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfigId = _data["styleConfigId"];
            this.artifactId = _data["artifactId"];
            this.productName = _data["productName"];
            this.isProduction = _data["isProduction"];
            this.status = _data["status"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.createdByName = _data["createdByName"];
            this.styleConfigTemplate = _data["styleConfigTemplate"] ? StyleConfigTemplateSlim.fromJS(_data["styleConfigTemplate"]) : undefined;
            if (Array.isArray(_data["sourceArtifacts"])) {
                this.sourceArtifacts = [];
                for (let item of _data["sourceArtifacts"])
                    this.sourceArtifacts.push(RenderedOutputSourceArtifactSlim.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RenderedOutputSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["homeConfigId"] = this.homeConfigId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfigId"] = this.styleConfigId;
        data["artifactId"] = this.artifactId;
        data["productName"] = this.productName;
        data["isProduction"] = this.isProduction;
        data["status"] = this.status;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["createdByName"] = this.createdByName;
        data["styleConfigTemplate"] = this.styleConfigTemplate ? this.styleConfigTemplate.toJSON() : undefined;
        if (Array.isArray(this.sourceArtifacts)) {
            data["sourceArtifacts"] = [];
            for (let item of this.sourceArtifacts)
                data["sourceArtifacts"].push(item.toJSON());
        }
        return data;
    }
}
export class ListRenderedOutputsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.productName = _data["productName"];
            this.expandProducts = _data["expandProducts"];
            this.status = _data["status"];
            this.isProduction = _data["isProduction"];
            this.homeId = _data["homeId"];
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["containsWords"])) {
                this.containsWords = [];
                for (let item of _data["containsWords"])
                    this.containsWords.push(item);
            }
            this.orderByHome = _data["orderByHome"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRenderedOutputsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["productName"] = this.productName;
        data["expandProducts"] = this.expandProducts;
        data["status"] = this.status;
        data["isProduction"] = this.isProduction;
        data["homeId"] = this.homeId;
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.containsWords)) {
            data["containsWords"] = [];
            for (let item of this.containsWords)
                data["containsWords"].push(item);
        }
        data["orderByHome"] = this.orderByHome;
        super.toJSON(data);
        return data;
    }
}
export class ListStyleTemplatesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["styleTemplates"])) {
                this.styleTemplates = [];
                for (let item of _data["styleTemplates"])
                    this.styleTemplates.push(StyleConfigTemplate.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleTemplatesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.styleTemplates)) {
            data["styleTemplates"] = [];
            for (let item of this.styleTemplates)
                data["styleTemplates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListStyleTemplatesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.tagId = _data["tagId"];
            this.showAll = _data["showAll"];
            this.globalOnly = _data["globalOnly"];
            this.productName = _data["productName"];
            this.isHidden = _data["isHidden"];
            this.templateName = _data["templateName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleTemplatesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["tagId"] = this.tagId;
        data["showAll"] = this.showAll;
        data["globalOnly"] = this.globalOnly;
        data["productName"] = this.productName;
        data["isHidden"] = this.isHidden;
        data["templateName"] = this.templateName;
        return data;
    }
}
export class ListStyleTemplatesByThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["styleTemplates"])) {
                this.styleTemplates = [];
                for (let item of _data["styleTemplates"])
                    this.styleTemplates.push(StyleConfigTemplate.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleTemplatesByThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.styleTemplates)) {
            data["styleTemplates"] = [];
            for (let item of this.styleTemplates)
                data["styleTemplates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListStyleTemplatesByThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.themeId = _data["themeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleTemplatesByThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["themeId"] = this.themeId;
        return data;
    }
}
export class ListTagsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(Tag.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListTagsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListTagsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.resourceType = _data["resourceType"];
            this.includeDeleted = _data["includeDeleted"];
            this.categoryId = _data["categoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListTagsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["resourceType"] = this.resourceType;
        data["includeDeleted"] = this.includeDeleted;
        data["categoryId"] = this.categoryId;
        return data;
    }
}
export var FileVaultCategory;
(function (FileVaultCategory) {
    FileVaultCategory[FileVaultCategory["NotSet"] = 0] = "NotSet";
    FileVaultCategory[FileVaultCategory["ReferenceMaterial"] = 1] = "ReferenceMaterial";
    FileVaultCategory[FileVaultCategory["SourceMaterial"] = 2] = "SourceMaterial";
    FileVaultCategory[FileVaultCategory["Assets"] = 3] = "Assets";
    FileVaultCategory[FileVaultCategory["MarketingMaterial"] = 4] = "MarketingMaterial";
})(FileVaultCategory || (FileVaultCategory = {}));
export class GetZippedFilesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["fileVaultReferences"])) {
                this.fileVaultReferences = [];
                for (let item of _data["fileVaultReferences"])
                    this.fileVaultReferences.push(CompanyProductIdPair.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetZippedFilesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileVaultReferences)) {
            data["fileVaultReferences"] = [];
            for (let item of this.fileVaultReferences)
                data["fileVaultReferences"].push(item.toJSON());
        }
        return data;
    }
}
export class CompanyProductIdPair {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.fileId = _data["fileId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProductIdPair();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["fileId"] = this.fileId;
        return data;
    }
}
export class FileVaultUploadResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.fileVaultReferenceId = _data["fileVaultReferenceId"];
            this.uploadUrl = _data["uploadUrl"];
            this.fileAlreadyInFileVault = _data["fileAlreadyInFileVault"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultUploadResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileVaultReferenceId"] = this.fileVaultReferenceId;
        data["uploadUrl"] = this.uploadUrl;
        data["fileAlreadyInFileVault"] = this.fileAlreadyInFileVault;
        super.toJSON(data);
        return data;
    }
}
export class FileVaultUploadRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.subjectId = _data["subjectId"];
            this.subjectType = _data["subjectType"];
            this.category = _data["category"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.fileHash = _data["fileHash"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultUploadRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["subjectId"] = this.subjectId;
        data["subjectType"] = this.subjectType;
        data["category"] = this.category;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileHash"] = this.fileHash;
        return data;
    }
}
export var FileVaultSubjectType;
(function (FileVaultSubjectType) {
    FileVaultSubjectType[FileVaultSubjectType["Product"] = 0] = "Product";
    FileVaultSubjectType[FileVaultSubjectType["Company"] = 1] = "Company";
})(FileVaultSubjectType || (FileVaultSubjectType = {}));
export class FileVaultUploadCommitResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.fileVaultReferenceRelation = _data["fileVaultReferenceRelation"] ? FileVaultReferenceRelation.fromJS(_data["fileVaultReferenceRelation"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultUploadCommitResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileVaultReferenceRelation"] = this.fileVaultReferenceRelation ? this.fileVaultReferenceRelation.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class FileVaultReference {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.fileHash = _data["fileHash"];
            this.fileContentType = _data["fileContentType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultReference();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["fileHash"] = this.fileHash;
        data["fileContentType"] = this.fileContentType;
        return data;
    }
}
export class FileVaultReferenceRelation extends FileVaultReference {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.subjectId = _data["subjectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultReferenceRelation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["subjectId"] = this.subjectId;
        super.toJSON(data);
        return data;
    }
}
export class FileVaultUploadCommitRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.fileVaultReferenceId = _data["fileVaultReferenceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultUploadCommitRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["fileVaultReferenceId"] = this.fileVaultReferenceId;
        return data;
    }
}
export class PagedResponseOfFileVaultReference extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(FileVaultReference.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfFileVaultReference();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class GetFileVaultReferencesResponse extends PagedResponseOfFileVaultReference {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileVaultReferencesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class GetFileVaultReferencesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.category = _data["category"];
            if (Array.isArray(_data["extensionsFilter"])) {
                this.extensionsFilter = [];
                for (let item of _data["extensionsFilter"])
                    this.extensionsFilter.push(item);
            }
            this.fileNameFilter = _data["fileNameFilter"];
            this.fileHashFilter = _data["fileHashFilter"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileVaultReferencesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["category"] = this.category;
        if (Array.isArray(this.extensionsFilter)) {
            data["extensionsFilter"] = [];
            for (let item of this.extensionsFilter)
                data["extensionsFilter"].push(item);
        }
        data["fileNameFilter"] = this.fileNameFilter;
        data["fileHashFilter"] = this.fileHashFilter;
        super.toJSON(data);
        return data;
    }
}
export class GetFileVaultReferenceRelationsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fileVaultReferenceRelations"])) {
                this.fileVaultReferenceRelations = [];
                for (let item of _data["fileVaultReferenceRelations"])
                    this.fileVaultReferenceRelations.push(FileVaultReferenceRelation.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileVaultReferenceRelationsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileVaultReferenceRelations)) {
            data["fileVaultReferenceRelations"] = [];
            for (let item of this.fileVaultReferenceRelations)
                data["fileVaultReferenceRelations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetFileVaultReferenceRelationsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.subjectId = _data["subjectId"];
            this.category = _data["category"];
            if (Array.isArray(_data["extensionsFilter"])) {
                this.extensionsFilter = [];
                for (let item of _data["extensionsFilter"])
                    this.extensionsFilter.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileVaultReferenceRelationsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["subjectId"] = this.subjectId;
        data["category"] = this.category;
        if (Array.isArray(this.extensionsFilter)) {
            data["extensionsFilter"] = [];
            for (let item of this.extensionsFilter)
                data["extensionsFilter"].push(item);
        }
        return data;
    }
}
export class AddFileVaultReferencesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fileVaultReferences"])) {
                this.fileVaultReferences = [];
                for (let item of _data["fileVaultReferences"])
                    this.fileVaultReferences.push(FileVaultReferenceRelation.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddFileVaultReferencesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileVaultReferences)) {
            data["fileVaultReferences"] = [];
            for (let item of this.fileVaultReferences)
                data["fileVaultReferences"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class AddFileVaultReferencesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["fileVaultReferenceIds"])) {
                this.fileVaultReferenceIds = [];
                for (let item of _data["fileVaultReferenceIds"])
                    this.fileVaultReferenceIds.push(item);
            }
            this.category = _data["category"];
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [];
                for (let item of _data["subjects"])
                    this.subjects.push(CompanySubjectPair.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddFileVaultReferencesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileVaultReferenceIds)) {
            data["fileVaultReferenceIds"] = [];
            for (let item of this.fileVaultReferenceIds)
                data["fileVaultReferenceIds"].push(item);
        }
        data["category"] = this.category;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item.toJSON());
        }
        return data;
    }
}
export class CompanySubjectPair {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.subjectId = _data["subjectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySubjectPair();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["subjectId"] = this.subjectId;
        return data;
    }
}
export class RemoveFileVaultReferencesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.removedCount = _data["removedCount"];
            this.wouldRemoveLastReference = _data["wouldRemoveLastReference"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFileVaultReferencesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["removedCount"] = this.removedCount;
        data["wouldRemoveLastReference"] = this.wouldRemoveLastReference;
        super.toJSON(data);
        return data;
    }
}
export class RemoveFileVaultReferencesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileVaultReferenceId = _data["fileVaultReferenceId"];
            this.category = _data["category"];
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [];
                for (let item of _data["subjects"])
                    this.subjects.push(CompanySubjectPair.fromJS(item));
            }
            this.force = _data["force"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFileVaultReferencesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileVaultReferenceId"] = this.fileVaultReferenceId;
        data["category"] = this.category;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item.toJSON());
        }
        data["force"] = this.force;
        return data;
    }
}
export class ImportThemesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportThemesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class GetAssetInstanceResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.assetInstance = _data["assetInstance"];
            if (Array.isArray(_data["assetTemplate"])) {
                this.assetTemplate = [];
                for (let item of _data["assetTemplate"])
                    this.assetTemplate.push(AssetTemplateProperties.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetInstanceResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetInstance"] = this.assetInstance;
        if (Array.isArray(this.assetTemplate)) {
            data["assetTemplate"] = [];
            for (let item of this.assetTemplate)
                data["assetTemplate"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class AssetTemplateProperties {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.assetType = _data["assetType"];
            this.assetCount = _data["assetCount"];
            this.templateName = _data["templateName"];
            this.templateID = _data["templateID"];
            this.defaultValue = _data["defaultValue"];
            this.range = _data["range"];
            this.enumValues = _data["enumValues"];
            this.isOptional = _data["isOptional"];
            this.isEditable = _data["isEditable"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTemplateProperties();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["assetType"] = this.assetType;
        data["assetCount"] = this.assetCount;
        data["templateName"] = this.templateName;
        data["templateID"] = this.templateID;
        data["defaultValue"] = this.defaultValue;
        data["range"] = this.range;
        data["enumValues"] = this.enumValues;
        data["isOptional"] = this.isOptional;
        data["isEditable"] = this.isEditable;
        return data;
    }
}
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["INT"] = 0] = "INT";
    PropertyType[PropertyType["FLOAT"] = 1] = "FLOAT";
    PropertyType[PropertyType["STRING"] = 2] = "STRING";
    PropertyType[PropertyType["BOOL"] = 3] = "BOOL";
    PropertyType[PropertyType["IMAGE"] = 4] = "IMAGE";
    PropertyType[PropertyType["MESH"] = 5] = "MESH";
    PropertyType[PropertyType["FILE"] = 6] = "FILE";
    PropertyType[PropertyType["ENUM"] = 7] = "ENUM";
    PropertyType[PropertyType["TEMPLATE"] = 8] = "TEMPLATE";
    PropertyType[PropertyType["BLENDER"] = 9] = "BLENDER";
})(PropertyType || (PropertyType = {}));
export class GetAssetInstanceRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.assetInstanceKey = _data["assetInstanceKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetInstanceRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["assetInstanceKey"] = this.assetInstanceKey;
        return data;
    }
}
export class GetAssetTemplateResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["assetTemplate"])) {
                this.assetTemplate = [];
                for (let item of _data["assetTemplate"])
                    this.assetTemplate.push(AssetTemplateProperties.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetTemplateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetTemplate)) {
            data["assetTemplate"] = [];
            for (let item of this.assetTemplate)
                data["assetTemplate"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetAssetTemplateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.assetTemplateKey = _data["assetTemplateKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetTemplateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetTemplateKey"] = this.assetTemplateKey;
        return data;
    }
}
export class GetAssetReferenceRecommendationsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["artifactRecommendations"])) {
                this.artifactRecommendations = [];
                for (let item of _data["artifactRecommendations"])
                    this.artifactRecommendations.push(item);
            }
            if (Array.isArray(_data["fileVaultReferences"])) {
                this.fileVaultReferences = [];
                for (let item of _data["fileVaultReferences"])
                    this.fileVaultReferences.push(FileVaultReferenceRelation.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetReferenceRecommendationsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifactRecommendations)) {
            data["artifactRecommendations"] = [];
            for (let item of this.artifactRecommendations)
                data["artifactRecommendations"].push(item);
        }
        if (Array.isArray(this.fileVaultReferences)) {
            data["fileVaultReferences"] = [];
            for (let item of this.fileVaultReferences)
                data["fileVaultReferences"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetAssetReferenceRecommendationsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.companyId = _data["companyId"];
            this.assetType = _data["assetType"];
            this.assetTemplateKey = _data["assetTemplateKey"];
            this.parentAssetInstanceKey = _data["parentAssetInstanceKey"];
            this.searchTerms = _data["searchTerms"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetReferenceRecommendationsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["companyId"] = this.companyId;
        data["assetType"] = this.assetType;
        data["assetTemplateKey"] = this.assetTemplateKey;
        data["parentAssetInstanceKey"] = this.parentAssetInstanceKey;
        data["searchTerms"] = this.searchTerms;
        return data;
    }
}
export class PublishAssetsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["publishedVersions"])) {
                this.publishedVersions = [];
                for (let item of _data["publishedVersions"])
                    this.publishedVersions.push(ArtifactVersion2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PublishAssetsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.publishedVersions)) {
            data["publishedVersions"] = [];
            for (let item of this.publishedVersions)
                data["publishedVersions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ArtifactVersion2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.id = _data["id"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactVersion2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["id"] = this.id;
        data["version"] = this.version;
        return data;
    }
}
export class PublishAssetsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.companyId = _data["companyId"];
            this.productCallerReferenceKey = _data["productCallerReferenceKey"];
            if (Array.isArray(_data["assetInstancesToPublish"])) {
                this.assetInstancesToPublish = [];
                for (let item of _data["assetInstancesToPublish"])
                    this.assetInstancesToPublish.push(AssetInstanceDetails.fromJS(item));
            }
            if (Array.isArray(_data["assetResourcesToPublish"])) {
                this.assetResourcesToPublish = [];
                for (let item of _data["assetResourcesToPublish"])
                    this.assetResourcesToPublish.push(FileVaultAssetResource.fromJS(item));
            }
            this.comment = _data["comment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PublishAssetsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["companyId"] = this.companyId;
        data["productCallerReferenceKey"] = this.productCallerReferenceKey;
        if (Array.isArray(this.assetInstancesToPublish)) {
            data["assetInstancesToPublish"] = [];
            for (let item of this.assetInstancesToPublish)
                data["assetInstancesToPublish"].push(item.toJSON());
        }
        if (Array.isArray(this.assetResourcesToPublish)) {
            data["assetResourcesToPublish"] = [];
            for (let item of this.assetResourcesToPublish)
                data["assetResourcesToPublish"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        return data;
    }
}
export class AssetInstanceDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.assetInstanceKey = _data["assetInstanceKey"];
            this.assetInstance = _data["assetInstance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInstanceDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetInstanceKey"] = this.assetInstanceKey;
        data["assetInstance"] = this.assetInstance;
        return data;
    }
}
export class FileVaultAssetResource {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.assetResourceKey = _data["assetResourceKey"];
            this.fileVaultCompanyId = _data["fileVaultCompanyId"];
            this.fileVaultReferenceId = _data["fileVaultReferenceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileVaultAssetResource();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetResourceKey"] = this.assetResourceKey;
        data["fileVaultCompanyId"] = this.fileVaultCompanyId;
        data["fileVaultReferenceId"] = this.fileVaultReferenceId;
        return data;
    }
}
export class GetMeshDetailsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["meshes"])) {
                this.meshes = [];
                for (let item of _data["meshes"])
                    this.meshes.push(MeshAssetMetaData.fromJS(item));
            }
            if (_data["materialsAssets"]) {
                this.materialsAssets = {};
                for (let key in _data["materialsAssets"]) {
                    if (_data["materialsAssets"].hasOwnProperty(key))
                        this.materialsAssets[key] = _data["materialsAssets"][key];
                }
            }
            if (Array.isArray(_data["slotAssets"])) {
                this.slotAssets = [];
                for (let item of _data["slotAssets"])
                    this.slotAssets.push(item);
            }
            this.hasEmbeddedTextures = _data["hasEmbeddedTextures"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeshDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.meshes)) {
            data["meshes"] = [];
            for (let item of this.meshes)
                data["meshes"].push(item.toJSON());
        }
        if (this.materialsAssets) {
            data["materialsAssets"] = {};
            for (let key in this.materialsAssets) {
                if (this.materialsAssets.hasOwnProperty(key))
                    data["materialsAssets"][key] = this.materialsAssets[key];
            }
        }
        if (Array.isArray(this.slotAssets)) {
            data["slotAssets"] = [];
            for (let item of this.slotAssets)
                data["slotAssets"].push(item);
        }
        data["hasEmbeddedTextures"] = this.hasEmbeddedTextures;
        super.toJSON(data);
        return data;
    }
}
export class MeshAssetMetaData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["subMeshes"])) {
                this.subMeshes = [];
                for (let item of _data["subMeshes"])
                    this.subMeshes.push(SubMeshAssetMetaData.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MeshAssetMetaData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.subMeshes)) {
            data["subMeshes"] = [];
            for (let item of this.subMeshes)
                data["subMeshes"].push(item.toJSON());
        }
        return data;
    }
}
export class SubMeshAssetMetaData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubMeshAssetMetaData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class GetMeshDetailsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.fileVaultReferenceId = _data["fileVaultReferenceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeshDetailsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["fileVaultReferenceId"] = this.fileVaultReferenceId;
        return data;
    }
}
export class GetAssetValidationResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (_data["assetValidation"]) {
                this.assetValidation = {};
                for (let key in _data["assetValidation"]) {
                    if (_data["assetValidation"].hasOwnProperty(key))
                        this.assetValidation[key] = _data["assetValidation"][key] ? AssetValidationRule.fromJS(_data["assetValidation"][key]) : new AssetValidationRule();
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetValidationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (this.assetValidation) {
            data["assetValidation"] = {};
            for (let key in this.assetValidation) {
                if (this.assetValidation.hasOwnProperty(key))
                    data["assetValidation"][key] = this.assetValidation[key] ? this.assetValidation[key].toJSON() : undefined;
            }
        }
        super.toJSON(data);
        return data;
    }
}
export class AssetValidationRule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"];
            this.valueUnit = _data["valueUnit"];
            this.result = _data["result"];
            this.reason = _data["reason"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetValidationRule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["valueUnit"] = this.valueUnit;
        data["result"] = this.result;
        data["reason"] = this.reason;
        return data;
    }
}
export var RuleResult;
(function (RuleResult) {
    RuleResult[RuleResult["None"] = 0] = "None";
    RuleResult[RuleResult["Success"] = 1] = "Success";
    RuleResult[RuleResult["Warning"] = 2] = "Warning";
    RuleResult[RuleResult["Failure"] = 3] = "Failure";
})(RuleResult || (RuleResult = {}));
export class GetAssetValidationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.fileVaultReferenceId = _data["fileVaultReferenceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetValidationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["fileVaultReferenceId"] = this.fileVaultReferenceId;
        return data;
    }
}
export class AddProductClassificationResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productClassification = _data["productClassification"] ? ProductClassification.fromJS(_data["productClassification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductClassificationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productClassification"] = this.productClassification ? this.productClassification.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ProductClassification {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductClassification();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class AddProductClassificationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productClassification = _data["productClassification"] ? ProductClassification.fromJS(_data["productClassification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductClassificationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productClassification"] = this.productClassification ? this.productClassification.toJSON() : undefined;
        return data;
    }
}
export class UpdateProductClassificationResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productClassification = _data["productClassification"] ? ProductClassification.fromJS(_data["productClassification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductClassificationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productClassification"] = this.productClassification ? this.productClassification.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductClassificationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productClassification = _data["productClassification"] ? ProductClassification.fromJS(_data["productClassification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductClassificationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productClassification"] = this.productClassification ? this.productClassification.toJSON() : undefined;
        return data;
    }
}
export class ListProductClassificationsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["productClassifications"])) {
                this.productClassifications = [];
                for (let item of _data["productClassifications"])
                    this.productClassifications.push(ProductClassification.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductClassificationsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productClassifications)) {
            data["productClassifications"] = [];
            for (let item of this.productClassifications)
                data["productClassifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListProductClassificationsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductClassificationsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class NewAddProductResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.product = _data["product"] ? Product2.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewAddProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class NewAddProductRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.product = _data["product"] ? Product2.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewAddProductRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        return data;
    }
}
export class NewUpdateProductResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.product = _data["product"] ? Product2.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewUpdateProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class NewUpdateProductRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.product = _data["product"] ? Product2.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewUpdateProductRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        return data;
    }
}
export class NewGetProductResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.product = _data["product"] ? Product2.fromJS(_data["product"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewGetProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class NewGetProductRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.includeProductSpecifications = _data["includeProductSpecifications"];
            this.includeCurrentState = _data["includeCurrentState"];
            this.includeBrand = _data["includeBrand"];
            this.includeProductRanges = _data["includeProductRanges"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewGetProductRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["includeProductSpecifications"] = this.includeProductSpecifications;
        data["includeCurrentState"] = this.includeCurrentState;
        data["includeBrand"] = this.includeBrand;
        data["includeProductRanges"] = this.includeProductRanges;
        return data;
    }
}
export class PagedResponseOfProduct2 extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Product2.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfProduct2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class NewListProductsResponse extends PagedResponseOfProduct2 {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewListProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class NewListProductsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.includeProductSpecifications = _data["includeProductSpecifications"];
            this.includeCurrentState = _data["includeCurrentState"];
            this.includeBrand = _data["includeBrand"];
            this.searchTerm = _data["searchTerm"];
            this.filterCompanyId = _data["filterCompanyId"];
            if (Array.isArray(_data["filterProductIds"])) {
                this.filterProductIds = [];
                for (let item of _data["filterProductIds"])
                    this.filterProductIds.push(item);
            }
            this.filterEnabled = _data["filterEnabled"];
            this.filterProductState = _data["filterProductState"];
            this.filterProductCategoryId = _data["filterProductCategoryId"];
            this.filterProductTypeId = _data["filterProductTypeId"];
            this.filterProductTypeTemplateName = _data["filterProductTypeTemplateName"];
            if (Array.isArray(_data["filterProductSpecificationsIds"])) {
                this.filterProductSpecificationsIds = [];
                for (let item of _data["filterProductSpecificationsIds"])
                    this.filterProductSpecificationsIds.push(item);
            }
            if (Array.isArray(_data["filterTagGroups"])) {
                this.filterTagGroups = [];
                for (let item of _data["filterTagGroups"])
                    this.filterTagGroups.push(item);
            }
            if (Array.isArray(_data["orderRelatedTags"])) {
                this.orderRelatedTags = [];
                for (let item of _data["orderRelatedTags"])
                    this.orderRelatedTags.push(item);
            }
            this.includeRanges = _data["includeRanges"];
            this.filterRangeId = _data["filterRangeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewListProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["includeProductSpecifications"] = this.includeProductSpecifications;
        data["includeCurrentState"] = this.includeCurrentState;
        data["includeBrand"] = this.includeBrand;
        data["searchTerm"] = this.searchTerm;
        data["filterCompanyId"] = this.filterCompanyId;
        if (Array.isArray(this.filterProductIds)) {
            data["filterProductIds"] = [];
            for (let item of this.filterProductIds)
                data["filterProductIds"].push(item);
        }
        data["filterEnabled"] = this.filterEnabled;
        data["filterProductState"] = this.filterProductState;
        data["filterProductCategoryId"] = this.filterProductCategoryId;
        data["filterProductTypeId"] = this.filterProductTypeId;
        data["filterProductTypeTemplateName"] = this.filterProductTypeTemplateName;
        if (Array.isArray(this.filterProductSpecificationsIds)) {
            data["filterProductSpecificationsIds"] = [];
            for (let item of this.filterProductSpecificationsIds)
                data["filterProductSpecificationsIds"].push(item);
        }
        if (Array.isArray(this.filterTagGroups)) {
            data["filterTagGroups"] = [];
            for (let item of this.filterTagGroups)
                data["filterTagGroups"].push(item);
        }
        if (Array.isArray(this.orderRelatedTags)) {
            data["orderRelatedTags"] = [];
            for (let item of this.orderRelatedTags)
                data["orderRelatedTags"].push(item);
        }
        data["includeRanges"] = this.includeRanges;
        data["filterRangeId"] = this.filterRangeId;
        super.toJSON(data);
        return data;
    }
}
export class TriggerProductWorkflowResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.currentWorkflowState = _data["currentWorkflowState"] ? ProductWorkflow.fromJS(_data["currentWorkflowState"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerProductWorkflowResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["currentWorkflowState"] = this.currentWorkflowState ? this.currentWorkflowState.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class TriggerProductWorkflowRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.productId = _data["productId"];
            this.workflowTrigger = _data["workflowTrigger"];
            this.comments = _data["comments"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerProductWorkflowRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["productId"] = this.productId;
        data["workflowTrigger"] = this.workflowTrigger;
        data["comments"] = this.comments;
        return data;
    }
}
export class GetProductWorkflowHistoryResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["workflowHistory"])) {
                this.workflowHistory = [];
                for (let item of _data["workflowHistory"])
                    this.workflowHistory.push(ProductWorkflowHistory.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductWorkflowHistoryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workflowHistory)) {
            data["workflowHistory"] = [];
            for (let item of this.workflowHistory)
                data["workflowHistory"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class WorkflowHistorySummaryOfProductWorkflowTriggerAndProductWorkflowStateAndWorkflowStateType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.previousStateId = _data["previousStateId"];
            this.trigger = _data["trigger"];
            this.triggerName = _data["triggerName"];
            this.triggerDescription = _data["triggerDescription"];
            this.state = _data["state"];
            this.stateName = _data["stateName"];
            this.stateDescription = _data["stateDescription"];
            this.stateType = _data["stateType"];
            this.comments = _data["comments"];
            this.stateChangedBy = _data["stateChangedBy"];
            this.stateChangedDate = _data["stateChangedDate"] ? new Date(_data["stateChangedDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowHistorySummaryOfProductWorkflowTriggerAndProductWorkflowStateAndWorkflowStateType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["previousStateId"] = this.previousStateId;
        data["trigger"] = this.trigger;
        data["triggerName"] = this.triggerName;
        data["triggerDescription"] = this.triggerDescription;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["stateDescription"] = this.stateDescription;
        data["stateType"] = this.stateType;
        data["comments"] = this.comments;
        data["stateChangedBy"] = this.stateChangedBy;
        data["stateChangedDate"] = this.stateChangedDate ? this.stateChangedDate.toISOString() : undefined;
        return data;
    }
}
export class ProductWorkflowHistory extends WorkflowHistorySummaryOfProductWorkflowTriggerAndProductWorkflowStateAndWorkflowStateType {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWorkflowHistory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class GetProductWorkflowHistoryRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.productId = _data["productId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductWorkflowHistoryRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["productId"] = this.productId;
        return data;
    }
}
export class GetProductThemesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themes"])) {
                this.themes = [];
                for (let item of _data["themes"])
                    this.themes.push(Theme.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductThemesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetProductThemesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.productId = _data["productId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductThemesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["productId"] = this.productId;
        return data;
    }
}
export class GetProductWorkflowConfigurationResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["workflowConfiguration"])) {
                this.workflowConfiguration = [];
                for (let item of _data["workflowConfiguration"])
                    this.workflowConfiguration.push(ProductWorkflow.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductWorkflowConfigurationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workflowConfiguration)) {
            data["workflowConfiguration"] = [];
            for (let item of this.workflowConfiguration)
                data["workflowConfiguration"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetProductWorkflowConfigurationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductWorkflowConfigurationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class ProductWorkflowStateReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(ProductWorkflowStateReportData.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWorkflowStateReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ProductWorkflowStateReportData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.y = _data["y"];
            this.x = _data["x"];
            this.count = _data["count"];
            if (Array.isArray(_data["dataPoints"])) {
                this.dataPoints = [];
                for (let item of _data["dataPoints"])
                    this.dataPoints.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWorkflowStateReportData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["y"] = this.y;
        data["x"] = this.x;
        data["count"] = this.count;
        if (Array.isArray(this.dataPoints)) {
            data["dataPoints"] = [];
            for (let item of this.dataPoints)
                data["dataPoints"].push(item);
        }
        return data;
    }
}
export class ProductWorkflowStateReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.xAxisType = _data["xAxisType"];
            this.yAxisType = _data["yAxisType"];
            this.releaseCompanyIdFilter = _data["releaseCompanyIdFilter"];
            this.releaseIdFilter = _data["releaseIdFilter"];
            this.themeIdFilter = _data["themeIdFilter"];
            this.includeDataPoints = _data["includeDataPoints"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWorkflowStateReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["xAxisType"] = this.xAxisType;
        data["yAxisType"] = this.yAxisType;
        data["releaseCompanyIdFilter"] = this.releaseCompanyIdFilter;
        data["releaseIdFilter"] = this.releaseIdFilter;
        data["themeIdFilter"] = this.themeIdFilter;
        data["includeDataPoints"] = this.includeDataPoints;
        return data;
    }
}
export var XAxisType;
(function (XAxisType) {
    XAxisType[XAxisType["Unset"] = 0] = "Unset";
    XAxisType[XAxisType["ReleaseCompanies"] = 1] = "ReleaseCompanies";
    XAxisType[XAxisType["Release"] = 2] = "Release";
    XAxisType[XAxisType["Theme"] = 3] = "Theme";
    XAxisType[XAxisType["Supplier"] = 4] = "Supplier";
})(XAxisType || (XAxisType = {}));
export var YAxisType;
(function (YAxisType) {
    YAxisType[YAxisType["Unset"] = 0] = "Unset";
    YAxisType[YAxisType["ProductStatus"] = 1] = "ProductStatus";
})(YAxisType || (YAxisType = {}));
export class AddProductSpecificationResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productSpecification = _data["productSpecification"] ? ProductSpecification.fromJS(_data["productSpecification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductSpecificationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productSpecification"] = this.productSpecification ? this.productSpecification.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ProductSpecification {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productTypeId = _data["productTypeId"];
            this.parentSpecificationId = _data["parentSpecificationId"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.selectable = _data["selectable"];
            this.suppressOutputToProductReplacementTag = _data["suppressOutputToProductReplacementTag"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSpecification();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productTypeId"] = this.productTypeId;
        data["parentSpecificationId"] = this.parentSpecificationId;
        data["name"] = this.name;
        data["order"] = this.order;
        data["selectable"] = this.selectable;
        data["suppressOutputToProductReplacementTag"] = this.suppressOutputToProductReplacementTag;
        return data;
    }
}
export class AddProductSpecificationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productSpecification = _data["productSpecification"] ? ProductSpecification.fromJS(_data["productSpecification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductSpecificationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productSpecification"] = this.productSpecification ? this.productSpecification.toJSON() : undefined;
        return data;
    }
}
export class UpdateProductSpecificationResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productSpecification = _data["productSpecification"] ? ProductSpecification.fromJS(_data["productSpecification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductSpecificationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productSpecification"] = this.productSpecification ? this.productSpecification.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductSpecificationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productSpecification = _data["productSpecification"] ? ProductSpecification.fromJS(_data["productSpecification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductSpecificationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productSpecification"] = this.productSpecification ? this.productSpecification.toJSON() : undefined;
        return data;
    }
}
export class ListProductSpecificationsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["productSpecifications"])) {
                this.productSpecifications = [];
                for (let item of _data["productSpecifications"])
                    this.productSpecifications.push(ProductSpecification.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductSpecificationsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productSpecifications)) {
            data["productSpecifications"] = [];
            for (let item of this.productSpecifications)
                data["productSpecifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListProductSpecificationsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["productTypeIdFilter"])) {
                this.productTypeIdFilter = [];
                for (let item of _data["productTypeIdFilter"])
                    this.productTypeIdFilter.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductSpecificationsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productTypeIdFilter)) {
            data["productTypeIdFilter"] = [];
            for (let item of this.productTypeIdFilter)
                data["productTypeIdFilter"].push(item);
        }
        return data;
    }
}
export class AddProductTypeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductTypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType ? this.productType.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ProductType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productClassificationId = _data["productClassificationId"];
            this.name = _data["name"];
            this.templateName = _data["templateName"];
            this.disabled = _data["disabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productClassificationId"] = this.productClassificationId;
        data["name"] = this.name;
        data["templateName"] = this.templateName;
        data["disabled"] = this.disabled;
        return data;
    }
}
export class AddProductTypeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductTypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType ? this.productType.toJSON() : undefined;
        return data;
    }
}
export class UpdateProductTypeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductTypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType ? this.productType.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductTypeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductTypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType ? this.productType.toJSON() : undefined;
        return data;
    }
}
export class UpdateProductTypeRelatedTagsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductTypeRelatedTagsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductTypeRelatedTagsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productTypeId = _data["productTypeId"];
            if (Array.isArray(_data["productTypeRelatedTags"])) {
                this.productTypeRelatedTags = [];
                for (let item of _data["productTypeRelatedTags"])
                    this.productTypeRelatedTags.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductTypeRelatedTagsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productTypeId"] = this.productTypeId;
        if (Array.isArray(this.productTypeRelatedTags)) {
            data["productTypeRelatedTags"] = [];
            for (let item of this.productTypeRelatedTags)
                data["productTypeRelatedTags"].push(item);
        }
        return data;
    }
}
export class GetProductTypeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductTypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType ? this.productType.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetProductTypeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productTypeName = _data["productTypeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductTypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productTypeName"] = this.productTypeName;
        return data;
    }
}
export class ListProductTypesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [];
                for (let item of _data["productTypes"])
                    this.productTypes.push(ProductType.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductTypesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListProductTypesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductTypesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class UpdateRequestedProductResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.requestedProduct = _data["requestedProduct"] ? RequestedProduct.fromJS(_data["requestedProduct"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestedProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestedProduct"] = this.requestedProduct ? this.requestedProduct.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class RequestedProduct {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.requestedName = _data["requestedName"];
            this.name = _data["name"];
            this.requestedProductCode = _data["requestedProductCode"];
            this.productCode = _data["productCode"];
            this.requestedProductTypeName = _data["requestedProductTypeName"];
            this.productTypeId = _data["productTypeId"];
            this.requestedSupplierName = _data["requestedSupplierName"];
            this.supplierId = _data["supplierId"];
            this.requestedProductUrl = _data["requestedProductUrl"];
            this.productUrl = _data["productUrl"];
            this.requestedDescription = _data["requestedDescription"];
            this.description = _data["description"];
            this.requestedBrand = _data["requestedBrand"];
            this.brandId = _data["brandId"];
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : undefined;
            this.requestedQualityLevel = _data["requestedQualityLevel"];
            this.qualityLevel = _data["qualityLevel"];
            this.notes = _data["notes"];
            this.modifiedBy = _data["modifiedBy"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined;
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : undefined;
            this.duplicateRequestedProductId = _data["duplicateRequestedProductId"];
            this.duplicateProductId = _data["duplicateProductId"];
            this.duplicateProduct = _data["duplicateProduct"] ? Product2.fromJS(_data["duplicateProduct"]) : undefined;
            this.currentWorkflowState = _data["currentWorkflowState"] ? ProductWorkflow.fromJS(_data["currentWorkflowState"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestedProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestedName"] = this.requestedName;
        data["name"] = this.name;
        data["requestedProductCode"] = this.requestedProductCode;
        data["productCode"] = this.productCode;
        data["requestedProductTypeName"] = this.requestedProductTypeName;
        data["productTypeId"] = this.productTypeId;
        data["requestedSupplierName"] = this.requestedSupplierName;
        data["supplierId"] = this.supplierId;
        data["requestedProductUrl"] = this.requestedProductUrl;
        data["productUrl"] = this.productUrl;
        data["requestedDescription"] = this.requestedDescription;
        data["description"] = this.description;
        data["requestedBrand"] = this.requestedBrand;
        data["brandId"] = this.brandId;
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        data["requestedQualityLevel"] = this.requestedQualityLevel;
        data["qualityLevel"] = this.qualityLevel;
        data["notes"] = this.notes;
        data["modifiedBy"] = this.modifiedBy;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined;
        data["productType"] = this.productType ? this.productType.toJSON() : undefined;
        data["duplicateRequestedProductId"] = this.duplicateRequestedProductId;
        data["duplicateProductId"] = this.duplicateProductId;
        data["duplicateProduct"] = this.duplicateProduct ? this.duplicateProduct.toJSON() : undefined;
        data["currentWorkflowState"] = this.currentWorkflowState ? this.currentWorkflowState.toJSON() : undefined;
        return data;
    }
}
export class UpdateRequestedProductRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestedProduct = _data["requestedProduct"] ? UpdateRequestedProduct.fromJS(_data["requestedProduct"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestedProductRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestedProduct"] = this.requestedProduct ? this.requestedProduct.toJSON() : undefined;
        return data;
    }
}
export class UpdateRequestedProduct {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productTypeId = _data["productTypeId"];
            this.supplierId = _data["supplierId"];
            this.brandId = _data["brandId"];
            this.qualityLevel = _data["qualityLevel"];
            this.name = _data["name"];
            this.productCode = _data["productCode"];
            this.productUrl = _data["productUrl"];
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.duplicateProductId = _data["duplicateProductId"];
            this.duplicateRequestedProductId = _data["duplicateRequestedProductId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestedProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productTypeId"] = this.productTypeId;
        data["supplierId"] = this.supplierId;
        data["brandId"] = this.brandId;
        data["qualityLevel"] = this.qualityLevel;
        data["name"] = this.name;
        data["productCode"] = this.productCode;
        data["productUrl"] = this.productUrl;
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["duplicateProductId"] = this.duplicateProductId;
        data["duplicateRequestedProductId"] = this.duplicateRequestedProductId;
        return data;
    }
}
export class UpdateRequestedProductsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["requestedProducts"])) {
                this.requestedProducts = [];
                for (let item of _data["requestedProducts"])
                    this.requestedProducts.push(RequestedProduct.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestedProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestedProducts)) {
            data["requestedProducts"] = [];
            for (let item of this.requestedProducts)
                data["requestedProducts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class UpdateRequestedProductsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["requestedProducts"])) {
                this.requestedProducts = [];
                for (let item of _data["requestedProducts"])
                    this.requestedProducts.push(UpdateRequestedProduct.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestedProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestedProducts)) {
            data["requestedProducts"] = [];
            for (let item of this.requestedProducts)
                data["requestedProducts"].push(item.toJSON());
        }
        return data;
    }
}
export class ImportRequestedProductsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["requestedProducts"])) {
                this.requestedProducts = [];
                for (let item of _data["requestedProducts"])
                    this.requestedProducts.push(RequestedProduct.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestedProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestedProducts)) {
            data["requestedProducts"] = [];
            for (let item of this.requestedProducts)
                data["requestedProducts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfRequestedProduct extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(RequestedProduct.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfRequestedProduct();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListRequestedProductsResponse extends PagedResponseOfRequestedProduct {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestedProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ListRequestedProductsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.importCompanyId = _data["importCompanyId"];
            this.includeCurrentState = _data["includeCurrentState"];
            this.includeBrand = _data["includeBrand"];
            this.searchTerm = _data["searchTerm"];
            this.filterCompanyId = _data["filterCompanyId"];
            this.filterRequestedProductState = _data["filterRequestedProductState"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestedProductsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["importCompanyId"] = this.importCompanyId;
        data["includeCurrentState"] = this.includeCurrentState;
        data["includeBrand"] = this.includeBrand;
        data["searchTerm"] = this.searchTerm;
        data["filterCompanyId"] = this.filterCompanyId;
        data["filterRequestedProductState"] = this.filterRequestedProductState;
        super.toJSON(data);
        return data;
    }
}
export class TriggerRequestedProductWorkflowResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.currentWorkflowState = _data["currentWorkflowState"] ? ProductWorkflow.fromJS(_data["currentWorkflowState"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRequestedProductWorkflowResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["currentWorkflowState"] = this.currentWorkflowState ? this.currentWorkflowState.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class TriggerRequestedProductWorkflowRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestedProductId = _data["requestedProductId"];
            this.workflowTrigger = _data["workflowTrigger"];
            this.comments = _data["comments"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRequestedProductWorkflowRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestedProductId"] = this.requestedProductId;
        data["workflowTrigger"] = this.workflowTrigger;
        data["comments"] = this.comments;
        return data;
    }
}
export class SituWorkflowResponseOfRequestedSupplier extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.itemIsAccessRestricted = _data["itemIsAccessRestricted"];
            this.item = _data["item"] ? RequestedSupplier.fromJS(_data["item"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituWorkflowResponseOfRequestedSupplier();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemIsAccessRestricted"] = this.itemIsAccessRestricted;
        data["item"] = this.item ? this.item.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class CreateRequestedSupplierResponse extends SituWorkflowResponseOfRequestedSupplier {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestedSupplierResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RequestedSupplier {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.accountingContact = _data["accountingContact"];
            this.productContact = _data["productContact"];
            this.createdSupplierId = _data["createdSupplierId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["workflowHistory"])) {
                this.workflowHistory = [];
                for (let item of _data["workflowHistory"])
                    this.workflowHistory.push(RequestedSupplierWorkflowHistory.fromJS(item));
            }
            this.workflow = _data["workflow"] ? RequestedSupplierWorkflow.fromJS(_data["workflow"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestedSupplier();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["accountingContact"] = this.accountingContact;
        data["productContact"] = this.productContact;
        data["createdSupplierId"] = this.createdSupplierId;
        data["comments"] = this.comments;
        if (Array.isArray(this.workflowHistory)) {
            data["workflowHistory"] = [];
            for (let item of this.workflowHistory)
                data["workflowHistory"].push(item.toJSON());
        }
        data["workflow"] = this.workflow ? this.workflow.toJSON() : undefined;
        return data;
    }
}
export class RequestedSupplierWorkflowHistory extends WorkflowHistorySummaryOfProductWorkflowTriggerAndProductWorkflowStateAndWorkflowStateType {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestedSupplierWorkflowHistory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RequestedSupplierWorkflow {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.state = _data["state"];
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [];
                for (let item of _data["transitions"])
                    this.transitions.push(ProductTransition.fromJS(item));
            }
            this.stateType = _data["stateType"];
            if (Array.isArray(_data["roleAccessRestrictions"])) {
                this.roleAccessRestrictions = [];
                for (let item of _data["roleAccessRestrictions"])
                    this.roleAccessRestrictions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RequestedSupplierWorkflow();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item.toJSON());
        }
        data["stateType"] = this.stateType;
        if (Array.isArray(this.roleAccessRestrictions)) {
            data["roleAccessRestrictions"] = [];
            for (let item of this.roleAccessRestrictions)
                data["roleAccessRestrictions"].push(item);
        }
        return data;
    }
}
export var RequestedSupplierWorkflowState;
(function (RequestedSupplierWorkflowState) {
    RequestedSupplierWorkflowState[RequestedSupplierWorkflowState["NewRequest"] = 0] = "NewRequest";
    RequestedSupplierWorkflowState[RequestedSupplierWorkflowState["SupplierIsNew"] = 1] = "SupplierIsNew";
    RequestedSupplierWorkflowState[RequestedSupplierWorkflowState["AwaitingAgreement"] = 2] = "AwaitingAgreement";
    RequestedSupplierWorkflowState[RequestedSupplierWorkflowState["GatheringContactDetails"] = 3] = "GatheringContactDetails";
    RequestedSupplierWorkflowState[RequestedSupplierWorkflowState["SupplierCreated"] = 4] = "SupplierCreated";
    RequestedSupplierWorkflowState[RequestedSupplierWorkflowState["SupplierAlreadyExists"] = 5] = "SupplierAlreadyExists";
    RequestedSupplierWorkflowState[RequestedSupplierWorkflowState["SupplierRefusedAgreement"] = 6] = "SupplierRefusedAgreement";
})(RequestedSupplierWorkflowState || (RequestedSupplierWorkflowState = {}));
export class CreateRequestedSupplierStateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestedSupplierStateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class ListRequestedSupplierStatesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["requestedSuppliers"])) {
                this.requestedSuppliers = [];
                for (let item of _data["requestedSuppliers"])
                    this.requestedSuppliers.push(RequestedSupplier.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestedSupplierStatesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestedSuppliers)) {
            data["requestedSuppliers"] = [];
            for (let item of this.requestedSuppliers)
                data["requestedSuppliers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListRequestedSupplierStatesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.state = _data["state"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestedSupplierStatesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        return data;
    }
}
export class GetRequestedSupplierCurrentWorkflowStateResponse extends SituWorkflowResponseOfRequestedSupplier {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestedSupplierCurrentWorkflowStateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class GetRequestedSupplierCurrentWorkflowRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestedSupplierId = _data["requestedSupplierId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestedSupplierCurrentWorkflowRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestedSupplierId"] = this.requestedSupplierId;
        return data;
    }
}
export class TriggerRequestedSupplierWorkflowResponse extends SituWorkflowResponseOfRequestedSupplier {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRequestedSupplierWorkflowResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class TriggerRequestedSupplierWorkflowRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.requestedSupplier = _data["requestedSupplier"] ? RequestedSupplier.fromJS(_data["requestedSupplier"]) : undefined;
            this.workflowTrigger = _data["workflowTrigger"];
            this.comments = _data["comments"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRequestedSupplierWorkflowRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requestedSupplier"] = this.requestedSupplier ? this.requestedSupplier.toJSON() : undefined;
        data["workflowTrigger"] = this.workflowTrigger;
        data["comments"] = this.comments;
        return data;
    }
}
export var RequestedSupplierWorkflowTrigger;
(function (RequestedSupplierWorkflowTrigger) {
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["ExistingSupplier"] = 0] = "ExistingSupplier";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["NewSupplier"] = 1] = "NewSupplier";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["Approve"] = 2] = "Approve";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["ContactDetailsGathered"] = 3] = "ContactDetailsGathered";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["SupplierAgreementCompleted"] = 4] = "SupplierAgreementCompleted";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["OverrideAgreementRequirement"] = 5] = "OverrideAgreementRequirement";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["FailureToReachAgreement"] = 6] = "FailureToReachAgreement";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["SupplierMisidentified"] = 7] = "SupplierMisidentified";
    RequestedSupplierWorkflowTrigger[RequestedSupplierWorkflowTrigger["SupplierAgreementReopened"] = 8] = "SupplierAgreementReopened";
})(RequestedSupplierWorkflowTrigger || (RequestedSupplierWorkflowTrigger = {}));
export class UpsertThemeLineItemsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themeLineItemResponses"])) {
                this.themeLineItemResponses = [];
                for (let item of _data["themeLineItemResponses"])
                    this.themeLineItemResponses.push(UpsertThemeLineItemResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertThemeLineItemsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themeLineItemResponses)) {
            data["themeLineItemResponses"] = [];
            for (let item of this.themeLineItemResponses)
                data["themeLineItemResponses"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class UpsertThemeLineItemResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.tag = _data["tag"];
            this.scope = _data["scope"];
            this.scopeVariant = _data["scopeVariant"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertThemeLineItemResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tag"] = this.tag;
        data["scope"] = this.scope;
        data["scopeVariant"] = this.scopeVariant;
        super.toJSON(data);
        return data;
    }
}
export var RoomType;
(function (RoomType) {
    RoomType[RoomType["NotSet"] = 0] = "NotSet";
    RoomType[RoomType["MasterBedroom"] = 1] = "MasterBedroom";
    RoomType[RoomType["Bedroom"] = 2] = "Bedroom";
    RoomType[RoomType["Family"] = 3] = "Family";
    RoomType[RoomType["Living"] = 4] = "Living";
    RoomType[RoomType["Rumpus"] = 5] = "Rumpus";
    RoomType[RoomType["Media"] = 6] = "Media";
    RoomType[RoomType["Meals"] = 7] = "Meals";
    RoomType[RoomType["MealsAndRumpus"] = 8] = "MealsAndRumpus";
    RoomType[RoomType["MealsAndLiving"] = 9] = "MealsAndLiving";
    RoomType[RoomType["MealsAndFamily"] = 10] = "MealsAndFamily";
    RoomType[RoomType["Garage"] = 11] = "Garage";
    RoomType[RoomType["Alfresco"] = 12] = "Alfresco";
    RoomType[RoomType["Study"] = 13] = "Study";
    RoomType[RoomType["Kids"] = 14] = "Kids";
    RoomType[RoomType["Robe"] = 15] = "Robe";
    RoomType[RoomType["Laundry"] = 16] = "Laundry";
    RoomType[RoomType["Entry"] = 17] = "Entry";
    RoomType[RoomType["Passage"] = 18] = "Passage";
    RoomType[RoomType["Kitchen"] = 19] = "Kitchen";
    RoomType[RoomType["Ensuite"] = 20] = "Ensuite";
    RoomType[RoomType["Linen"] = 21] = "Linen";
    RoomType[RoomType["Pantry"] = 22] = "Pantry";
    RoomType[RoomType["Porch"] = 23] = "Porch";
    RoomType[RoomType["Bath"] = 24] = "Bath";
    RoomType[RoomType["WC"] = 25] = "WC";
    RoomType[RoomType["Balcony"] = 26] = "Balcony";
    RoomType[RoomType["WalkInLinen"] = 27] = "WalkInLinen";
    RoomType[RoomType["Stairwell"] = 28] = "Stairwell";
    RoomType[RoomType["Landing"] = 29] = "Landing";
    RoomType[RoomType["Gym"] = 30] = "Gym";
    RoomType[RoomType["Storeroom"] = 31] = "Storeroom";
    RoomType[RoomType["Activity"] = 32] = "Activity";
    RoomType[RoomType["Mudroom"] = 33] = "Mudroom";
    RoomType[RoomType["OutdoorSpace"] = 34] = "OutdoorSpace";
    RoomType[RoomType["WalkInPantry"] = 35] = "WalkInPantry";
    RoomType[RoomType["Powder"] = 36] = "Powder";
    RoomType[RoomType["Nook"] = 37] = "Nook";
    RoomType[RoomType["Storage"] = 38] = "Storage";
    RoomType[RoomType["WalkInRobe"] = 39] = "WalkInRobe";
})(RoomType || (RoomType = {}));
export var ScopeVariant;
(function (ScopeVariant) {
    ScopeVariant[ScopeVariant["Default"] = 0] = "Default";
    ScopeVariant[ScopeVariant["Number1"] = 1] = "Number1";
    ScopeVariant[ScopeVariant["Number2"] = 2] = "Number2";
    ScopeVariant[ScopeVariant["Number3"] = 3] = "Number3";
    ScopeVariant[ScopeVariant["Number4"] = 4] = "Number4";
    ScopeVariant[ScopeVariant["Number5"] = 5] = "Number5";
    ScopeVariant[ScopeVariant["Number6"] = 6] = "Number6";
    ScopeVariant[ScopeVariant["Number7"] = 7] = "Number7";
    ScopeVariant[ScopeVariant["Number8"] = 8] = "Number8";
    ScopeVariant[ScopeVariant["Number9"] = 9] = "Number9";
    ScopeVariant[ScopeVariant["GroundFloor"] = 10] = "GroundFloor";
    ScopeVariant[ScopeVariant["FirstFloor"] = 11] = "FirstFloor";
})(ScopeVariant || (ScopeVariant = {}));
export class UpsertThemeLineItemsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.themeId = _data["themeId"];
            if (Array.isArray(_data["themeLineItems"])) {
                this.themeLineItems = [];
                for (let item of _data["themeLineItems"])
                    this.themeLineItems.push(ThemeLineItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertThemeLineItemsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["themeId"] = this.themeId;
        if (Array.isArray(this.themeLineItems)) {
            data["themeLineItems"] = [];
            for (let item of this.themeLineItems)
                data["themeLineItems"].push(item.toJSON());
        }
        return data;
    }
}
export class ThemeLineItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.lineItemTypeId = _data["lineItemTypeId"];
            this.tag = _data["tag"];
            this.scope = _data["scope"];
            this.scopeVariant = _data["scopeVariant"];
            if (_data["properties"]) {
                this.properties = {};
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties[key] = _data["properties"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLineItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineItemTypeId"] = this.lineItemTypeId;
        data["tag"] = this.tag;
        data["scope"] = this.scope;
        data["scopeVariant"] = this.scopeVariant;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data;
    }
}
export class ListThemeLineItemsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themeLineItems"])) {
                this.themeLineItems = [];
                for (let item of _data["themeLineItems"])
                    this.themeLineItems.push(ThemeLineItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemeLineItemsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themeLineItems)) {
            data["themeLineItems"] = [];
            for (let item of this.themeLineItems)
                data["themeLineItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListThemeLineItemsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.themeId = _data["themeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemeLineItemsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["themeId"] = this.themeId;
        return data;
    }
}
export class GetThemeLineItemTypeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.themeLineItemType = _data["themeLineItemType"] ? ThemeLineItemType.fromJS(_data["themeLineItemType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemeLineItemTypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["themeLineItemType"] = this.themeLineItemType ? this.themeLineItemType.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ThemeLineItemType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.templateName = _data["templateName"];
            this.themeReplacementTagGroup = _data["themeReplacementTagGroup"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [];
                for (let item of _data["properties"])
                    this.properties.push(AssetTemplateProperties.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLineItemType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["templateName"] = this.templateName;
        data["themeReplacementTagGroup"] = this.themeReplacementTagGroup;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }
}
export class GetThemeLineItemTypeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.themeLineItemTypeName = _data["themeLineItemTypeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemeLineItemTypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["themeLineItemTypeName"] = this.themeLineItemTypeName;
        return data;
    }
}
export class ListThemeLineItemTypesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themeLineItemTypes"])) {
                this.themeLineItemTypes = [];
                for (let item of _data["themeLineItemTypes"])
                    this.themeLineItemTypes.push(ThemeLineItemType.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemeLineItemTypesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themeLineItemTypes)) {
            data["themeLineItemTypes"] = [];
            for (let item of this.themeLineItemTypes)
                data["themeLineItemTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListThemeLineItemTypesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemeLineItemTypesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class AddThemeReplacementTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.themeReplacementTag = _data["themeReplacementTag"] ? ThemeReplacementTag.fromJS(_data["themeReplacementTag"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddThemeReplacementTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["themeReplacementTag"] = this.themeReplacementTag ? this.themeReplacementTag.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ThemeReplacementTag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.tag = _data["tag"];
            if (Array.isArray(_data["themeLineItemTypeIds"])) {
                this.themeLineItemTypeIds = [];
                for (let item of _data["themeLineItemTypeIds"])
                    this.themeLineItemTypeIds.push(item);
            }
            if (Array.isArray(_data["productTypeIds"])) {
                this.productTypeIds = [];
                for (let item of _data["productTypeIds"])
                    this.productTypeIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeReplacementTag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tag"] = this.tag;
        if (Array.isArray(this.themeLineItemTypeIds)) {
            data["themeLineItemTypeIds"] = [];
            for (let item of this.themeLineItemTypeIds)
                data["themeLineItemTypeIds"].push(item);
        }
        if (Array.isArray(this.productTypeIds)) {
            data["productTypeIds"] = [];
            for (let item of this.productTypeIds)
                data["productTypeIds"].push(item);
        }
        return data;
    }
}
export class AddThemeReplacementTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.themeReplacementTag = _data["themeReplacementTag"] ? ThemeReplacementTag.fromJS(_data["themeReplacementTag"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddThemeReplacementTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["themeReplacementTag"] = this.themeReplacementTag ? this.themeReplacementTag.toJSON() : undefined;
        return data;
    }
}
export class UpdateThemeReplacementTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.themeReplacementTag = _data["themeReplacementTag"] ? ThemeReplacementTag.fromJS(_data["themeReplacementTag"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateThemeReplacementTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["themeReplacementTag"] = this.themeReplacementTag ? this.themeReplacementTag.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateThemeReplacementTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.themeReplacementTag = _data["themeReplacementTag"] ? ThemeReplacementTag.fromJS(_data["themeReplacementTag"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateThemeReplacementTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["themeReplacementTag"] = this.themeReplacementTag ? this.themeReplacementTag.toJSON() : undefined;
        return data;
    }
}
export class SearchThemeReplacementTagsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themeReplacementTags"])) {
                this.themeReplacementTags = [];
                for (let item of _data["themeReplacementTags"])
                    this.themeReplacementTags.push(ScoredThemeReplacementTag.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchThemeReplacementTagsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themeReplacementTags)) {
            data["themeReplacementTags"] = [];
            for (let item of this.themeReplacementTags)
                data["themeReplacementTags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ScoredThemeReplacementTag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tag = _data["tag"];
            this.tagGroup = _data["tagGroup"];
            this.score = _data["score"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ScoredThemeReplacementTag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["tagGroup"] = this.tagGroup;
        data["score"] = this.score;
        return data;
    }
}
export class SearchThemeReplacementTagsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.orderThemeLineItemTypeId = _data["orderThemeLineItemTypeId"];
            if (Array.isArray(_data["orderProductTypeIds"])) {
                this.orderProductTypeIds = [];
                for (let item of _data["orderProductTypeIds"])
                    this.orderProductTypeIds.push(item);
            }
            if (Array.isArray(_data["orderProductSpecificationIds"])) {
                this.orderProductSpecificationIds = [];
                for (let item of _data["orderProductSpecificationIds"])
                    this.orderProductSpecificationIds.push(item);
            }
            this.useIfcTags = _data["useIfcTags"];
            this.ifcTagsOnly = _data["ifcTagsOnly"];
            this.standardTagsOnly = _data["standardTagsOnly"];
            if (Array.isArray(_data["tagGroupsFilter"])) {
                this.tagGroupsFilter = [];
                for (let item of _data["tagGroupsFilter"])
                    this.tagGroupsFilter.push(item);
            }
            if (Array.isArray(_data["productTypesFilter"])) {
                this.productTypesFilter = [];
                for (let item of _data["productTypesFilter"])
                    this.productTypesFilter.push(item);
            }
            this.filterByLatestIfcFiles = _data["filterByLatestIfcFiles"];
            this.filterByReleaseId = _data["filterByReleaseId"];
            this.filterByThemeId = _data["filterByThemeId"];
            this.filterActiveReleases = _data["filterActiveReleases"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchThemeReplacementTagsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["orderThemeLineItemTypeId"] = this.orderThemeLineItemTypeId;
        if (Array.isArray(this.orderProductTypeIds)) {
            data["orderProductTypeIds"] = [];
            for (let item of this.orderProductTypeIds)
                data["orderProductTypeIds"].push(item);
        }
        if (Array.isArray(this.orderProductSpecificationIds)) {
            data["orderProductSpecificationIds"] = [];
            for (let item of this.orderProductSpecificationIds)
                data["orderProductSpecificationIds"].push(item);
        }
        data["useIfcTags"] = this.useIfcTags;
        data["ifcTagsOnly"] = this.ifcTagsOnly;
        data["standardTagsOnly"] = this.standardTagsOnly;
        if (Array.isArray(this.tagGroupsFilter)) {
            data["tagGroupsFilter"] = [];
            for (let item of this.tagGroupsFilter)
                data["tagGroupsFilter"].push(item);
        }
        if (Array.isArray(this.productTypesFilter)) {
            data["productTypesFilter"] = [];
            for (let item of this.productTypesFilter)
                data["productTypesFilter"].push(item);
        }
        data["filterByLatestIfcFiles"] = this.filterByLatestIfcFiles;
        data["filterByReleaseId"] = this.filterByReleaseId;
        data["filterByThemeId"] = this.filterByThemeId;
        data["filterActiveReleases"] = this.filterActiveReleases;
        return data;
    }
}
export class ListThemeReplacementTagsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themeReplacementTags"])) {
                this.themeReplacementTags = [];
                for (let item of _data["themeReplacementTags"])
                    this.themeReplacementTags.push(ThemeReplacementTag.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemeReplacementTagsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themeReplacementTags)) {
            data["themeReplacementTags"] = [];
            for (let item of this.themeReplacementTags)
                data["themeReplacementTags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListThemeReplacementTagsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["themeReplacementTagIds"])) {
                this.themeReplacementTagIds = [];
                for (let item of _data["themeReplacementTagIds"])
                    this.themeReplacementTagIds.push(item);
            }
            this.tagGroupFilter = _data["tagGroupFilter"];
            this.includeProductTypes = _data["includeProductTypes"];
            this.includeThemeLineItemTypes = _data["includeThemeLineItemTypes"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemeReplacementTagsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themeReplacementTagIds)) {
            data["themeReplacementTagIds"] = [];
            for (let item of this.themeReplacementTagIds)
                data["themeReplacementTagIds"].push(item);
        }
        data["tagGroupFilter"] = this.tagGroupFilter;
        data["includeProductTypes"] = this.includeProductTypes;
        data["includeThemeLineItemTypes"] = this.includeThemeLineItemTypes;
        return data;
    }
}
export class AddThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.theme = _data["theme"] ? Theme.fromJS(_data["theme"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class AddThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.theme = _data["theme"] ? Theme.fromJS(_data["theme"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        return data;
    }
}
export class UpdateThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.theme = _data["theme"] ? Theme.fromJS(_data["theme"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.theme = _data["theme"] ? Theme.fromJS(_data["theme"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        return data;
    }
}
export class CopyThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.theme = _data["theme"] ? Theme.fromJS(_data["theme"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CopyThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class CopyThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sourceCompanyId = _data["sourceCompanyId"];
            this.sourceThemeName = _data["sourceThemeName"];
            this.destinationCompanyId = _data["destinationCompanyId"];
            this.destinationThemeName = _data["destinationThemeName"];
            this.allowOverwritingExistingTheme = _data["allowOverwritingExistingTheme"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CopyThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCompanyId"] = this.sourceCompanyId;
        data["sourceThemeName"] = this.sourceThemeName;
        data["destinationCompanyId"] = this.destinationCompanyId;
        data["destinationThemeName"] = this.destinationThemeName;
        data["allowOverwritingExistingTheme"] = this.allowOverwritingExistingTheme;
        return data;
    }
}
export class GetThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.theme = _data["theme"] ? Theme.fromJS(_data["theme"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.themeId = _data["themeId"];
            this.calculateThemeCompletion = _data["calculateThemeCompletion"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["themeId"] = this.themeId;
        data["calculateThemeCompletion"] = this.calculateThemeCompletion;
        return data;
    }
}
export class PublishThemeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.assetModuleId = _data["assetModuleId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PublishThemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetModuleId"] = this.assetModuleId;
        super.toJSON(data);
        return data;
    }
}
export class PublishThemeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.themeName = _data["themeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PublishThemeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["themeName"] = this.themeName;
        return data;
    }
}
export class GetThemeConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.themeConfig = _data["themeConfig"] ? ThemeConfig.fromJS(_data["themeConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemeConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["themeConfig"] = this.themeConfig ? this.themeConfig.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class ThemeConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [];
                for (let item of _data["lineItems"])
                    this.lineItems.push(ThemeLineItem.fromJS(item));
            }
            if (Array.isArray(_data["lineItemsTypes"])) {
                this.lineItemsTypes = [];
                for (let item of _data["lineItemsTypes"])
                    this.lineItemsTypes.push(ThemeLineItemType.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [];
                for (let item of _data["products"])
                    this.products.push(Product2.fromJS(item));
            }
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [];
                for (let item of _data["productTypes"])
                    this.productTypes.push(ProductType.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        if (Array.isArray(this.lineItemsTypes)) {
            data["lineItemsTypes"] = [];
            for (let item of this.lineItemsTypes)
                data["lineItemsTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item.toJSON());
        }
        return data;
    }
}
export class GetThemeConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.themeName = _data["themeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemeConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["themeName"] = this.themeName;
        return data;
    }
}
export class ListThemesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["themes"])) {
                this.themes = [];
                for (let item of _data["themes"])
                    this.themes.push(Theme.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListThemesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["filterThemeIds"])) {
                this.filterThemeIds = [];
                for (let item of _data["filterThemeIds"])
                    this.filterThemeIds.push(item);
            }
            this.enabled = _data["enabled"];
            this.calculateThemeCompletion = _data["calculateThemeCompletion"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListThemesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.filterThemeIds)) {
            data["filterThemeIds"] = [];
            for (let item of this.filterThemeIds)
                data["filterThemeIds"].push(item);
        }
        data["enabled"] = this.enabled;
        data["calculateThemeCompletion"] = this.calculateThemeCompletion;
        return data;
    }
}
export class AddAcceptanceResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.termsAndConditionsAcceptanceId = _data["termsAndConditionsAcceptanceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddAcceptanceResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["termsAndConditionsAcceptanceId"] = this.termsAndConditionsAcceptanceId;
        super.toJSON(data);
        return data;
    }
}
export class AddAcceptanceRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.resourceId = _data["resourceId"];
            this.termsAndCondtionsId = _data["termsAndCondtionsId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddAcceptanceRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["resourceId"] = this.resourceId;
        data["termsAndCondtionsId"] = this.termsAndCondtionsId;
        return data;
    }
}
export class AddHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.processedFileCount = _data["processedFileCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["processedFileCount"] = this.processedFileCount;
        super.toJSON(data);
        return data;
    }
}
export class IfcFileModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.ifcType = _data["ifcType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IfcFileModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["ifcType"] = this.ifcType;
        return data;
    }
}
export var IfcType;
(function (IfcType) {
    IfcType[IfcType["Master"] = 0] = "Master";
    IfcType[IfcType["Option"] = 1] = "Option";
})(IfcType || (IfcType = {}));
export class AddStyleCategoryResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.styleCategoryId = _data["styleCategoryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddStyleCategoryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleCategoryId"] = this.styleCategoryId;
        super.toJSON(data);
        return data;
    }
}
export class AddStyleCategoryRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isSingleSelect = _data["isSingleSelect"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddStyleCategoryRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isSingleSelect"] = this.isSingleSelect;
        return data;
    }
}
export class AddStyleTemplateResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.styleTemplateId = _data["styleTemplateId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddStyleTemplateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleTemplateId"] = this.styleTemplateId;
        super.toJSON(data);
        return data;
    }
}
export class AddStyleTemplateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.tagId = _data["tagId"];
            this.name = _data["name"];
            if (Array.isArray(_data["styles"])) {
                this.styles = [];
                for (let item of _data["styles"])
                    this.styles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddStyleTemplateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["tagId"] = this.tagId;
        data["name"] = this.name;
        if (Array.isArray(this.styles)) {
            data["styles"] = [];
            for (let item of this.styles)
                data["styles"].push(item);
        }
        return data;
    }
}
export class ClearIfcFileUploadErrorResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClearIfcFileUploadErrorResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ClearIfcFileUploadErrorRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.builder = _data["builder"];
            this.homeName = _data["homeName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClearIfcFileUploadErrorRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["builder"] = this.builder;
        data["homeName"] = this.homeName;
        return data;
    }
}
export class CreateSituViewChildRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.renderedOutputId = _data["renderedOutputId"];
            this.productName = _data["productName"];
            this.queueName = _data["queueName"];
            this.environmentOverride = _data["environmentOverride"] ? ArtifactEnvironment.fromJS(_data["environmentOverride"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituViewChildRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["renderedOutputId"] = this.renderedOutputId;
        data["productName"] = this.productName;
        data["queueName"] = this.queueName;
        data["environmentOverride"] = this.environmentOverride ? this.environmentOverride.toJSON() : undefined;
        return data;
    }
}
export class CreateSituViewRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeConfigId = _data["homeConfigId"];
            this.styleConfigTemplateId = _data["styleConfigTemplateId"];
            this.productName = _data["productName"];
            this.queueName = _data["queueName"];
            this.accessoryBundleId = _data["accessoryBundleId"];
            this.environmentOverride = _data["environmentOverride"] ? ArtifactEnvironment.fromJS(_data["environmentOverride"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituViewRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeConfigId"] = this.homeConfigId;
        data["styleConfigTemplateId"] = this.styleConfigTemplateId;
        data["productName"] = this.productName;
        data["queueName"] = this.queueName;
        data["accessoryBundleId"] = this.accessoryBundleId;
        data["environmentOverride"] = this.environmentOverride ? this.environmentOverride.toJSON() : undefined;
        return data;
    }
}
export class CreateSituViewWithNamesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.artifactId = _data["artifactId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfigSlim.fromJS(_data["homeConfig"]) : undefined;
            this.styleConfigName = _data["styleConfigName"];
            this.productName = _data["productName"];
            this.queueName = _data["queueName"];
            this.environmentOverride = _data["environmentOverride"] ? ArtifactEnvironment.fromJS(_data["environmentOverride"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituViewWithNamesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["artifactId"] = this.artifactId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["styleConfigName"] = this.styleConfigName;
        data["productName"] = this.productName;
        data["queueName"] = this.queueName;
        data["environmentOverride"] = this.environmentOverride ? this.environmentOverride.toJSON() : undefined;
        return data;
    }
}
export class CreateTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class CreateTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.resourceType = _data["resourceType"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resourceType"] = this.resourceType;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class DeleteTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class GetSanitizedFileResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSanitizedFileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}
export class GetSanitizedFileRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.retainTagDetails = _data["retainTagDetails"];
            this.retainHiddenProducts = _data["retainHiddenProducts"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSanitizedFileRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["retainTagDetails"] = this.retainTagDetails;
        data["retainHiddenProducts"] = this.retainHiddenProducts;
        return data;
    }
}
export class ImportProductsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProductsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class LogPanoramaViewResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LogPanoramaViewResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class LogPanoramaViewRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            this.themes = _data["themes"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(item);
            }
            this.room = _data["room"];
            this.width = _data["width"];
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LogPanoramaViewRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        data["themes"] = this.themes;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["room"] = this.room;
        data["width"] = this.width;
        data["artifactId"] = this.artifactId;
        return data;
    }
}
export class SaveStyleCategoryResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleCategoryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SaveStyleCategoryRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.styleCategoryId = _data["styleCategoryId"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.parentStyleCategoryId = _data["parentStyleCategoryId"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isSingleSelect = _data["isSingleSelect"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleCategoryRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleCategoryId"] = this.styleCategoryId;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["parentStyleCategoryId"] = this.parentStyleCategoryId;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isSingleSelect"] = this.isSingleSelect;
        return data;
    }
}
export class SaveStyleConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.styleConfigId = _data["styleConfigId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleConfigId"] = this.styleConfigId;
        super.toJSON(data);
        return data;
    }
}
export class SaveStyleConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.styleTemplateId = _data["styleTemplateId"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["styleIds"])) {
                this.styleIds = [];
                for (let item of _data["styleIds"])
                    this.styleIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleTemplateId"] = this.styleTemplateId;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.styleIds)) {
            data["styleIds"] = [];
            for (let item of this.styleIds)
                data["styleIds"].push(item);
        }
        return data;
    }
}
export class SaveStyleTemplateResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleTemplateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SaveStyleTemplateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.styleTemplateId = _data["styleTemplateId"];
            this.isHidden = _data["isHidden"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["styles"])) {
                this.styles = [];
                for (let item of _data["styles"])
                    this.styles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStyleTemplateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleTemplateId"] = this.styleTemplateId;
        data["isHidden"] = this.isHidden;
        data["productName"] = this.productName;
        if (Array.isArray(this.styles)) {
            data["styles"] = [];
            for (let item of this.styles)
                data["styles"].push(item);
        }
        return data;
    }
}
export class SetArtifactActiveResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactActiveResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetArtifactActiveRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.active = _data["active"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactActiveRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["active"] = this.active;
        return data;
    }
}
export class SetCompanyTeamsIntegrationResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyTeamsIntegrationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetCompanyTeamsIntegrationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.webhook = _data["webhook"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetCompanyTeamsIntegrationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["webhook"] = this.webhook;
        return data;
    }
}
export var TeamsIntegrationType;
(function (TeamsIntegrationType) {
    TeamsIntegrationType[TeamsIntegrationType["Baseline"] = 1] = "Baseline";
    TeamsIntegrationType[TeamsIntegrationType["Ifc"] = 2] = "Ifc";
    TeamsIntegrationType[TeamsIntegrationType["Release"] = 3] = "Release";
})(TeamsIntegrationType || (TeamsIntegrationType = {}));
export class SetDefaultRenderedOutputResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultRenderedOutputResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetDefaultRenderedOutputRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.isUserRequest = _data["isUserRequest"];
            this.productName = _data["productName"];
            this.renderedOutputId = _data["renderedOutputId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultRenderedOutputRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["isUserRequest"] = this.isUserRequest;
        data["productName"] = this.productName;
        data["renderedOutputId"] = this.renderedOutputId;
        return data;
    }
}
export class SetRenderedOutputProductionResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetRenderedOutputProductionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetRenderedOutputProductionRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.renderedOutputId = _data["renderedOutputId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetRenderedOutputProductionRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["renderedOutputId"] = this.renderedOutputId;
        return data;
    }
}
export class SetRenderedOutputStatusResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetRenderedOutputStatusResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetRenderedOutputStatusRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.renderedOutputId = _data["renderedOutputId"];
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetRenderedOutputStatusRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["renderedOutputId"] = this.renderedOutputId;
        data["status"] = this.status;
        return data;
    }
}
export class UpdateCategoryStylesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryStylesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateCategoryStylesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.styleCategoryId = _data["styleCategoryId"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["styleIds"])) {
                this.styleIds = [];
                for (let item of _data["styleIds"])
                    this.styleIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryStylesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleCategoryId"] = this.styleCategoryId;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.styleIds)) {
            data["styleIds"] = [];
            for (let item of this.styleIds)
                data["styleIds"].push(item);
        }
        return data;
    }
}
export class UpdateHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateHomeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeId = _data["homeId"];
            this.isHidden = _data["isHidden"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHomeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeId"] = this.homeId;
        data["isHidden"] = this.isHidden;
        return data;
    }
}
export class UpdateHomeIfcFileResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeIfcFile = _data["homeIfcFile"] ? HomeIfcFile.fromJS(_data["homeIfcFile"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHomeIfcFileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeIfcFile"] = this.homeIfcFile ? this.homeIfcFile.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class UpdateHomeIfcFileRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.isAccessory = _data["isAccessory"];
            this.isHidden = _data["isHidden"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHomeIfcFileRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["isAccessory"] = this.isAccessory;
        data["isHidden"] = this.isHidden;
        return data;
    }
}
export class UpdateProductMatchResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductMatchResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateProductMatchRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"];
            this.companyId = _data["companyId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductMatchRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["companyId"] = this.companyId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        return data;
    }
}
export class UpdateTagResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.borderColour = _data["borderColour"];
            this.backgroundColour = _data["backgroundColour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["borderColour"] = this.borderColour;
        data["backgroundColour"] = this.backgroundColour;
        return data;
    }
}
export class UploadFilesForHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.processedFileCount = _data["processedFileCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFilesForHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["processedFileCount"] = this.processedFileCount;
        super.toJSON(data);
        return data;
    }
}
export class UploadStyleThumbnailResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.thumbnailUrl = _data["thumbnailUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStyleThumbnailResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["thumbnailUrl"] = this.thumbnailUrl;
        super.toJSON(data);
        return data;
    }
}
export class UploadStyleThumbnailRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.thumbnailType = _data["thumbnailType"];
            this.thumbnail = _data["thumbnail"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStyleThumbnailRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["thumbnailType"] = this.thumbnailType;
        data["thumbnail"] = this.thumbnail;
        return data;
    }
}
export var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType[ThumbnailType["Style"] = 0] = "Style";
    ThumbnailType[ThumbnailType["StyleTemplate"] = 1] = "StyleTemplate";
})(ThumbnailType || (ThumbnailType = {}));
export class FacadeData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["position"])) {
                this.position = [];
                for (let item of _data["position"])
                    this.position.push(item);
            }
            if (Array.isArray(_data["lookat"])) {
                this.lookat = [];
                for (let item of _data["lookat"])
                    this.lookat.push(item);
            }
            if (Array.isArray(_data["orientation"])) {
                this.orientation = [];
                for (let item of _data["orientation"])
                    this.orientation.push(item);
            }
            this.shiftX = _data["shiftX"];
            this.shiftY = _data["shiftY"];
            this.fov = _data["fov"];
            if (Array.isArray(_data["resolution"])) {
                this.resolution = [];
                for (let item of _data["resolution"])
                    this.resolution.push(item);
            }
            this.samples = _data["samples"];
            if (Array.isArray(_data["hotspots"])) {
                this.hotspots = [];
                for (let item of _data["hotspots"])
                    this.hotspots.push(FacadeHotspot.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FacadeData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.position)) {
            data["position"] = [];
            for (let item of this.position)
                data["position"].push(item);
        }
        if (Array.isArray(this.lookat)) {
            data["lookat"] = [];
            for (let item of this.lookat)
                data["lookat"].push(item);
        }
        if (Array.isArray(this.orientation)) {
            data["orientation"] = [];
            for (let item of this.orientation)
                data["orientation"].push(item);
        }
        data["shiftX"] = this.shiftX;
        data["shiftY"] = this.shiftY;
        data["fov"] = this.fov;
        if (Array.isArray(this.resolution)) {
            data["resolution"] = [];
            for (let item of this.resolution)
                data["resolution"].push(item);
        }
        data["samples"] = this.samples;
        if (Array.isArray(this.hotspots)) {
            data["hotspots"] = [];
            for (let item of this.hotspots)
                data["hotspots"].push(item.toJSON());
        }
        return data;
    }
}
export class FacadeHotspot {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.featureID = _data["featureID"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.distance = _data["distance"];
            this.visibilityScore = _data["visibilityScore"];
            this.name = _data["name"];
            if (Array.isArray(_data["productDetails"])) {
                this.productDetails = [];
                for (let item of _data["productDetails"])
                    this.productDetails.push(ProductDetail.fromJS(item));
            }
            if (Array.isArray(_data["tagDetails"])) {
                this.tagDetails = [];
                for (let item of _data["tagDetails"])
                    this.tagDetails.push(TagDetail.fromJS(item));
            }
            this.roomUniqueSafeName = _data["roomUniqueSafeName"];
            this.productID = _data["productID"];
            this.manufacturer = _data["manufacturer"];
            this.sku = _data["sku"];
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FacadeHotspot();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["featureID"] = this.featureID;
        data["x"] = this.x;
        data["y"] = this.y;
        data["distance"] = this.distance;
        data["visibilityScore"] = this.visibilityScore;
        data["name"] = this.name;
        if (Array.isArray(this.productDetails)) {
            data["productDetails"] = [];
            for (let item of this.productDetails)
                data["productDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.tagDetails)) {
            data["tagDetails"] = [];
            for (let item of this.tagDetails)
                data["tagDetails"].push(item.toJSON());
        }
        data["roomUniqueSafeName"] = this.roomUniqueSafeName;
        data["productID"] = this.productID;
        data["manufacturer"] = this.manufacturer;
        data["sku"] = this.sku;
        data["type"] = this.type;
        return data;
    }
}
export class TagDetail {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tag = _data["tag"];
            this.scope = _data["scope"];
            this.scopeVariant = _data["scopeVariant"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TagDetail();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["scope"] = this.scope;
        data["scopeVariant"] = this.scopeVariant;
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
